import { jsx as t, jsxs as h, Fragment as Q } from "react/jsx-runtime";
import "@fontsource/merriweather/300.css";
import "@fontsource/merriweather/400.css";
import "@fontsource/merriweather/700.css";
import "@fontsource/open-sans/300.css";
import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/500.css";
import "@fontsource/open-sans/700.css";
import "@fontsource/open-sans/800.css";
import { ChakraProvider as Er, defineStyle as N, defineStyleConfig as te, createMultiStyleConfigHelpers as B, cssVar as Rt, useStyleConfig as Ht, chakra as ge, Badge as Do, Card as Fr, CardHeader as jr, CardBody as Or, Button as Wr, IconButton as Gr, ButtonGroup as Ur, useMultiStyleConfig as D, Box as I, FormControl as Vr, FormLabel as Yr, FormHelperText as Zr, FormErrorMessage as Qr, Switch as Kr, Skeleton as Xr, useTheme as qr, Popover as ve, PopoverTrigger as Be, PopoverContent as Ce, PopoverBody as Se, Stack as Et, Flex as T, Td as Jr, Tr as ea, Center as Ze, VStack as O, Th as ta, TableContainer as oa, keyframes as ra, usePrefersReducedMotion as aa, InputGroup as na, InputLeftElement as _o, InputLeftAddon as ia, Divider as De, Input as la, InputRightElement as Ft, InputRightAddon as sa, Select as ca, Tbody as da, Thead as ua, useBreakpointValue as ae, Checkbox as ot, Table as ga, TableCaption as pa, HStack as ue, Tag as ma, TagLabel as ba, Accordion as ha, AccordionItem as fa, AccordionButton as ya, AccordionPanel as xa, Tabs as va, TabList as Ca, Tab as Sa, TabPanels as wa, TabPanel as ka, useAlertStyles as Ia, Alert as $a, AlertTitle as Ma, AlertDescription as Na, CloseButton as za, Spinner as Da, Progress as _a, useToast as Aa, PopoverAnchor as La, Icon as rt, NumberInput as Ta, NumberInputField as Ba, NumberInputStepper as Pa, NumberDecrementStepper as Ra, NumberIncrementStepper as Ha, Radio as Ea, Slider as Fa, SliderTrack as ja, SliderFilledTrack as Oa, SliderThumb as Wa, Textarea as Ga, Avatar as Ua, BreadcrumbItem as Va, BreadcrumbLink as Ao, Menu as Ya, MenuItem as Za, MenuGroup as Qa, MenuDivider as Ka, MenuList as Xa, MenuButton as qa, Breadcrumb as Ja, Link as we, Tooltip as en, PopoverHeader as Mt, useDimensions as tn, useDisclosure as We, AlertDialog as on, AlertDialogOverlay as rn, AlertDialogContent as an, AlertDialogHeader as nn, AlertDialogCloseButton as ln, AlertDialogBody as sn, AlertDialogFooter as cn, Modal as dn, ModalOverlay as un, ModalContent as gn, ModalHeader as pn, ModalCloseButton as mn, ModalBody as bn, ModalFooter as hn, PopoverArrow as fn, PopoverCloseButton as yn, PopoverFooter as xn, useOutsideClick as Lo, StackDivider as vn, Collapse as Cn } from "@chakra-ui/react";
import { accordionAnatomy as Sn, tableAnatomy as wn, tagAnatomy as kn, tabsAnatomy as In, alertAnatomy as $n, progressAnatomy as Mn, checkboxAnatomy as Nn, formAnatomy as zn, formErrorAnatomy as Dn, inputAnatomy as _n, numberInputAnatomy as An, radioAnatomy as Ln, selectAnatomy as Tn, sliderAnatomy as Bn, switchAnatomy as Pn, avatarAnatomy as Rn, breadcrumbAnatomy as Hn, menuAnatomy as En, modalAnatomy as Fn, popoverAnatomy as jn } from "@chakra-ui/anatomy";
import { defineStyle as ne, defineStyleConfig as On, createMultiStyleConfigHelpers as To, cssVar as jt } from "@chakra-ui/styled-system";
import { cssVar as se, getColor as so, orient as Ot, calc as Bo } from "@chakra-ui/theme-tools";
import { mergeWith as Wn } from "@chakra-ui/utils";
import co, { forwardRef as A, useMemo as E, useRef as le, useState as V, useEffect as oe, useId as Wt, Fragment as Gn, cloneElement as re, createContext as ke, useContext as pe, useCallback as Z } from "react";
import { FontAwesomeIcon as at } from "@fortawesome/react-fontawesome";
import { faArrowDown as Un } from "@fortawesome/pro-solid-svg-icons/faArrowDown";
import { faArrowLeft as Vn } from "@fortawesome/pro-solid-svg-icons/faArrowLeft";
import { faArrowLeftLongToLine as Yn } from "@fortawesome/pro-solid-svg-icons/faArrowLeftLongToLine";
import { faArrowRight as Zn } from "@fortawesome/pro-solid-svg-icons/faArrowRight";
import { faArrowRightFromBracket as Qn } from "@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket";
import { faArrowRightLongToLine as Kn } from "@fortawesome/pro-solid-svg-icons/faArrowRightLongToLine";
import { faArrowUp as Xn } from "@fortawesome/pro-solid-svg-icons/faArrowUp";
import { faArrowUpFromBracket as qn } from "@fortawesome/pro-solid-svg-icons/faArrowUpFromBracket";
import { faArrowUpRightFromSquare as Jn } from "@fortawesome/pro-solid-svg-icons/faArrowUpRightFromSquare";
import { faAtom as ei } from "@fortawesome/pro-solid-svg-icons/faAtom";
import { faBars as ti } from "@fortawesome/pro-solid-svg-icons/faBars";
import { faBell as oi } from "@fortawesome/pro-solid-svg-icons/faBell";
import { faCalendar as ri } from "@fortawesome/pro-solid-svg-icons/faCalendar";
import { faCartShopping as ai } from "@fortawesome/pro-solid-svg-icons/faCartShopping";
import { faCheck as Po } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { faChevronDown as ni } from "@fortawesome/pro-solid-svg-icons/faChevronDown";
import { faChevronLeft as ii } from "@fortawesome/pro-solid-svg-icons/faChevronLeft";
import { faChevronRight as li } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { faChevronUp as si } from "@fortawesome/pro-solid-svg-icons/faChevronUp";
import { faCircle as ci } from "@fortawesome/pro-solid-svg-icons/faCircle";
import { faCircleCheck as di } from "@fortawesome/pro-solid-svg-icons/faCircleCheck";
import { faCircleDot as ui } from "@fortawesome/pro-solid-svg-icons/faCircleDot";
import { faCircleExclamation as gi } from "@fortawesome/pro-solid-svg-icons/faCircleExclamation";
import { faCircleInfo as pi } from "@fortawesome/pro-solid-svg-icons/faCircleInfo";
import { faCircleXmark as mi } from "@fortawesome/pro-solid-svg-icons/faCircleXmark";
import { faCloudArrowUp as bi } from "@fortawesome/pro-solid-svg-icons/faCloudArrowUp";
import { faComment as hi } from "@fortawesome/pro-solid-svg-icons/faComment";
import { faCreditCard as fi } from "@fortawesome/pro-solid-svg-icons/faCreditCard";
import { faCreditCardFront as yi } from "@fortawesome/pro-solid-svg-icons/faCreditCardFront";
import { faDollarSign as xi } from "@fortawesome/pro-solid-svg-icons/faDollarSign";
import { faEye as vi } from "@fortawesome/pro-solid-svg-icons/faEye";
import { faEyeSlash as Ci } from "@fortawesome/pro-solid-svg-icons/faEyeSlash";
import { faFilter as Si } from "@fortawesome/pro-solid-svg-icons/faFilter";
import { faMagnifyingGlass as wi } from "@fortawesome/pro-solid-svg-icons/faMagnifyingGlass";
import { faMinus as Ro } from "@fortawesome/pro-solid-svg-icons/faMinus";
import { faPlus as ki } from "@fortawesome/pro-solid-svg-icons/faPlus";
import { faSolarSystem as Ii } from "@fortawesome/pro-solid-svg-icons/faSolarSystem";
import { faTriangleExclamation as $i } from "@fortawesome/pro-solid-svg-icons/faTriangleExclamation";
import { faXmark as Mi } from "@fortawesome/pro-solid-svg-icons/faXmark";
import { faArrowDown as Ni } from "@fortawesome/pro-light-svg-icons/faArrowDown";
import { faArrowLeft as zi } from "@fortawesome/pro-light-svg-icons/faArrowLeft";
import { faArrowLeftLongToLine as Di } from "@fortawesome/pro-light-svg-icons/faArrowLeftLongToLine";
import { faArrowRight as _i } from "@fortawesome/pro-light-svg-icons/faArrowRight";
import { faArrowRightFromBracket as Ai } from "@fortawesome/pro-light-svg-icons/faArrowRightFromBracket";
import { faArrowRightLongToLine as Li } from "@fortawesome/pro-light-svg-icons/faArrowRightLongToLine";
import { faArrowUp as Ti } from "@fortawesome/pro-light-svg-icons/faArrowUp";
import { faArrowUpFromBracket as Bi } from "@fortawesome/pro-light-svg-icons/faArrowUpFromBracket";
import { faArrowUpRightFromSquare as Pi } from "@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare";
import { faAtom as Ri } from "@fortawesome/pro-light-svg-icons/faAtom";
import { faBars as Hi } from "@fortawesome/pro-light-svg-icons/faBars";
import { faBell as Ei } from "@fortawesome/pro-light-svg-icons/faBell";
import { faCalendar as Fi } from "@fortawesome/pro-light-svg-icons/faCalendar";
import { faCartShopping as ji } from "@fortawesome/pro-light-svg-icons/faCartShopping";
import { faCheck as Oi } from "@fortawesome/pro-light-svg-icons/faCheck";
import { faChevronDown as Wi } from "@fortawesome/pro-light-svg-icons/faChevronDown";
import { faChevronLeft as Gi } from "@fortawesome/pro-light-svg-icons/faChevronLeft";
import { faChevronRight as Ui } from "@fortawesome/pro-light-svg-icons/faChevronRight";
import { faChevronUp as Vi } from "@fortawesome/pro-light-svg-icons/faChevronUp";
import { faCircle as Yi } from "@fortawesome/pro-light-svg-icons/faCircle";
import { faCircleCheck as Zi } from "@fortawesome/pro-light-svg-icons/faCircleCheck";
import { faCircleDot as Qi } from "@fortawesome/pro-light-svg-icons/faCircleDot";
import { faCircleExclamation as Ki } from "@fortawesome/pro-light-svg-icons/faCircleExclamation";
import { faCircleInfo as Xi } from "@fortawesome/pro-light-svg-icons/faCircleInfo";
import { faCircleXmark as qi } from "@fortawesome/pro-light-svg-icons/faCircleXmark";
import { faCloudArrowUp as Ji } from "@fortawesome/pro-light-svg-icons/faCloudArrowUp";
import { faComment as el } from "@fortawesome/pro-light-svg-icons/faComment";
import { faCreditCard as tl } from "@fortawesome/pro-light-svg-icons/faCreditCard";
import { faCreditCardFront as ol } from "@fortawesome/pro-light-svg-icons/faCreditCardFront";
import { faDollarSign as rl } from "@fortawesome/pro-light-svg-icons/faDollarSign";
import { faEye as al } from "@fortawesome/pro-light-svg-icons/faEye";
import { faEyeSlash as nl } from "@fortawesome/pro-light-svg-icons/faEyeSlash";
import { faFilter as il } from "@fortawesome/pro-light-svg-icons/faFilter";
import { faMagnifyingGlass as ll } from "@fortawesome/pro-light-svg-icons/faMagnifyingGlass";
import { faMinus as sl } from "@fortawesome/pro-light-svg-icons/faMinus";
import { faPlus as cl } from "@fortawesome/pro-light-svg-icons/faPlus";
import { faSolarSystem as dl } from "@fortawesome/pro-light-svg-icons/faSolarSystem";
import { faTriangleExclamation as ul } from "@fortawesome/pro-light-svg-icons/faTriangleExclamation";
import { faXmark as Ho } from "@fortawesome/pro-light-svg-icons/faXmark";
import { flexRender as Je, useReactTable as gl, getCoreRowModel as pl, getExpandedRowModel as ml, getSortedRowModel as bl } from "@tanstack/react-table";
import { AnimatePresence as hl, LazyMotion as fl, domMax as yl, m as yt, motion as Eo } from "framer-motion";
import { useDrop as xl, useDrag as vl, DndProvider as Cl } from "react-dnd";
import { HTML5Backend as Sl } from "react-dnd-html5-backend";
import { useDebouncedCallback as Fo } from "use-debounce";
import xt from "react-paginate";
import vt from "react-datepicker";
import { NumericFormat as wl, PatternFormat as kl } from "react-number-format";
import { useCheckboxGroup as Il } from "@chakra-ui/checkbox";
import { useRadioGroup as $l } from "@chakra-ui/radio";
import { useDropzone as Ml } from "react-dropzone";
const Um = ({
  children: e,
  theme: o
}) => /* @__PURE__ */ t(Er, { theme: o, children: e }), Nl = N({
  display: "inline-block",
  width: "100%",
  height: "auto",
  ".cls-1": {
    color: "gray.700",
    fill: "currentColor"
  }
}), zl = te({
  baseStyle: Nl
}), Dl = N({
  display: "inline-block",
  width: "100%",
  height: "auto",
  ".cls-1": {
    fill: "currentColor"
  },
  ".cls-2": {
    fill: "currentColor"
  }
}), _l = N({
  grayscale: {
    ".cls-1": {
      color: "gray.700"
    },
    ".cls-2": {
      color: "gray.700"
    }
  },
  colour: {
    ".cls-1": {
      color: "#52A446"
    },
    ".cls-2": {
      color: "#FFD600"
    }
  }
}), Al = te({
  baseStyle: Dl,
  variants: _l,
  defaultProps: {
    variant: "colour"
  }
}), { defineMultiStyleConfig: Ll, definePartsStyle: Tl } = B(Sn.keys), Bl = N({
  borderTopWidth: "1px",
  borderColor: "gray.200",
  _last: {
    borderBottomWidth: "1px"
  }
}), Pl = N({
  transitionProperty: "common",
  transitionDuration: "normal",
  textStyle: "subheading2",
  py: 2,
  px: 4,
  svg: {
    ml: 3,
    color: "teal.500"
  },
  _focusVisible: {
    boxShadow: "outline",
    position: "relative",
    zIndex: 1
  },
  _hover: {
    bg: "gray.100",
    svg: {
      color: "teal.600"
    }
  },
  _disabled: {
    opacity: 0.5,
    cursor: "not-allowed"
  },
  _expanded: {
    svg: {
      color: "teal.700"
    },
    _hover: {
      bg: "gray.100"
    }
  }
}), Rl = N({
  bg: "teal.25",
  pt: 2,
  px: 4,
  pb: 4
}), Hl = Tl({
  root: {},
  container: Bl,
  button: Pl,
  panel: Rl
}), El = Ll({
  baseStyle: Hl
}), Fl = ne({
  textStyle: "bodyBoldSmall",
  px: 1,
  borderRadius: "base"
}), jl = ne((e) => {
  const { colorScheme: o, theme: r } = e;
  return {
    bg: `${o}.100`,
    color: `${o}.800`
  };
}), Ol = {
  subtle: jl
}, Wl = On({
  baseStyle: Fl,
  variants: Ol,
  defaultProps: {
    variant: "subtle",
    colorScheme: "gray"
  }
}), { defineMultiStyleConfig: Gl, definePartsStyle: Vm } = B([
  "container",
  "header",
  "body"
]), Ul = Gl({
  baseStyle: {
    container: {
      p: "4",
      borderWidth: "1px",
      borderRadius: "lg",
      borderColor: "gray.200",
      bg: "white"
    },
    header: {
      pb: 3
    },
    body: {}
  },
  variants: {},
  defaultProps: {}
}), Vl = N({
  color: "gray.700",
  background: "transparent",
  borderColor: "transparent",
  _disabled: {
    color: "gray.800",
    opacity: 0.5,
    cursor: "not-allowed",
    boxShadow: "none",
    _hover: { bg: "none" }
  },
  _hover: { bg: "blackAlpha.100" },
  _active: { bg: "blackAlpha.200" },
  _focusVisible: {
    boxShadow: "outline"
  }
}), Yl = te({
  baseStyle: Vl
}), Zl = B(["container"]), Ql = Zl.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: "inline-flex",
      gap: "8px",
      "> li": {
        display: "inline-block"
      },
      "> li:not(.previous):not(.next)": {
        display: "none"
      },
      "> li.disabled > a > div": {
        opacity: 0.5,
        cursor: "not-allowed",
        boxShadow: "none"
      },
      "> li.previous, li.next": {
        fontSize: "16px"
      },
      "li:not(.previous, .next)": {
        backgroundColor: "white",
        borderRadius: "lg",
        height: "32px",
        minWidth: "32px",
        mx: 1,
        my: 0,
        px: 1,
        py: 0
      },
      "li:not(.previous, .next) > a": {
        alignItems: "center",
        color: "gray.800",
        display: "flex",
        fontSize: "md",
        fontWeight: 700,
        height: "100%",
        justifyContent: "center"
      },
      "li:not(.previous, .next).selected > a, li:not(.previous, .next):hover > a": {
        color: "white"
      },
      "li:not(.previous, .next).selected, li:not(.previous, .next):hover": {
        bg: "teal.600",
        borderColor: "teal.600"
      }
    }
  }
}), { defineMultiStyleConfig: Kl, definePartsStyle: Nt } = B([
  ...wn.keys,
  "status"
]), uo = N({
  "&[data-is-numeric=true]": {
    textAlign: "end"
  }
}), Xl = Nt({
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse",
    width: "full"
  },
  th: {
    textStyle: "bodyBold",
    textAlign: "left",
    whiteSpace: "pre-wrap",
    verticalAlign: "bottom"
  },
  td: {
    whiteSpace: "pre-wrap",
    textStyle: { base: "subheading2", md: "bodySmall" },
    textAlign: "start"
  },
  caption: {
    mt: 4,
    fontFamily: "body",
    textAlign: "center",
    fontWeight: "medium"
  },
  status: {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    border: "0px",
    overflow: "hidden"
  }
}), ql = Kl({
  baseStyle: Xl,
  variants: {
    base: Nt(({ theme: e }) => ({
      th: {
        borderBottom: "1px",
        borderTop: "1px",
        borderColor: "gray.200",
        backgroundColor: "gray.50",
        ...uo
      },
      tr: {
        _first: {
          td: {
            borderTop: "1px",
            borderColor: "gray.200"
          }
        }
      },
      td: {
        borderBottom: "1px",
        borderColor: "gray.200",
        ...uo
      },
      caption: {
        color: "gray.600"
      },
      tfoot: {
        tr: {
          "&:last-of-type": {
            th: { borderBottomWidth: 0 }
          }
        }
      }
    }))
  },
  sizes: {
    md: Nt({
      th: {
        px: { base: 4, md: 6 },
        py: 3
      },
      td: {
        px: { base: 4, md: 6 },
        py: { base: 2, md: 5 },
        lineHeight: "1"
      },
      caption: {
        px: "6",
        py: "2",
        fontSize: "sm"
      }
    })
  },
  defaultProps: {
    variant: "base",
    size: "md"
  }
}), { defineMultiStyleConfig: Jl, definePartsStyle: es } = To(kn.keys), ts = ne({
  px: 2,
  borderRadius: "lg",
  outline: 0,
  gap: "4px",
  _focusVisible: {
    boxShadow: "outline"
  }
}), os = ne({
  textStyle: "bodyBoldSmall",
  overflow: "visible"
}), rs = ne({
  height: "14px",
  width: "14px",
  minW: "14px",
  minH: "14px"
}), as = es({
  container: ts,
  label: os,
  closeButton: rs
}), ns = ne((e) => {
  const { colorScheme: o, theme: r } = e;
  return {
    container: {
      bg: `${o}.100`
    },
    label: {
      color: `${o}.800`
    }
  };
}), is = {
  subtle: ns
}, ls = Jl({
  variants: is,
  baseStyle: as,
  defaultProps: {
    variant: "subtle",
    colorScheme: "teal"
  }
}), ss = te({
  variants: {
    h1: {
      textStyle: "h1"
    },
    h2: {
      textStyle: "h2"
    },
    h3: {
      textStyle: "h3"
    },
    h4: {
      textStyle: "h4"
    },
    subheading1: {
      textStyle: "subheading1"
    },
    subheading2: {
      textStyle: "subheading2"
    },
    body: {
      textStyle: "body"
    },
    bodyBold: {
      textStyle: "bodyBold"
    },
    bodySmall: {
      textStyle: "bodySmall"
    },
    bodyBoldSmall: {
      textStyle: "bodyBoldSmall"
    }
  },
  baseStyle: {},
  sizes: {},
  defaultProps: {}
}), { defineMultiStyleConfig: cs, definePartsStyle: Gt } = B(In.keys), ds = N((e) => {
  const { orientation: o } = e;
  return {
    display: o === "vertical" ? "flex" : "block",
    ".tabs-scrollable": {
      overflowX: "scroll",
      position: "relative",
      overflowY: "visible",
      margin: "-4px -4px",
      padding: "4px 4px"
    },
    ".tabs-scrollable::-webkit-scrollbar": {
      display: "none",
      msOverflowStyle: "none",
      scrollbarWidth: "none"
    }
  };
}), us = N((e) => {
  const { isFitted: o } = e;
  return {
    flex: o ? 1 : void 0,
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
      zIndex: 1,
      boxShadow: "outline"
    },
    _disabled: {
      cursor: "not-allowed",
      opacity: 0.4
    }
  };
}), gs = N((e) => {
  const { align: o = "start", orientation: r } = e;
  return {
    justifyContent: {
      end: "flex-end",
      center: "center",
      start: "flex-start"
    }[o],
    flexDirection: r === "vertical" ? "column" : "row"
  };
}), ps = N({
  p: 4
}), ms = Gt((e) => ({
  root: ds(e),
  tab: us(e),
  tablist: gs(e),
  tabpanel: ps
})), bs = {
  md: Gt({
    tab: {
      textStyle: "subheading1",
      py: 2,
      px: 4
    }
  })
}, hs = Gt((e) => {
  const { orientation: o } = e, r = o === "vertical", a = o === "vertical" ? "borderStart" : "borderBottom", n = r ? "marginStart" : "marginBottom";
  return {
    tablist: {
      [a]: "2px solid",
      borderColor: "gray.200"
    },
    tab: {
      [a]: "2px solid",
      borderColor: "gray.200",
      [n]: "-2px",
      color: "gray.600",
      _hover: {
        color: "teal.500",
        borderColor: "teal.500"
      },
      _selected: {
        color: "teal.700",
        borderColor: "teal.700"
      },
      _disabled: {
        _active: { bg: "none" }
      }
    }
  };
}), fs = cs({
  baseStyle: ms,
  sizes: bs,
  variants: {
    line: hs
  },
  defaultProps: {
    size: "md",
    variant: "line",
    colorScheme: "blue"
  }
}), k = {
  xs: "12px",
  sm: "14px",
  md: "16px",
  lg: "18px",
  xl: "20px",
  "2xl": "24px",
  "3xl": "28px",
  "4xl": "36px",
  "5xl": "48px",
  "6xl": "64px"
}, _e = {
  xs: { fontSize: k.xs },
  sm: { fontSize: k.sm },
  md: { fontSize: k.md },
  lg: { fontSize: k.lg },
  xl: { fontSize: k.xl },
  "2xl": { fontSize: k["2xl"] },
  "3xl": { fontSize: k["3xl"] },
  "4xl": { fontSize: k["4xl"] },
  "5xl": { fontSize: k["5xl"] },
  "6xl": { fontSize: k["6xl"] }
}, ys = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  iconSizeStyles: _e,
  iconSizes: k
}, Symbol.toStringTag, { value: "Module" })), { defineMultiStyleConfig: xs, definePartsStyle: st } = B([
  ...$n.keys,
  "close"
]), vs = st((e) => ({
  container: {
    alignItems: "start",
    py: { base: 2, md: 3 }
  },
  title: {
    textStyle: "bodyBold"
  },
  description: {
    textStyle: "body",
    display: "inline-block"
  },
  icon: {
    flexShrink: 0,
    marginEnd: { base: 2, md: 3 },
    marginTop: { base: "2px", md: 0 },
    w: { base: k.xl, md: k["2xl"] },
    h: { base: k.xl, md: k["2xl"] }
  },
  close: {
    alignSelf: "flex-start",
    position: "absolute",
    right: { base: 4, md: 6 },
    top: { base: 2, md: 3 }
  }
})), jo = st((e) => {
  const { colorScheme: o } = e;
  return {
    container: {
      borderStartWidth: "4px",
      borderStartColor: `${o}.500`,
      bg: `${o}.50`,
      borderRadius: "lg",
      paddingLeft: { base: 3, md: 5 }
    }
  };
}), Cs = st({
  container: {
    bg: "gray.50",
    paddingLeft: { base: 4, md: 6 }
  }
}), Ss = st((e) => ({
  container: {
    ...jo(e).container,
    boxShadow: "xl"
  },
  icon: {
    marginEnd: 3
  },
  close: {
    right: 1,
    top: 1
  }
})), ws = xs({
  baseStyle: vs,
  variants: {
    "left-accent": jo,
    toast: Ss,
    global: Cs
  },
  defaultProps: {
    variant: "left-accent",
    colorScheme: "blue"
  }
}), ks = B(["container", "iconButton", "badgeContainer", "badge"]), Is = ks.defineMultiStyleConfig({
  baseStyle: {
    container: {
      position: "relative",
      width: "fit-content",
      height: "fit-content"
    },
    iconButton: {
      borderRadius: "full"
    },
    badgeContainer: {
      position: "absolute",
      display: "inline",
      width: "48px",
      right: "-24px",
      top: "-14px",
      textAlign: "center"
    },
    badge: {
      background: "red.500",
      color: "white",
      borderRadius: "2xl",
      border: "1px solid white",
      fontSize: "10px",
      fontStyle: "normal",
      fontWeight: "semibold",
      lineHeight: "12px"
    }
  },
  sizes: {},
  variants: {},
  defaultProps: {}
}), { defineMultiStyleConfig: $s } = B(Mn.keys), Ms = $s({
  sizes: {
    sm: {
      track: { h: 2 }
    },
    md: {
      track: { h: 3 }
    },
    lg: {
      track: { h: 4 }
    }
  },
  baseStyle: {
    filledTrack: {
      bg: "green.500",
      transition: "width 0.3s ease-in-out"
    },
    track: {
      bg: "gray.100",
      "&.gravity-progress__appear-full": {
        div: {
          w: "100% !important"
        }
      }
    }
  },
  defaultProps: {
    size: "md",
    variant: "normal"
  },
  variants: {
    normal: {
      filledTrack: {
        bg: "green.500"
      }
    },
    error: {
      filledTrack: {
        bg: "red.500"
      }
    }
  }
}), Ns = B(["container"]), zs = Ns.defineMultiStyleConfig({
  baseStyle: {
    container: {
      bg: "white",
      borderRadius: "lg",
      p: { base: 4, md: "40px" }
    }
  },
  variants: {},
  defaultProps: {}
}), Ds = te({
  baseStyle: {
    color: "teal.500"
  },
  sizes: {
    sm: {
      h: "14px",
      w: "14px"
    },
    md: {
      h: "16px",
      w: "16px"
    },
    lg: {
      h: "18px",
      w: "18px"
    }
  },
  defaultProps: {
    size: "md"
  }
}), _s = se("skeleton-start-color"), As = se("skeleton-end-color"), Ls = N((e) => {
  const o = "gray.400", r = "gray.100", { startColor: a = o, endColor: n = r, theme: i } = e, l = so(i, a), s = so(i, n);
  return {
    [_s.variable]: l,
    [As.variable]: s,
    opacity: 0.7,
    borderRadius: "base",
    borderColor: l,
    background: s
  };
}), Ts = te({
  baseStyle: Ls
}), { defineMultiStyleConfig: Bs, definePartsStyle: Ps } = B([
  "container",
  "content",
  "body",
  "suggestion",
  "status"
]), Rs = Ps({
  content: {
    paddingY: 2,
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "gray.200",
    borderRadius: "lg",
    boxShadow: "lg",
    backgroundColor: "white"
  },
  body: {
    maxW: "100%",
    padding: 0
  },
  suggestion: {
    paddingX: 4,
    paddingY: { base: 1, md: 2 },
    ":hover, &.suggestion-focused": {
      backgroundColor: "gray.100",
      cursor: "arrow"
    }
  },
  status: {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    border: "0px",
    overflow: "hidden"
  }
}), Hs = Bs({
  baseStyle: Rs
}), Es = N((e) => {
  const o = {
    bg: "red.500",
    _hover: { bg: "red.600" },
    _active: { bg: "red.700" }
  }, r = {
    bg: "teal.500",
    _hover: { bg: "teal.600" },
    _active: { bg: "teal.700" }
  };
  return {
    color: "white",
    borderColor: "transparent",
    ...e.colorScheme === "red" ? o : r
  };
}), Fs = N((e) => {
  const o = {
    color: "red.500",
    _hover: {
      color: "red.600",
      bg: "gray.100"
    },
    _active: {
      color: "red.700",
      bg: "gray.200"
    }
  }, r = {
    color: "teal.500",
    bg: "transparent",
    _hover: {
      color: "teal.600",
      bg: "gray.100"
    },
    _active: {
      color: "teal.700",
      bg: "gray.200"
    }
  };
  return {
    borderColor: "transparent",
    ...e.colorScheme === "red" ? o : r
  };
}), js = N((e) => {
  const o = {
    color: "red.500",
    _hover: {
      color: "red.600",
      bg: "gray.100"
    },
    _active: {
      color: "red.700",
      bg: "gray.200"
    }
  }, r = {
    color: "teal.500",
    _hover: {
      color: "teal.600",
      bg: "gray.100"
    },
    _active: {
      color: "teal.700",
      bg: "gray.200"
    }
  };
  return {
    bg: "white",
    borderColor: "gray.200",
    ...e.colorScheme === "red" ? o : r,
    ".chakra-button__group[data-attached] > &:not(:last-of-type)": {
      marginEnd: "-1px"
    }
  };
}), Os = N((e) => {
  const o = {
    color: "red.500",
    borderColor: "red.500",
    _hover: {
      color: "red.600",
      borderColor: "red.600",
      bg: "red.50"
    },
    _active: {
      color: "red.700",
      borderColor: "red.700",
      bg: "red.100"
    }
  }, r = {
    color: "teal.500",
    borderColor: "teal.500",
    _hover: {
      color: "teal.600",
      borderColor: "teal.600",
      bg: "teal.100"
    },
    _active: {
      color: "teal.700",
      borderColor: "teal.700",
      bg: "teal.200"
    }
  };
  return {
    bg: "white",
    ...e.colorScheme === "red" ? o : r,
    ".chakra-button__group[data-attached] > &:not(:last-of-type)": {
      marginEnd: "-1px"
    }
  };
}), Ws = {
  tertiary: js,
  secondary: Os,
  primary: Es,
  ghost: Fs
}, Gs = {
  lg: N({
    textStyle: "subheading2",
    minH: { base: 10, md: 12 },
    minW: { base: 10, md: 12 },
    px: 6
  }),
  md: N({
    textStyle: "bodyBold",
    minH: { base: 8, md: 10 },
    minW: { base: 8, md: 10 },
    px: 4
  }),
  sm: N({
    textStyle: "bodyBoldSmall",
    minH: { base: 7, md: 8 },
    minW: { base: 7, md: 8 },
    px: 3
  }),
  xs: N({
    textStyle: "bodyBoldSmall",
    minH: { base: 6, md: 6 },
    minW: { base: 6, md: 6 }
  })
}, Us = {
  borderRadius: "lg",
  transitionProperty: "common",
  transitionDuration: "normal",
  border: "1px solid green",
  _focusVisible: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.5,
    pointerEvents: "none",
    cursor: "not-allowed"
  }
}, Ge = te({
  baseStyle: Us,
  variants: Ws,
  sizes: Gs,
  defaultProps: {
    variant: "primary",
    size: "md"
  }
}), { defineMultiStyleConfig: Vs, definePartsStyle: Ue } = B(Nn.keys), Ys = {
  sm: Ue({
    control: {
      h: 4,
      w: 4,
      marginTop: { base: "2px", md: "4px" }
    },
    label: {
      textStyle: "bodySmall"
    },
    icon: {
      fontSize: k.xs
    }
  }),
  md: Ue({
    control: {
      w: 5,
      h: 5,
      marginTop: "2px"
    },
    label: {
      textStyle: "body"
    },
    icon: {
      fontSize: k.md
    }
  })
}, Zs = Ue(({ size: e }) => {
  const o = Ys[e];
  return {
    icon: {
      transitionProperty: "transform",
      transitionDuration: "normal",
      ...o.icon
    },
    container: {
      alignItems: "start",
      WebkitAlignItems: "start",
      _disabled: { cursor: "not-allowed" }
    },
    label: {
      color: "black",
      userSelect: "none",
      _disabled: { opacity: 0.5 },
      ...o.label
    },
    control: {
      transitionProperty: "box-shadow",
      transitionDuration: "normal",
      border: "2px solid",
      borderRadius: "base",
      borderColor: "gray.200",
      color: "white",
      backgroundColor: "white",
      ...o.control,
      _hover: {
        borderColor: "gray.300"
      },
      _checked: {
        bg: "teal.500",
        borderColor: "teal.500",
        color: "white",
        _hover: {
          bg: "teal.600",
          borderColor: "teal.600"
        },
        _disabled: {
          borderColor: "gray.200",
          bg: "gray.200",
          color: "gray.500"
        }
      },
      _indeterminate: {
        bg: "teal.500",
        borderColor: "teal.500",
        color: "white"
      },
      _disabled: {
        bg: "gray.200",
        borderColor: "gray.200",
        opacity: 0.5
      },
      _focusVisible: {
        boxShadow: "outline"
      },
      _invalid: {
        borderColor: "red.500",
        _focusVisible: {
          boxShadow: "invalidOutline"
        }
      }
    }
  };
}), Qs = Ue(() => ({
  size: {},
  icon: { display: "none" },
  container: {
    borderColor: "teal.500",
    borderWidth: "1px",
    borderRadius: "lg",
    bg: "white",
    p: 4,
    pb: 10,
    width: "fit-content",
    textStyle: "body",
    _hover: {
      borderColor: "teal.700",
      bg: "teal.50",
      _disabled: {
        borderColor: "gray.200",
        bg: "initial"
      }
    },
    _focusWithin: {
      p: "15px",
      pb: "39px",
      borderColor: "teal.500",
      borderWidth: "2px",
      boxShadow: "outline"
    },
    _checked: {
      borderColor: "teal.500",
      bg: "teal.25",
      ".checkbox-card-selected-badge": {
        display: "inline-block"
      },
      _hover: {
        borderColor: "teal.700",
        bg: "teal.50"
      },
      svg: { display: "none" }
    },
    _invalid: {
      p: "15px",
      pb: "39px",
      borderColor: "red.500",
      borderWidth: "2px",
      bg: "white",
      _focusWithin: {
        boxShadow: "invalidOutline"
      },
      _hover: {
        borderColor: "inherit"
      }
    },
    _disabled: {
      opacity: 0.5,
      cursor: "not-allowed"
    }
  },
  label: {
    m: 0,
    w: "100%",
    ".checkbox-card-badge-container": {
      textAlign: "right",
      lineHeight: "0",
      height: { base: "20px", md: "24px" }
    },
    ".checkbox-card-selected-badge": {
      display: "none"
    }
  }
})), Ks = Ue(({ size: e, ...o }) => {
  var a;
  const r = (a = Ge.sizes) == null ? void 0 : a[e];
  return {
    icon: { display: "none" },
    container: {
      width: "fit-content",
      ...Ge.baseStyle,
      ...r,
      color: "teal.500",
      bg: "white",
      border: "1px solid",
      borderColor: "gray.200",
      _focusWithin: {
        boxShadow: "outline"
      },
      _checked: {
        color: "teal.700",
        bg: "gray.200",
        svg: { display: "none" }
      },
      _invalid: {
        boxShadow: "inset 0px 0px 0px 2px var(--sgi-colors-red-500)",
        webkitBoxShadow: "inset 0px 0px 0px 2px var(--sgi-colors-red-500)",
        color: "teal.500",
        _focusWithin: {
          boxShadow: "invalidOutline"
        }
      }
    },
    label: { m: 0 }
  };
}), Xs = Vs({
  baseStyle: {},
  variants: {
    checkbox: Zs,
    card: Qs,
    button: Ks
  },
  defaultProps: {
    size: "md",
    variant: "checkbox"
  }
}), { defineMultiStyleConfig: qs } = B(["container", "arrows"]), Js = qs({
  baseStyle: ({ theme: e, ...o }) => ({
    container: {
      position: "relative",
      shadow: "lg",
      backgroundColor: "white",
      border: "none!important",
      pb: 3,
      px: 4,
      pt: 5,
      borderRadius: "8px !important",
      ".react-datepicker__day-name, .react-datepicker__time-name": {
        display: "inline-block",
        width: "38px",
        textAlign: "center",
        margin: 0.5
      },
      ".react-datepicker__day": {
        display: "inline-block",
        color: "gray.800",
        width: "42px",
        textAlign: "center",
        height: "32px",
        mx: 0,
        my: 0.5,
        _hover: {
          background: "gray.200",
          cursor: "pointer"
        },
        _disabled: {
          opacity: "0.5",
          cursor: "not-allowed",
          pointerEvents: "none"
        },
        ...e.textStyles.body,
        lineHeight: "32px",
        borderRadius: "8px",
        "&--outside-month": {
          color: "gray.600"
        }
      },
      ".react-datepicker__month": {
        px: 0,
        pt: 0,
        mb: 3,
        m: 0
      },
      ".react-datepicker__day--today": {
        background: "inherit",
        color: "teal.500",
        fontWeight: "bold"
      },
      ".react-datepicker__day--selected, .react-datepicker__day--keyboard-selected": {
        background: "teal.50",
        color: "gray.800"
      },
      ".react-datepicker__day--in-range": {
        borderRadius: 0,
        background: "teal.50"
      },
      ".react-datepicker__day--in-selecting-range:not(.react-datepicker__day--selecting-range-end, .react-datepicker__day--range-start)": {
        background: "teal.50",
        borderRadius: 0
      },
      ".react-datepicker__day--range-start, .react-datepicker__day--selecting-range-start:not(.react-datepicker__day--range-end)": {
        background: "teal.200",
        borderRightRadius: 0,
        borderLeftRadius: "8px",
        color: "gray.800"
      },
      ".react-datepicker__day--range-end, .react-datepicker__day--selecting-range-end:not(.react-datepicker__day--range-start)": {
        background: "teal.200",
        borderLeftRadius: 0,
        borderRightRadius: "8px",
        color: "gray.800"
      },
      ".react-datepicker__day-name": {
        width: "36px",
        textTransform: "uppercase",
        ...e.textStyles.bodySmall,
        color: "gray.600"
      },
      ".react-datepicker__header": {
        borderBottom: "none!important",
        backgroundColor: "transparent"
      },
      ".react-datepicker__today-button": {
        ...e.components.Button.variants.ghost({ theme: e, ...o }),
        borderTop: "none !important",
        mt: 1,
        py: 0,
        textAlign: "center",
        ...e.textStyles.bodyBoldSmall,
        "&:hover": {
          cursor: "pointer"
        }
      }
    }
  })
}), { defineMultiStyleConfig: ec, definePartsStyle: tc } = B([
  "container",
  "leftElement",
  "rightElement",
  "divider"
]), oc = tc({
  container: {
    // V2 classes
    ".dual-input-left": {
      borderEndRadius: "none"
    },
    ".dual-input-left-control": {
      ".chakra-form__error-message": {
        display: "none"
      }
    },
    ".dual-input-right": {
      borderStartRadius: "none"
    },
    ".dual-input-right-control": {
      ".chakra-form__error-message": {
        display: "none"
      }
    }
  },
  // V1 classes
  leftElement: {
    ".dual-input-left": {
      borderEndRadius: "none"
    },
    ".dual-input-left-control": {
      ".chakra-form__error-message": {
        display: "none"
      }
    }
  },
  // V1 classes
  rightElement: {
    ".dual-input-right": {
      borderStartRadius: "none"
    },
    ".dual-input-right-control": {
      ".chakra-form__error-message": {
        display: "none"
      }
    }
  },
  divider: {
    color: "gray.200",
    height: "auto",
    border: "0px solid",
    borderWidth: "0 0 0 1px"
  }
}), rc = ec({
  baseStyle: oc
}), { defineMultiStyleConfig: ac, definePartsStyle: nc } = B([
  "container",
  "dropzone",
  "listitem"
]), ic = nc({
  container: {},
  dropzone: {
    width: "100%",
    height: "324px",
    borderWidth: "1px",
    borderStyle: "dashed",
    borderRadius: "lg",
    borderColor: "gray.200",
    p: 10,
    backgroundColor: "gray.50",
    '&[data-dragActive="true"]': {
      backgroundColor: "gray.100"
    },
    _hover: {
      backgroundColor: "gray.100"
    },
    '&[data-invalid="true"]': {
      borderWidth: "2px",
      borderColor: "red.500",
      borderStyle: "solid"
    },
    _disabled: {
      opacity: 0.5,
      cursor: "not-allowed",
      _hover: {
        backgroundColor: "gray.50"
      }
    }
  },
  listitem: {
    gap: 4,
    alignItems: "center",
    p: 4,
    borderBottom: "1px solid var(--sgi-colors-gray-200)"
  }
}), lc = ac({
  baseStyle: ic
}), { defineMultiStyleConfig: sc } = B(zn.keys), cc = sc({
  baseStyle: {
    container: {
      width: "100%",
      position: "relative",
      "span.label-optional": {
        textStyle: "bodySmall",
        lineHeight: "20px",
        color: "gray.600",
        pl: "2"
      }
    },
    requiredIndicator: {
      marginStart: 1,
      color: "red.500"
    },
    helperText: {
      textStyle: "bodySmall",
      mt: { base: 1, md: 2 },
      color: "gray.600",
      ".password-requirement-status-icon": {
        width: { base: k.sm, md: k.md },
        height: { base: k.sm, md: k.md }
      }
    }
  }
}), dc = te({
  baseStyle: {
    textStyle: "bodyBold",
    marginEnd: 3,
    mb: { base: 1, md: 2 },
    transitionProperty: "common",
    transitionDuration: "normal"
  }
}), { defineMultiStyleConfig: uc } = B(Dn.keys), gc = uc({
  baseStyle: {
    text: {
      textStyle: "bodySmall",
      alignItems: "start",
      color: "red.500",
      display: "flex"
    },
    icon: {
      marginEnd: { base: 1, md: 2 },
      marginTop: { base: 0, md: "2px" }
    }
  }
}), { defineMultiStyleConfig: pc, definePartsStyle: mc } = B(_n.keys), bc = mc({
  field: {
    width: "100%",
    color: "gray.800",
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    ":not(.dual-input-right)": {
      ":not(.dual-input-left)": {
        _invalid: {
          _focus: {
            boxShadow: "invalidOutline"
          }
        }
      }
    },
    "&.dual-input-left": {
      _invalid: {
        borderWidth: "2px 0 2px 2px",
        borderColor: "red.500",
        _focus: {
          boxShadow: "invalidOutline"
        }
      }
    },
    "&.dual-input-right": {
      _invalid: {
        borderWidth: "2px 2px 2px 0",
        borderColor: "red.500",
        _focus: {
          boxShadow: "invalidOutline"
        }
      }
    },
    '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration, &[type="search"]::-webkit-search-results-button, &[type="search"]::-webkit-search-results-decoration': {
      WebkitAppearance: "none"
    },
    '&[type="search"]::-ms-clear, &[type="search"]::-ms-reveal': {
      display: "none",
      width: "0",
      height: "0"
    },
    "&.search-input-with-button": {
      borderRightRadius: "none",
      borderRight: "none"
    }
  },
  element: {
    "&.search-input-left-element-icon": {
      width: "auto",
      color: "gray.400"
    },
    "&.input-clear-element button, &.password-view-toggle button": {
      minWidth: 7,
      minHeight: 7
    },
    ".ccinput-right-icon": {
      color: "gray.400"
    }
  },
  addon: {
    ".currencyinput-left-addon": {
      color: "gray.700"
    }
  }
}), Xe = {
  md: N({
    textStyle: "body",
    px: 4,
    h: { base: 8, md: 10 },
    borderRadius: "lg",
    "&.search-input-with-button, &.password-input": {
      paddingLeft: "16px",
      paddingRight: { base: "56px", md: "64px" }
    },
    "&.search-input-no-button": {
      paddingLeft: { base: "38px", md: "40px" },
      paddingRight: { base: "56px", md: "64px" }
    },
    "+ .search-input-button": {
      minWidth: { base: 8, md: 10 },
      minHeight: { base: 8, md: 10 },
      fontSize: { base: k.lg, md: k.xl }
    },
    ".currencyinput-left-addon": {
      fontSize: { base: k.sm, md: k.md }
    }
  }),
  sm: N({
    textStyle: "bodySmall",
    px: 3,
    h: { base: 7, md: 8 },
    borderRadius: "lg",
    "&.search-input-with-button, &.password-input": {
      paddingLeft: "12px",
      paddingRight: { base: "48px", md: "52px" }
    },
    "&.search-input-no-button": {
      paddingLeft: { base: "32px", md: "34px" },
      paddingRight: { base: "48px", md: "52px" }
    },
    "+ .search-input-button": {
      minWidth: { base: 7, md: 8 },
      minHeight: { base: 7, md: 8 },
      fontSize: { base: k.sm, md: k.md }
    },
    ".currencyinput-left-addon": {
      fontSize: { base: k.xs, md: k.sm }
    }
  })
}, Y = pc({
  baseStyle: bc,
  sizes: {
    md: {
      field: Xe.md,
      addon: Xe.md,
      element: {
        "&.search-input-left-element-icon": {
          marginLeft: 4,
          fontSize: { base: k.sm, md: k.md }
        },
        "&.input-clear-element, &.password-view-toggle": {
          right: 4
        },
        "&.search-button-repos": {
          right: { base: "48px", md: "56px" }
        },
        "&.input-clear-element button, &.password-view-toggle button": {
          width: { base: 8, md: 10 },
          height: { base: 8, md: 10 },
          fontSize: { base: k.lg, md: k.xl }
        },
        "+ .search-input-button": {
          minWidth: { base: 8, md: 10 },
          minHeight: { base: 8, md: 10 },
          fontSize: { base: k.lg, md: k.xl }
        },
        ".ccinput-right-icon": {
          fontSize: k["2xl"]
        }
      }
    },
    sm: {
      field: Xe.sm,
      addon: Xe.sm,
      element: {
        "&.search-input-left-element-icon": {
          marginLeft: 3,
          fontSize: { base: k.xs, md: k.sm }
        },
        "&.input-clear-element, &.password-view-toggle": {
          right: 3
        },
        "&.search-button-repos": {
          right: { base: "40px", md: "44px" }
        },
        "&.input-clear-element button, &.password-view-toggle button": {
          width: { base: 7, md: 8 },
          height: { base: 7, md: 8 },
          fontSize: { base: k.sm, md: k.md }
        },
        "+ .search-input-button": {
          minWidth: { base: 7, md: 8 },
          minHeight: { base: 7, md: 8 },
          fontSize: { base: k.sm, md: k.md }
        },
        ".ccinput-right-icon": {
          fontSize: k.xl
        }
      }
    }
  },
  variants: {
    outline: {
      field: {
        border: "1px solid",
        borderColor: "gray.200",
        bg: "inherit",
        _hover: {
          borderColor: "gray.300"
        },
        _focus: {
          borderColor: "teal.500",
          borderWidth: "2px",
          boxShadow: "outline"
        },
        _focusVisible: {
          borderColor: "teal.500",
          borderWidth: "2px"
        },
        _readOnly: {
          userSelect: "all"
        },
        ":not(.dual-input-left)": {
          ":not(.dual-input-right)": {
            _invalid: {
              borderWidth: "2px",
              borderColor: "red.500"
            }
          }
        },
        _disabled: {
          opacity: 0.5,
          cursor: "not-allowed",
          _hover: {
            borderColor: "gray.200"
          }
        }
      },
      addon: {
        border: "1px solid",
        borderColor: "gray.200",
        bg: "gray.100"
      }
    },
    filled: {
      field: {
        border: "1px solid",
        borderColor: "transparent",
        bg: "gray.50",
        _hover: {
          bg: "gray.100"
        },
        _focus: {
          bg: "inherit",
          borderColor: "teal.500",
          borderWidth: "2px",
          boxShadow: "outline"
        },
        _focusVisible: {
          bg: "inherit",
          borderColor: "teal.500",
          borderWidth: "2px"
        },
        _readOnly: {
          boxShadow: "none !important",
          userSelect: "all"
        },
        ":not(.dual-input-right)": {
          ":not(.dual-input-left)": {
            _invalid: {
              borderColor: "red.500",
              bg: "inherit",
              borderWidth: "2px",
              _hover: {
                bg: "inherit"
              }
            }
          }
        },
        _disabled: {
          opacity: 0.5,
          cursor: "not-allowed",
          _hover: {
            bg: "gray.50"
          }
        }
      },
      addon: {
        border: "1px solid",
        borderColor: "transparent",
        bg: "gray.100",
        "~ hr": {
          border: "0px solid",
          borderWidth: "0 0 0 1px",
          borderColor: "gray.200",
          height: "auto"
        }
      }
    }
  },
  defaultProps: {
    size: "md",
    variant: "outline"
  }
}), { defineMultiStyleConfig: hc, definePartsStyle: fc } = B(An.keys);
var Co;
const yc = fc({
  field: {
    ...(Co = Y.baseStyle) == null ? void 0 : Co.field
  },
  stepperGroup: {
    flexDirection: "row",
    color: "teal.500"
  },
  stepper: {
    borderStart: "1px solid",
    borderStartColor: "gray.200",
    _last: {
      pb: "4px",
      borderRightRadius: "lg"
    },
    _active: {
      bg: "gray.200"
    },
    _disabled: {
      opacity: 0.5,
      cursor: "not-allowed"
    }
  }
});
var So, wo, ko, Io;
const xc = hc({
  baseStyle: yc,
  sizes: {
    md: {
      field: (So = Y.sizes) == null ? void 0 : So.md.field,
      stepperGroup: {
        width: "80px",
        fontSize: "12px"
      }
    },
    sm: {
      field: (wo = Y.sizes) == null ? void 0 : wo.sm.field,
      stepperGroup: {
        width: "64px",
        fontSize: "10px"
      }
    }
  },
  variants: {
    outline: {
      field: (ko = Y.variants) == null ? void 0 : ko.outline.field
    },
    filled: {
      field: (Io = Y.variants) == null ? void 0 : Io.filled.field
    }
  },
  defaultProps: Y.defaultProps
}), { defineMultiStyleConfig: vc, definePartsStyle: Ve } = B(Ln.keys), Cc = {
  md: Ve({
    control: {
      w: 5,
      h: 5,
      marginTop: "2px"
    },
    label: { textStyle: "body" }
  }),
  sm: Ve({
    control: {
      width: 4,
      height: 4,
      marginTop: { base: "2px", md: "4px" }
    },
    label: { textStyle: "bodySmall" }
  })
}, Sc = Ve(({ size: e }) => {
  const o = Cc[e];
  return {
    container: {
      alignItems: "start",
      WebkitAlignItems: "start",
      _disabled: { cursor: "not-allowed" }
    },
    label: {
      color: "black",
      userSelect: "none",
      _disabled: { opacity: 0.5 },
      ...o.label
    },
    control: {
      borderRadius: "full",
      transitionProperty: "box-shadow",
      transitionDuration: "normal",
      border: "2px solid",
      borderColor: "gray.200",
      color: "white",
      ...o.control,
      _hover: {
        borderColor: "gray.300"
      },
      _checked: {
        bg: "teal.500",
        borderColor: "teal.500",
        color: "white",
        _before: {
          content: '""',
          display: "inline-block",
          pos: "relative",
          w: "50%",
          h: "50%",
          borderRadius: "50%",
          bg: "currentColor"
        },
        _hover: {
          bg: "teal.600",
          borderColor: "teal.600"
        },
        _disabled: {
          borderColor: "gray.200",
          bg: "gray.200",
          color: "gray.500"
        }
      },
      _indeterminate: {
        bg: "teal.500",
        borderColor: "teal.500",
        color: "white"
      },
      _disabled: {
        bg: "gray.200",
        borderColor: "gray.200",
        opacity: 0.5
      },
      _focusVisible: {
        boxShadow: "outline"
      },
      _invalid: {
        borderColor: "red.500",
        _focusVisible: {
          boxShadow: "invalidOutline"
        }
      }
    }
  };
}), wc = Ve(() => ({
  size: {},
  container: {
    borderColor: "teal.500",
    borderWidth: "1px",
    borderRadius: "lg",
    bg: "white",
    p: 4,
    pb: 10,
    width: "fit-content",
    textStyle: "body",
    w: "100%",
    h: "100%",
    alignItems: "start",
    _hover: {
      borderColor: "teal.700",
      bg: "teal.50",
      _disabled: {
        borderColor: "gray.200",
        bg: "initial"
      }
    },
    _focusWithin: {
      p: "15px",
      pb: "39px",
      borderColor: "teal.500",
      borderWidth: "2px",
      boxShadow: "outline"
    },
    _checked: {
      borderColor: "teal.500",
      bg: "teal.25",
      ".radio-card-selected-badge": {
        display: "inline-block"
      },
      _hover: {
        borderColor: "teal.700",
        bg: "teal.50"
      }
    },
    _invalid: {
      p: "15px",
      pb: "39px",
      borderColor: "red.500",
      borderWidth: "2px",
      bg: "white",
      _focusWithin: {
        boxShadow: "invalidOutline"
      },
      _hover: {
        borderColor: "inherit"
      }
    },
    _disabled: {
      opacity: 0.5,
      cursor: "not-allowed"
    }
  },
  label: {
    m: 0,
    w: "100%",
    ".radio-card-badge-container": {
      textAlign: "right",
      lineHeight: "0",
      height: { base: "20px", md: "24px" }
    },
    ".radio-card-selected-badge": {
      display: "none"
    }
  },
  control: {}
})), kc = Ve(({ size: e, ...o }) => {
  var a;
  const r = (a = Ge.sizes) == null ? void 0 : a[e];
  return {
    container: {
      width: "fit-content",
      ...Ge.baseStyle,
      ...r,
      color: "teal.500",
      bg: "white",
      border: "1px solid",
      borderColor: "gray.200",
      _focusWithin: {
        boxShadow: "outline"
      },
      _checked: {
        color: "teal.700",
        bg: "gray.200"
      },
      _invalid: {
        boxShadow: "inset 0px 0px 0px 2px var(--sgi-colors-red-500)",
        webkitBoxShadow: "inset 0px 0px 0px 2px var(--sgi-colors-red-500)",
        color: "teal.500",
        _focusWithin: {
          boxShadow: "invalidOutline"
        }
      }
    },
    label: { m: 0 },
    control: {}
  };
}), Ic = vc({
  baseStyle: {},
  variants: {
    radio: Sc,
    card: wc,
    button: kc
  },
  defaultProps: {
    size: "md",
    variant: "radio"
  }
}), $c = te({
  baseStyle: {
    '&[data-attached="true"]': {
      width: "fit-content"
    },
    '&[data-attached="true"] label': {
      borderRadius: "none"
    },
    '&[data-attached="true"] div:first-child label': {
      borderStartRadius: "lg"
    },
    '&[data-attached="true"] div:last-child label': {
      borderEndRadius: "lg"
    },
    '&[data-attached="true"] :not(div:last-child) label': {
      marginInlineEnd: "-1px"
    },
    '&[data-attached="true"] label:focus-within': {
      zIndex: 1
    },
    '&[data-attached="true"][data-invalid="true"]': {
      boxShadow: "0px 0px 0px 2px var(--sgi-colors-red-500)",
      webkitBoxShadow: "0px 0px 0px 2px var(--sgi-colors-red-500)",
      borderRadius: "lg"
    },
    '&[data-attached="true"][data-invalid="true"] label': {
      boxShadow: "none",
      WebkitBoxShadow: "none"
    },
    '&[data-attached="true"][data-invalid="true"] label:focus-within': {
      boxShadow: "invalidOutline"
    }
  },
  sizes: {},
  variants: {},
  defaultProps: {}
}), { defineMultiStyleConfig: Mc } = B(Tn.keys), go = N({ paddingInlineEnd: "2rem" });
var $o;
const Nc = Mc({
  baseStyle: {
    field: {
      ...(($o = Y.baseStyle) == null ? void 0 : $o.field) || {},
      bg: "white",
      appearance: "none",
      "> option, > optgroup": {
        bg: "white"
      }
    },
    icon: {
      width: "1.5rem",
      height: "100%",
      insetEnd: "0.5rem",
      position: "relative",
      color: "teal.500",
      _disabled: {
        opacity: 0.5
      },
      _groupHover: {
        color: "teal.600"
      },
      _groupFocusWithin: {
        color: "teal.700"
      }
    }
  },
  sizes: Wn({}, Y.sizes, {
    md: {
      field: go,
      icon: {
        fontSize: { base: k.sm, md: k.md }
      }
    },
    sm: {
      field: go,
      icon: {
        fontSize: { base: k.xs, md: k.sm }
      }
    }
  }),
  variants: Y.variants,
  defaultProps: Y.defaultProps
}), { defineMultiStyleConfig: zc, definePartsStyle: Dc } = To(Bn.keys), zt = jt("slider-thumb-size"), Dt = jt("slider-track-size"), nt = jt("slider-bg"), _c = ne((e) => {
  const { orientation: o } = e;
  return {
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    _disabled: {
      opacity: 0.5,
      cursor: "default",
      pointerEvents: "none"
    },
    ...Ot({
      orientation: o,
      vertical: { h: "100%", minH: "240px" },
      horizontal: { w: "100%" }
    })
  };
}), Ac = ne((e) => ({
  ...Ot({
    orientation: e.orientation,
    horizontal: { h: Dt.reference },
    vertical: { w: Dt.reference }
  }),
  overflow: "hidden",
  borderRadius: "full",
  [nt.variable]: "colors.gray.200",
  bg: nt.reference
})), Lc = ne((e) => {
  const { orientation: o } = e;
  return {
    ...Ot({
      orientation: o,
      vertical: {
        left: "50%",
        transform: "translateX(-50%)"
      },
      horizontal: {
        top: "50%",
        transform: "translateY(-50%)"
      }
    }),
    w: zt.reference,
    h: zt.reference,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    outline: 0,
    zIndex: 1,
    borderRadius: "full",
    bg: "white",
    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)",
    border: "1px solid",
    borderColor: "transparent",
    transitionProperty: "transform",
    transitionDuration: "normal",
    _hover: {
      bg: "gray.50"
    },
    _focusVisible: {
      bg: "white",
      boxShadow: "outline"
    }
  };
}), Tc = ne((e) => ({
  width: "inherit",
  height: "inherit",
  [nt.variable]: "colors.teal.500",
  bg: nt.reference
})), Bc = Dc((e) => ({
  container: _c(e),
  track: Ac(e),
  thumb: Lc(e),
  filledTrack: Tc(e)
})), Pc = {
  md: {
    container: {
      [zt.variable]: "sizes.4",
      [Dt.variable]: "sizes.1.5"
    }
  }
}, Rc = zc({
  baseStyle: Bc,
  sizes: Pc,
  defaultProps: {
    size: "md"
  }
}), { defineMultiStyleConfig: Hc, definePartsStyle: _t } = B(Pn.keys), it = se("switch-track-width"), Ae = se("switch-track-height"), Ct = se("switch-track-diff"), Ec = Bo.subtract(it, Ae), At = se("switch-thumb-x"), Fc = N({
  borderRadius: "full",
  p: "2px",
  width: [it.reference],
  height: [Ae.reference],
  transitionProperty: "common",
  transitionDuration: "fast",
  bg: "gray.300",
  _hover: {
    bg: "gray.400"
  },
  _focusVisible: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.5,
    cursor: "not-allowed",
    _hover: {
      bg: "gray.300"
    }
  },
  _checked: {
    bg: "teal.500",
    _hover: {
      bg: "teal.600"
    },
    _disabled: {
      _hover: {
        bg: "teal.500"
      }
    }
  }
}), jc = N({
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [Ae.reference],
  height: [Ae.reference],
  _checked: {
    transform: `translateX(${At.reference})`
  }
}), Oc = _t({
  container: {
    display: "flex",
    alignItems: "center",
    [Ct.variable]: Ec,
    [At.variable]: Ct.reference,
    _rtl: {
      [At.variable]: Bo(Ct).negate().toString()
    }
  },
  track: Fc,
  thumb: jc
}), Wc = {
  sm: _t({
    container: {
      [it.variable]: "1.375rem",
      [Ae.variable]: "0.75rem"
    }
  }),
  md: _t({
    container: {
      [it.variable]: "1.875rem",
      [Ae.variable]: "1rem"
    }
  })
}, Gc = Hc({
  baseStyle: Oc,
  sizes: Wc,
  defaultProps: { size: "md", colorScheme: "blue" }
});
var Mo, No;
const Uc = te({
  baseStyle: {
    ...(Mo = Y.baseStyle) == null ? void 0 : Mo.field,
    paddingY: "8px",
    minHeight: "80px",
    lineHeight: "short",
    verticalAlign: "top"
  },
  sizes: {
    sm: Y.sizes.sm.field,
    md: Y.sizes.md.field
  },
  variants: {
    outline: Y.variants.outline.field,
    filled: Y.variants.filled.field
  },
  defaultProps: {
    size: (No = Y.defaultProps) == null ? void 0 : No.size,
    variant: "outline"
  }
}), Vc = {
  body: "'Open Sans', sans-serif",
  heading: "'Merriweather', sans-serif"
}, ze = {
  xs: "12px",
  sm: "14px",
  md: "16px",
  lg: "18px",
  xl: "20px",
  "2xl": "24px",
  "3xl": "36px",
  "4xl": "48px"
}, Yc = {
  hairline: 100,
  thin: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900
}, Zc = {
  normal: "normal",
  none: 1,
  shorter: 1.25,
  short: 1.375,
  base: 1.5,
  tall: 1.625,
  taller: "2"
}, Qc = {
  tighter: "-0.05em",
  tight: "-0.025em",
  normal: "0",
  wide: "0.025em",
  wider: "0.05em",
  widest: "0.1em"
}, Kc = {
  h1: {
    fontFamily: "body",
    fontSize: { base: "3xl", md: "4xl" },
    fontWeight: "light",
    lineHeight: { base: "44px", md: "56px" }
  },
  h2: {
    fontFamily: "heading",
    fontSize: { base: "28px", md: "3xl" },
    fontWeight: "normal",
    lineHeight: { base: "40px", md: "48px" },
    fontVariantNumeric: "lining-nums"
  },
  h3: {
    fontFamily: "heading",
    fontSize: { base: "xl", md: "2xl" },
    fontWeight: "bold",
    lineHeight: { base: "32px", md: "36px" },
    fontVariantNumeric: "lining-nums"
  },
  h4: {
    fontFamily: "heading",
    fontSize: { base: "lg", md: "xl" },
    fontWeight: "bold",
    lineHeight: { base: "28px", md: "32px" },
    fontVariantNumeric: "lining-nums"
  },
  subheading1: {
    fontFamily: "body",
    fontSize: { base: "lg", md: "xl" },
    fontWeight: "bold",
    lineHeight: { base: "28px", md: "36px" },
    textTransform: "uppercase"
  },
  subheading2: {
    fontFamily: "body",
    fontSize: { base: "md", md: "lg" },
    fontWeight: "bold",
    lineHeight: { base: "24px", md: "28px" }
  },
  body: {
    fontFamily: "body",
    fontSize: { base: "sm", md: "md" },
    fontWeight: "normal",
    lineHeight: { base: "24px", md: "24px" }
  },
  bodyBold: {
    fontFamily: "body",
    fontSize: { base: "sm", md: "md" },
    fontWeight: "bold",
    lineHeight: { base: "24px", md: "24px" }
  },
  bodySmall: {
    fontFamily: "body",
    fontSize: { base: "xs", md: "sm" },
    fontWeight: "normal",
    lineHeight: { base: "20px", md: "24px" }
  },
  bodyBoldSmall: {
    fontFamily: "body",
    fontSize: { base: "xs", md: "sm" },
    fontWeight: "bold",
    lineHeight: { base: "20px", md: "24px" }
  }
}, Xc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fontSizes: ze,
  fontWeights: Yc,
  fonts: Vc,
  letterSpacings: Qc,
  lineHeights: Zc,
  textStyles: Kc
}, Symbol.toStringTag, { value: "Module" })), { defineMultiStyleConfig: qc, definePartsStyle: Jc } = B(Rn.keys), ed = N((e) => {
  const { name: o } = e;
  return {
    bg: o ? "teal.500" : "gray.200",
    color: "white",
    borderColor: "white",
    verticalAlign: "top"
  };
}), td = Jc((e) => ({
  container: ed(e),
  label: {
    textStyle: "body"
  }
}));
function Ee(e) {
  return {
    container: {
      width: e,
      height: e
    },
    excessLabel: {
      width: e,
      height: e
    }
  };
}
const od = {
  sm: {
    ...Ee(8),
    label: {
      fontSize: ze.sm,
      lineHeight: "24px"
    }
  },
  md: {
    ...Ee(12),
    label: {
      fontSize: ze.xl,
      lineHeight: "32px"
    }
  },
  lg: {
    ...Ee(16),
    label: {
      fontSize: ze["2xl"],
      lineHeight: "32px"
    }
  },
  xl: {
    ...Ee(20),
    label: {
      fontSize: ze["3xl"],
      lineHeight: "48px"
    }
  },
  "2xl": {
    ...Ee(32),
    label: {
      fontSize: ze["4xl"],
      lineHeight: "56px"
    }
  }
}, rd = qc({
  baseStyle: td,
  sizes: od,
  defaultProps: {
    size: "md"
  }
}), Lt = te({
  baseStyle: {
    textStyle: "bodyBold",
    color: "teal.500",
    textDecorationLine: "underline",
    textDecorationColor: "teal.500",
    _hover: {
      color: "teal.600",
      textDecorationColor: "teal.600"
    },
    _active: {
      color: "teal.700",
      textDecorationColor: "teal.700"
    },
    _focusVisible: {
      outline: "none",
      boxShadow: "outline"
    }
  },
  sizes: {
    sm: {
      textStyle: "bodyBoldSmall"
    },
    md: {
      textStyle: "bodyBold"
    }
  },
  defaultProps: {
    size: "md"
  }
}), { defineMultiStyleConfig: ad } = B(Hn.keys);
var zo;
const nd = ad({
  baseStyle: {
    container: {
      color: "gray.800",
      '[aria-current="page"]': {
        color: "gray.800",
        textDecoration: "none"
      }
    },
    separator: {
      textStyle: "bodySmall"
    },
    link: {
      transitionProperty: "common",
      transitionDuration: "fast",
      transitionTimingFunction: "ease-out",
      cursor: "pointer",
      ...Lt.baseStyle,
      ...(zo = Lt.sizes) == null ? void 0 : zo.sm
    }
  }
}), id = B(["container"]), ld = id.defineMultiStyleConfig({
  baseStyle: {
    container: {
      bg: "white",
      px: "6",
      alignItems: "center",
      h: "60px",
      flexDir: "row",
      borderBottomWidth: "1px",
      borderBottomColor: "gray.200"
    }
  },
  variants: {},
  defaultProps: {}
}), sd = B([
  "container",
  "mobileMenuContent",
  "mobileMenuBody",
  "mobileMenuHeader",
  "signOutLink"
]), cd = sd.defineMultiStyleConfig({
  baseStyle: {
    container: {
      bg: "white",
      paddingX: { base: 4, md: 6 },
      alignItems: "center",
      height: "60px",
      flexDir: "row",
      borderBottomWidth: "1px",
      borderBottomColor: "gray.200"
    },
    mobileMenuContent: {
      borderRadius: "none",
      borderWidth: 0,
      boxShadow: "none",
      width: "100vw"
    },
    mobileMenuBody: {
      paddingX: 0,
      paddingY: 4,
      maxWidth: "unset"
    },
    mobileMenuHeader: {
      bg: "gray.50",
      paddingY: 4,
      paddingX: 6,
      backgroundPosition: "right",
      backgroundRepeat: "no-repeat",
      textAlign: "center",
      backgroundSize: "auto 100%"
    },
    signOutLink: {
      color: "gray.800",
      paddingY: 2,
      paddingX: 6,
      display: "block",
      textDecoration: "none",
      cursor: "pointer",
      _hover: { bg: "gray.100" },
      svg: { color: "teal.500" }
    }
  },
  variants: {},
  defaultProps: {}
}), Le = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
}, { defineMultiStyleConfig: dd, definePartsStyle: Ut } = B([
  "container",
  "menubar",
  "category",
  "group",
  "menuItem",
  "slider"
]), Tt = 94, ud = 334, gd = Ut({
  container: {
    display: "flex",
    flexDir: "column",
    backgroundColor: "white"
  },
  menubar: {
    display: "flex",
    flexDir: "column"
  },
  category: {
    cursor: "pointer",
    textDecoration: "none"
  },
  menuItem: {
    display: "flex",
    flexDir: "row",
    cursor: "pointer",
    textDecoration: "none",
    "&[aria-disabled]": {
      cursor: "not-allowed",
      opacity: 0.5
    }
  }
}), pd = Ut({
  container: {
    minH: "100vh",
    pos: "sticky",
    background: "teal.500",
    zIndex: Le.modal
  },
  category: {
    display: "flex",
    flexDir: "column",
    background: "teal.500",
    gap: 2,
    alignItems: "center",
    color: "white",
    width: `${Tt}px`,
    paddingTop: 4,
    paddingX: 2,
    paddingBottom: "15px",
    borderBottom: "1px solid var(--sgi-colors-blackAlpha-200)",
    span: {
      textStyle: "bodyBoldSmall",
      lineHeight: "20px",
      textAlign: "center"
    },
    svg: {
      ..._e["2xl"]
    },
    _hover: {
      backgroundColor: "white",
      color: "gray.800"
    },
    _focusVisible: {
      outline: "none",
      boxShadow: "outline",
      zIndex: 1
    },
    "&[aria-expanded=true]": {
      backgroundColor: "white",
      color: "gray.800",
      _hover: {}
    },
    "&.category-active": {
      backgroundColor: "teal.400",
      boxShadow: "inset 6px 0 var(--sgi-colors-teal-200)",
      _hover: {
        backgroundColor: "white",
        color: "gray.800"
      },
      _focusVisible: {
        outline: "none",
        boxShadow: "outline",
        zIndex: 1
      }
    }
  },
  slider: {
    position: "absolute",
    top: "0",
    left: `${Tt}px`,
    height: "full",
    minHeight: "100%",
    overflow: "hidden",
    backgroundColor: "white",
    boxShadow: "4px 4px 6px -2px rgba(0, 0, 0, 0.05), 10px 10px 15px -3px rgba(0, 0, 0, 0.10)",
    zIndex: Le.modal
  },
  group: {
    flexDir: "column",
    gap: 2,
    minWidth: "191px",
    paddingBottom: 6,
    borderBottom: "1px solid var(--sgi-colors-gray-100)",
    marginBottom: 6,
    p: {
      textStyle: "bodyBoldSmall"
    }
  },
  menuItem: {
    gap: 2,
    paddingY: "0.5",
    paddingX: "4",
    color: "teal.600",
    minWidth: "191px",
    marginBottom: 1,
    span: {
      flex: 1,
      textStyle: "bodySmall"
    },
    svg: {
      marginTop: 1
    },
    _hover: {
      backgroundColor: "gray.100",
      color: "teal.700",
      borderRadius: "lg"
    },
    _focusVisible: {
      outline: "none",
      boxShadow: "outline"
    },
    "&[aria-current]": {
      color: "teal.700",
      backgroundColor: "teal.100",
      borderRadius: "lg",
      _hover: {
        backgroundColor: "gray.100"
      }
    }
  }
}), md = Ut({
  container: {
    width: "100%"
  },
  menubar: {
    gap: 2
  },
  category: {
    display: "flex",
    flexDir: "row",
    gap: 4,
    paddingX: 6,
    paddingY: 2,
    alignItems: "center",
    span: {
      textStyle: "bodyBold",
      color: "gray.800"
    },
    svg: {
      ..._e.xl,
      color: "teal.500",
      "&[data-icon=chevron-down], &[data-icon=chevron-up]": {
        ..._e.md
      }
    },
    _hover: {
      backgroundColor: "gray.100",
      svg: {
        color: "teal.600"
      }
    },
    "&.category-active": {
      backgroundColor: "teal.100",
      svg: {
        color: "teal.700"
      },
      _hover: {
        backgroundColor: "gray.100"
      },
      _focusVisible: {
        outline: "none",
        boxShadow: "outline"
      }
    }
  },
  group: {
    flexDir: "column",
    gap: 2,
    marginBottom: 2,
    p: {
      textStyle: "bodyBold",
      paddingLeft: "62px",
      paddingRight: 6,
      paddingY: 2
    }
  },
  menuItem: {
    gap: 2,
    paddingLeft: "60px",
    paddingRight: 6,
    paddingY: 2,
    textStyle: "body",
    marginBottom: 2,
    span: {
      flex: 1
    },
    svg: {
      marginTop: 1
    },
    _hover: {
      backgroundColor: "gray.100",
      color: "teal.600"
    },
    "&[aria-current]": {
      color: "teal.700",
      backgroundColor: "teal.100",
      _hover: {
        backgroundColor: "gray.100"
      }
    }
  }
}), bd = dd({
  baseStyle: gd,
  variants: {
    desktop: pd,
    mobile: md
  },
  defaultProps: {
    variant: "desktop"
  }
}), { defineMultiStyleConfig: hd, definePartsStyle: ct } = B([
  "container",
  "stepDetails",
  "stepDetailsLabel",
  "icon",
  "verticalDivider",
  "status"
]), fd = ct({
  container: {
    paddingX: "22px",
    paddingY: 6,
    maxWidth: "none",
    "[data-no-click]": {
      cursor: "not-allowed"
    },
    "[aria-disabled]:not([data-no-click])": {
      cursor: "not-allowed",
      opacity: 0.5
    }
  },
  stepDetails: {
    cursor: "pointer",
    color: "teal.500",
    ".gravity-steps__step-label": {
      fontFamily: "body",
      fontSize: "sm",
      fontWeight: "bold",
      lineHeight: "24px"
    },
    ":hover, :focus": {
      ".gravity-steps__step-details": {
        color: "teal.600",
        background: "gray.100",
        borderRadius: "lg"
      },
      _focusVisible: { outline: "none" },
      ".gravity-steps__step-icon": {
        "svg circle": {
          stroke: "teal.600",
          fill: "teal.600"
        }
      },
      ".gravity-steps__step-number": {
        color: "white"
      }
    }
  },
  stepDetailsLabel: {
    paddingX: 2,
    paddingY: 1
  },
  icon: {
    position: "relative",
    width: "20px",
    height: "20px",
    "svg circle": {
      stroke: "gray.600",
      fill: "none"
    },
    ".gravity-steps__step-number": {
      color: "gray.600",
      width: "100%",
      height: "100%",
      textAlign: "center",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: "700",
      position: "relative",
      bottom: "20px",
      lineHeight: "20px"
    }
  },
  verticalDivider: {
    marginLeft: 4,
    border: "2px solid var(--sgi-colors-gray-200)",
    height: "8px",
    width: 0
  },
  status: {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    border: "0px",
    overflow: "hidden"
  }
}), yd = ct({
  stepDetails: {
    color: "teal.700",
    ":hover, :focus": {
      ".gravity-steps__step-details": {
        color: "teal.700"
        // background: 'white',
      },
      _focusVisible: { outline: "none" },
      ".gravity-steps__step-icon": {
        "svg circle": {
          stroke: "teal.700",
          fill: "teal.700"
        }
      },
      ".gravity-steps__step-number": {
        color: "white"
      }
    }
  }
}), xd = ct({
  stepDetails: {
    color: "teal.500",
    "svg.gravity-steps__step-icon": {
      color: "green.500"
    },
    hr: {
      borderColor: "green.500"
    }
  }
}), vd = ct({}), Cd = hd({
  baseStyle: fd,
  variants: {
    active: yd,
    complete: xd,
    default: vd
  }
}), { defineMultiStyleConfig: Sd, definePartsStyle: wd } = B([
  "container",
  "content",
  "graphic"
]), kd = wd({
  container: {
    flexDirection: "row",
    gap: "40px"
  },
  content: {
    p: { base: "16px", md: "40px" },
    flex: 1
  },
  graphic: {}
}), Id = Sd({
  baseStyle: kd
}), Oe = se("close-button-size"), $d = N({
  color: "gray.700",
  w: [Oe.reference],
  h: [Oe.reference],
  borderRadius: "lg",
  transitionProperty: "common",
  transitionDuration: "normal",
  _disabled: {
    color: "gray.800",
    opacity: 0.5,
    cursor: "not-allowed",
    boxShadow: "none",
    _hover: { bg: "none" }
  },
  _hover: { bg: "blackAlpha.100" },
  _active: { bg: "blackAlpha.200" },
  _focusVisible: {
    boxShadow: "outline"
  }
}), Md = {
  lg: N({
    [Oe.variable]: "40px",
    fontSize: "15px"
  }),
  md: N({
    [Oe.variable]: "32px",
    fontSize: "15px"
  }),
  sm: N({
    [Oe.variable]: "24px",
    fontSize: "10px"
  })
}, Nd = te({
  baseStyle: $d,
  sizes: Md,
  defaultProps: {
    size: "md"
  }
}), zd = (e) => typeof e == "function";
function po(e, ...o) {
  return zd(e) ? e(...o) : e;
}
const { defineMultiStyleConfig: Dd, definePartsStyle: _d } = B(En.keys), Ad = N({
  bg: "white",
  boxShadow: "lg",
  minW: "3xs",
  p: "2",
  zIndex: Le.popover,
  borderRadius: "lg",
  borderWidth: "1px",
  borderColor: "gray.200",
  gap: "4px 0px",
  display: "flex",
  flexWrap: "wrap",
  flexDir: "column"
}), Ld = N({
  textStyle: "bodySmall",
  py: "0.5",
  px: "2",
  transitionProperty: "background",
  transitionDuration: "ultra-fast",
  transitionTimingFunction: "ease-in",
  alignItems: "start",
  _focus: {
    color: "inherit",
    bg: "gray.100",
    borderRadius: "lg"
  },
  _hover: {
    color: "inherit",
    bg: "gray.100",
    borderRadius: "lg"
  },
  _active: {
    color: "inherit",
    bg: "teal.100",
    borderRadius: "lg"
  },
  _disabled: {
    opacity: 0.5,
    cursor: "not-allowed",
    _active: { bg: "inherit" },
    _focus: { bg: "inherit" }
  },
  "span.chakra-menu__icon-wrapper": {
    display: "inline"
  }
}), Td = N({
  mx: 2,
  my: 1,
  textStyle: "bodyBoldSmall"
}), Bd = N({
  opacity: 0.6
}), Pd = N({
  border: 0,
  borderBottom: "1px solid",
  borderColor: "inherit",
  my: "2",
  opacity: 0.6
}), Rd = N({
  transitionProperty: "common",
  transitionDuration: "normal",
  textStyle: "body",
  _focus: {
    boxShadow: "outline"
  }
}), Hd = _d((e) => ({
  button: Rd,
  list: po(Ad, e),
  item: po(Ld, e),
  groupTitle: Td,
  command: Bd,
  divider: Pd
})), Ed = Dd({
  baseStyle: Hd
}), { defineMultiStyleConfig: Fd, definePartsStyle: jd } = B(Fn.keys), Od = N({
  bg: "blackAlpha.400",
  zIndex: "modal"
}), Wd = N((e) => {
  const { isCentered: o, scrollBehavior: r } = e;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: o ? "center" : "flex-start",
    overflow: r === "inside" ? "hidden" : "auto"
  };
}), Gd = N((e) => {
  const { scrollBehavior: o } = e;
  return {
    borderRadius: "lg",
    bg: "white",
    color: "inherit",
    my: "3.75rem",
    zIndex: "modal",
    maxH: o === "inside" ? "calc(100% - 7.5rem)" : void 0,
    boxShadow: "xl",
    p: 6
  };
}), Ud = N({
  textStyle: "subheading2",
  mb: 2,
  pr: "44px"
}), Vd = N({
  position: "absolute",
  top: 6,
  right: 6
}), Yd = N((e) => {
  const { scrollBehavior: o } = e;
  return {
    textStyle: "body",
    flex: 1,
    overflow: o === "inside" ? "auto" : void 0
  };
}), Zd = N({
  mt: 6
}), Qd = jd((e) => ({
  overlay: Od,
  dialogContainer: Wd(e),
  dialog: Gd(e),
  header: Ud,
  closeButton: Vd,
  body: Yd(e),
  footer: Zd
})), St = (e) => e === "full" ? {
  dialog: {
    maxW: "100vw",
    minH: "100vh",
    "@supports(min-height: -webkit-fill-available)": {
      minH: "-webkit-fill-available"
    },
    my: 0,
    borderRadius: "none"
  }
} : {
  dialog: { maxW: e }
}, Kd = {
  sm: St("sm"),
  xl: St("xl"),
  full: St("full")
}, Xd = Fd({
  baseStyle: Qd,
  sizes: Kd,
  defaultProps: {
    size: "xl"
  }
}), { defineMultiStyleConfig: qd, definePartsStyle: Jd } = B(jn.keys), wt = Rt("popper-bg"), eu = Rt("popper-arrow-bg"), tu = Rt("popper-arrow-shadow-color"), ou = {
  md: Jd({ body: { maxW: "md" } })
}, ru = qd({
  baseStyle: {
    popper: {
      zIndex: "popover"
    },
    content: {
      border: "1px solid",
      borderColor: "gray.200",
      borderRadius: "lg",
      boxShadow: "lg",
      zIndex: "inherit",
      [wt.variable]: "colors.white",
      bg: wt.reference,
      [eu.variable]: wt.reference,
      [tu.variable]: "colors.gray.200",
      _focusVisible: {
        outline: 0,
        boxShadow: "outline"
      },
      ".headerspacer": {
        height: "20px"
      }
    },
    header: {
      paddingLeft: 4,
      paddingRight: 10,
      py: 2,
      borderBottomWidth: "1px",
      borderColor: "gray.200",
      textStyle: "bodyBoldSmall"
    },
    body: {
      py: 2,
      px: 4,
      textStyle: "bodySmall"
    },
    footer: {
      px: 3,
      py: 2,
      borderTopWidth: "1px",
      borderColor: "gray.200"
    },
    closeButton: {
      position: "absolute",
      top: 1,
      insetEnd: 1
    }
  },
  sizes: ou,
  defaultProps: {
    size: "md"
  }
}), mo = se("tooltip-bg"), au = se("popper-arrow-bg"), nu = te({
  baseStyle: {
    textStyle: "bodySmall",
    [mo.variable]: "colors.gray.900",
    [au.variable]: [mo.reference],
    px: 2,
    py: 2,
    bg: "gray.900",
    color: "white",
    borderRadius: "base",
    boxShadow: "lg",
    maxW: "320px",
    zIndex: "tooltip"
  }
}), { defineMultiStyleConfig: iu, definePartsStyle: Ym } = B([
  "container",
  "chatIcon",
  "defaultContent"
]), lu = iu({
  baseStyle: {
    container: {
      bg: "gray.50",
      p: "4",
      h: { base: "fit-content", md: "112px" },
      minH: "72px",
      position: "relative"
    },
    defaultContent: {
      flexDir: { base: "column", md: "row" },
      gap: "0px 16px",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "center",
      mx: { base: "0", md: "80px" },
      "a, p": {
        textStyle: "bodySmall",
        textDecoration: "none"
      }
    },
    chatIcon: {
      borderRadius: "full",
      position: "absolute",
      right: { base: "16px", md: "40px" },
      top: { base: "16px", md: "32px" }
    }
  },
  variants: {
    stickToBottom: {
      container: {
        bottom: "0",
        left: "0",
        position: "fixed",
        zIndex: "1000",
        width: "100%"
      }
    }
  }
}), { defineMultiStyleConfig: su } = B([
  "globalNavTopContainer",
  "globalNavNavContainer",
  "globalNavCategory",
  "globalNavCategoryIcon",
  "globalNavMenu",
  "globalNavMenuSlider",
  "globalNavMenuLink",
  "globalNavSubMenu",
  "globalNavSubMenuLink",
  "globalNavMenuDivider"
]), et = 94, cu = 334, du = su({
  baseStyle: {
    globalNavTopContainer: {
      minH: "100vh",
      pos: "sticky",
      bg: "teal.500",
      zIndex: Le.modal
    },
    globalNavNavContainer: {
      w: `${et}px`,
      h: "full"
    },
    globalNavCategory: {
      w: `${et}px`,
      mx: "auto",
      borderBottom: "1px solid white",
      borderColor: "blackAlpha.200",
      cursor: "pointer",
      display: "block",
      pt: 4,
      px: 2,
      pb: "15px",
      textDecoration: "none",
      "& p": {
        color: "white",
        textStyle: "bodyBoldSmall",
        lineHeight: "20px",
        textAlign: "center"
      },
      _hover: {
        backgroundColor: "white",
        "& p": {
          color: "gray.800"
        },
        "& svg": {
          color: "gray.800"
        }
      },
      _focusVisible: {
        outline: "none",
        boxShadow: "outline",
        backgroundColor: "white",
        "& p": {
          color: "gray.800"
        },
        "& svg": {
          color: "gray.800"
        }
      }
    },
    globalNavCategoryIcon: {
      ..._e["2xl"],
      color: "white",
      fill: "currentColor"
    },
    globalNavMenu: {
      m: "6"
    },
    globalNavMenuSlider: {
      overflow: "hidden",
      whiteSpace: "nowrap",
      position: "absolute",
      left: `${et}px`,
      height: "full",
      minHeight: "100%",
      top: "0",
      backgroundColor: "white",
      boxShadow: "18px 28px 24px rgba(0, 0, 0, 0.04)",
      borderRight: "1px solid #D3D4D6",
      zIndex: Le.modal
    },
    globalNavMenuLink: {
      textStyle: "bodyBoldSmall",
      color: "green.900",
      textDecoration: "none",
      _hover: {},
      _active: {},
      _focusVisible: {
        outline: "none",
        boxShadow: "outline"
      }
    },
    globalNavSubMenu: {
      mt: "2"
    },
    globalNavSubMenuLink: {
      py: "0.5",
      px: "4",
      textStyle: "bodySmall",
      color: "teal.600",
      textDecoration: "none",
      _hover: {
        backgroundColor: "gray.100",
        borderRadius: "lg",
        color: "teal.700"
      },
      _focusVisible: {
        outline: "none",
        boxShadow: "outline",
        backgroundColor: "gray.100",
        borderRadius: "lg",
        color: "teal.700"
      }
    },
    globalNavMenuDivider: {
      borderColor: "blackAlpha.400"
    }
  },
  variants: {
    disabled: {
      globalNavMenuLink: {
        cursor: "not-allowed",
        opacity: 0.5
      },
      globalNavSubMenuLink: {
        cursor: "not-allowed",
        opacity: 0.5,
        _hover: {
          backgroundColor: "none"
        }
      }
    },
    active: {
      globalNavCategory: {
        backgroundColor: "teal.400",
        boxShadow: "inset 6px 0 #99C7CC",
        "& p": {
          color: "white"
        },
        "& svg": {
          color: "white"
        }
      },
      globalNavMenuLink: {
        pl: "3",
        backgroundColor: "gray.100",
        borderLeftWidth: "4px",
        borderStyle: "solid",
        borderColor: "gray.900"
      },
      globalNavSubMenuLink: {
        backgroundColor: "teal.100",
        color: "teal.700",
        borderRadius: "lg"
      }
    },
    open: {
      globalNavCategory: {
        backgroundColor: "white",
        "& p": {
          color: "gray.800"
        },
        "& svg": {
          color: "gray.800"
        }
      }
    }
  },
  defaultProps: {}
}), uu = {
  none: 0,
  "1px": "1px solid"
}, gu = {
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "90em"
}, pu = {
  transparent: "transparent",
  current: "currentColor",
  black: "#000000",
  white: "#FFFFFF",
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.16)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.48)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255, 0.92)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)"
  },
  gray: {
    50: "#F4F4F5",
    100: "#E9EAEA",
    200: "#D3D4D6",
    300: "#BDBFC1",
    400: "#A7A9AD",
    500: "#919498",
    600: "#74767A",
    700: "#57595B",
    800: "#3A3B3D",
    900: "#1D1E1E"
  },
  teal: {
    25: "#F2F8F9",
    50: "#E6F1F2",
    100: "#CCE3E6",
    200: "#99C7CC",
    300: "#66ACB3",
    400: "#339099",
    500: "#007480",
    600: "#005D66",
    700: "#00464D",
    800: "#002E33",
    900: "#00171A"
  },
  blue: {
    50: "#EBF8FF",
    100: "#BEE3F8",
    200: "#90CDF4",
    300: "#63B3ED",
    400: "#4299E1",
    500: "#3182CE",
    600: "#2B6CB0",
    700: "#2C5282",
    800: "#2A4365",
    900: "#1A365D"
  },
  green: {
    50: "#F0FFF4",
    100: "#C6F6D5",
    200: "#9AE6B4",
    300: "#68D391",
    400: "#48BB78",
    500: "#38A169",
    600: "#25855A",
    700: "#276749",
    800: "#22543D",
    900: "#1C4532"
  },
  red: {
    50: "#FFF5F5",
    100: "#FED7D7",
    200: "#FEB2B2",
    300: "#FC8181",
    400: "#F56565",
    500: "#DA3A3A",
    600: "#C53030",
    700: "#9B2C2C",
    800: "#822727",
    900: "#63171B"
  },
  orange: {
    50: "#FFFAF0",
    100: "#FEEBCB",
    200: "#FBD38D",
    300: "#F6AD55",
    400: "#ED8936",
    500: "#DD6B20",
    600: "#C05621",
    700: "#9C4221",
    800: "#7B341E",
    900: "#652B19"
  }
}, mu = {
  none: "0",
  base: "4px",
  lg: "8px",
  "2xl": "16px",
  full: "9999px"
}, bu = {
  none: "none",
  outline: "0 0 0 3px var(--sgi-colors-teal-200)",
  invalidOutline: "0 0 0 3px var(--sgi-colors-red-200)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
}, Oo = {
  px: "1px",
  0.5: "0.125rem",
  1: "0.25rem",
  1.5: "0.375rem",
  2: "0.5rem",
  2.5: "0.625rem",
  3: "0.75rem",
  3.5: "0.875rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem"
}, hu = {
  max: "max-content",
  min: "min-content",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  full: "100%"
}, fu = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
}, yu = {
  ...Oo,
  ...hu,
  container: fu
}, xu = {
  common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
  colors: "background-color, border-color, color, fill, stroke",
  dimensions: "width, height",
  position: "left, right, top, bottom",
  background: "background-color, background-image, background-position"
}, vu = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
}, Cu = {
  "ultra-fast": "50ms",
  faster: "100ms",
  fast: "150ms",
  normal: "200ms",
  slow: "300ms",
  slower: "400ms",
  "ultra-slow": "500ms"
}, Su = {
  property: xu,
  easing: vu,
  duration: Cu
}, wu = {}, ku = {
  breakpoints: gu,
  zIndices: Le,
  radii: mu,
  blur: wu,
  colors: pu,
  ...ys,
  ...Xc,
  sizes: yu,
  shadows: bu,
  space: Oo,
  borders: uu,
  transition: Su
}, Iu = {
  global: {
    body: {
      fontFamily: "body",
      transitionDuration: "normal",
      lineHeight: "base",
      color: "gray.800"
    },
    "*, *::before, &::after": {
      wordWrap: "break-word"
    },
    ".react-datepicker-popper": {
      zIndex: "popover"
    },
    '.react-datepicker-popper[data-placement^="bottom"]': {
      paddingTop: 2
    },
    '.react-datepicker-popper[data-placement^="top"]': {
      paddingBottom: 2
    },
    '.react-datepicker-popper[data-placement^="right"]': {
      paddingLeft: 2
    },
    '.react-datepicker-popper[data-placement^="left"]': {
      paddingRight: 2
    },
    ".react-datepicker__portal": {
      position: "fixed",
      width: "100vw",
      height: "100vh",
      background: "blackAlpha.800",
      left: 0,
      top: 0,
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      zIndex: 2147483647
    }
  }
}, $u = "ltr", Mu = {
  useSystemColorMode: !1,
  initialColorMode: "light",
  cssVarPrefix: "sgi"
}, Zm = {
  ...ku,
  styles: Iu,
  components: {
    Accordion: El,
    Alert: ws,
    AutoSuggestion: Hs,
    Avatar: rd,
    Badge: Wl,
    Breadcrumb: nd,
    Button: Ge,
    Card: Ul,
    Checkbox: Xs,
    CloseButton: Nd,
    CloseButtonCustom: Yl,
    DatePicker: Js,
    DualInput: rc,
    FileUpload: lc,
    Footer: lu,
    Form: cc,
    FormError: gc,
    FormLabel: dc,
    GlobalHeader: ld,
    GlobalHeaderv2: cd,
    GlobalNav: du,
    GlobalNavv2: bd,
    Input: Y,
    Link: Lt,
    Menu: Ed,
    Modal: Xd,
    Notification: Is,
    NumberInput: xc,
    PageHeader: Id,
    Pagination: Ql,
    Progress: Ms,
    Radio: Ic,
    RadioGroup: $c,
    ResponseError: zs,
    SgiCanadaLogo: zl,
    SgiLogo: Al,
    Select: Nc,
    Skeleton: Ts,
    Slider: Rc,
    Spinner: Ds,
    Steps: Cd,
    Switch: Gc,
    Table: ql,
    Tabs: fs,
    Tag: ls,
    Textarea: Uc,
    Tooltip: nu,
    Typography: ss,
    Popover: ru
  },
  config: Mu,
  direction: $u
}, Nu = () => /* @__PURE__ */ t("svg", { viewBox: "0 0 800 195", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h("g", { clipPath: "url(#clip0_977_60)", children: [
  /* @__PURE__ */ t(
    "path",
    {
      d: "M800 0H796.248C780.774 0 769.707 8.29795 765.111 23.0291L712.591 194.023H716.155C731.63 194.023 742.79 185.632 747.292 170.9L800 0Z",
      className: "cls-2"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M746.823 0H740.727C725.252 0 714.279 8.29795 709.684 23.0291L657.163 194.023H663.072C678.546 194.023 689.707 185.632 694.209 170.9L746.823 0Z",
      className: "cls-2"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M633.435 0H622.556C607.081 0 595.92 8.29795 591.419 23.0291L538.898 194.023H549.777C565.252 194.023 576.319 185.632 580.821 170.9L633.435 0Z",
      className: "cls-2"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M691.301 0H682.954C667.48 0 656.413 8.29795 651.817 23.0291L599.39 194.023H607.644C623.119 194.023 634.279 185.632 638.781 170.9L691.301 0Z",
      className: "cls-2"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M79.7186 0C60.4924 0 43.517 12.4935 37.8898 30.7677L23.6342 77.1056C17.5381 97.058 32.544 117.29 53.5522 117.29H178.945C179.977 117.29 180.727 118.316 180.445 119.248L171.348 148.71C171.067 149.643 170.223 150.202 169.285 150.202H46.0492C26.6354 150.202 9.56624 162.789 3.93904 181.156L0 193.836H164.127H169.097H175.569C190.95 193.836 204.549 183.86 209.05 169.222L225.275 116.731C231.372 96.7783 216.366 76.5462 195.358 76.5462H69.871C68.8394 76.5462 68.0891 75.5206 68.3705 74.5883L77.4678 45.1259C77.7491 44.1936 78.5932 43.6341 79.5311 43.6341H199.109C218.523 43.6341 235.592 31.0474 241.219 12.68L244.877 0H79.7186Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M315.498 0C296.272 0 279.297 12.4935 273.669 30.7677L238.124 146.193C230.809 169.968 248.722 193.93 273.669 193.93H411.254C426.635 193.93 440.234 183.953 444.736 169.315L446.518 163.442C446.518 163.348 446.612 163.255 446.612 163.162L452.145 145.074L459.179 122.325C459.273 122.045 459.273 121.859 459.367 121.579L460.867 116.824C466.964 96.8715 451.958 76.6395 430.95 76.6395H377.304H330.973C329.379 98.9227 349.637 117.197 372.145 117.197H414.631C415.662 117.197 416.413 118.222 416.131 119.155L407.034 148.617C406.846 149.27 406.284 149.829 405.627 150.016C405.44 150.109 405.158 150.109 404.971 150.109H377.21H282.954C281.923 150.109 281.172 149.083 281.454 148.151L313.154 45.2192C313.435 44.2868 314.279 43.7274 315.217 43.7274H434.982C454.209 43.7274 471.184 31.2338 476.811 12.9597L480.75 0H315.498Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M573.224 0H553.623C534.584 0 517.796 12.4935 512.169 30.5812L461.899 194.023H487.503C502.884 194.023 516.671 183.86 521.172 169.222L573.224 0Z",
      className: "cls-1"
    }
  )
] }) }), Wo = ({ variant: e = "colour", ...o }) => {
  const r = Ht("SgiLogo", { variant: e });
  return /* @__PURE__ */ t(
    ge.span,
    {
      __css: r,
      role: "img",
      "aria-label": "Saskatchewan Government Insurance logo",
      ...o,
      children: /* @__PURE__ */ t(Nu, {})
    }
  );
}, zu = ({ ...e }) => /* @__PURE__ */ t(Wo, { ...e }), Du = () => /* @__PURE__ */ h("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 800 277", fill: "none", children: [
  /* @__PURE__ */ t(
    "path",
    {
      d: "M647.99 0H645.168C633.533 0 625.271 6.21898 621.875 17.3489L582.542 146.226H585.25C596.884 146.226 605.215 139.939 608.611 128.809L647.99 0Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M608.152 0H603.609C591.974 0 583.758 6.24193 580.362 17.3489L540.983 146.204H545.435C557.07 146.204 565.4 139.916 568.796 128.786L608.152 0Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M523.244 0H515.12C503.485 0 495.155 6.21898 491.759 17.3489L452.425 146.226H460.618C472.253 146.226 480.514 139.939 483.91 128.809L523.244 0Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M566.593 0H560.351C548.716 0 540.432 6.24193 537.035 17.3489L497.725 146.204H503.875C515.51 146.204 523.84 139.916 527.237 128.786L566.593 0Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M108.293 0C93.8812 0 81.1449 9.40879 76.9454 23.2007L66.2744 58.128C61.6618 73.1821 72.9294 88.3968 88.672 88.3968H182.645C183.425 88.3968 183.976 89.1541 183.747 89.8884L176.954 112.125C176.747 112.814 176.128 113.273 175.416 113.273H83.0955C68.5693 113.273 55.7641 122.75 51.5187 136.634L48.5813 146.226H171.538H175.233H180.052C191.595 146.226 201.761 138.699 205.134 127.661L217.274 88.0984C221.887 73.0444 210.619 57.8297 194.877 57.8297H100.88C100.1 57.8297 99.5494 57.0724 99.7789 56.338L106.572 34.1011C106.778 33.4127 107.398 32.9537 108.109 32.9537H197.699C212.203 32.9537 225.031 23.4761 229.276 9.59238L232.03 0H108.293Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M284.949 0C270.537 0 257.801 9.40879 253.601 23.2007L227.004 110.198C221.519 128.097 234.921 146.204 253.647 146.204H356.731C368.274 146.204 378.44 138.676 381.813 127.638L383.167 123.232C383.19 123.14 383.236 123.072 383.259 123.003L387.436 109.371L392.691 92.2062C392.737 92.0226 392.783 91.839 392.851 91.6554L393.953 88.0755C398.565 73.0214 387.298 57.8067 371.555 57.8067H331.327H296.583C295.413 74.6278 310.582 88.3968 327.472 88.3968H359.324C360.104 88.3968 360.655 89.1541 360.425 89.8884L353.633 112.125C353.472 112.63 353.082 113.02 352.6 113.181C352.439 113.227 352.279 113.273 352.095 113.273H331.327H260.577C259.797 113.273 259.246 112.515 259.476 111.781L283.227 34.1011C283.434 33.4127 284.054 32.9537 284.765 32.9537H374.516C388.927 32.9537 401.664 23.5449 405.863 9.75302L408.846 0H284.949Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M478.082 0H463.418C449.144 0 436.545 9.38585 432.369 23.0401L394.71 146.226H413.895C425.438 146.226 435.719 138.585 439.092 127.547L478.082 0Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M706.004 226.523C711.649 226.591 715.114 228.703 722.297 232.535C729.847 236.574 737.122 239.534 737.122 239.534L739.325 223.218L800 180.603L791.509 176.082C788.021 174.223 787.057 169.794 789.237 165.687L799.082 147.282L779.37 152.629C774.986 153.822 771.039 151.757 770.144 147.833L767.964 138.263L743.249 160.89L766.84 101.363L757.087 106.549C745.452 112.745 733.312 107.077 733.083 95.3501L732.578 69.0055L720.874 95.3501C715.665 107.077 701.116 112.745 692.12 106.549L684.57 101.363L682.849 160.89L667.749 138.263L661.484 147.856C658.914 151.803 654.095 153.845 650.217 152.652L632.776 147.305L634.795 165.71C635.231 169.794 632.386 174.246 628.117 176.105L617.699 180.626L660.268 223.241L655.541 239.557C655.541 239.557 664.077 236.574 673.348 232.558C682.161 228.726 686.521 226.614 692.189 226.545L683.951 265.351H3.3275L0 276.274H695.448L706.004 226.523Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M427.458 164.424L402.238 246.946H420.849L440.401 183.035H492.86C496.119 183.035 498.46 186.202 497.519 189.323L486.986 223.769C486.137 226.522 483.612 228.381 480.744 228.381H433.31L427.618 246.992H484.783C492.929 246.992 500.112 241.668 502.476 233.889L516.405 188.359C520.031 176.472 511.15 164.447 498.712 164.447H427.458V164.424Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M320.312 164.424H318.5C308.517 164.424 299.728 170.942 296.813 180.488L285.316 218.078L256.815 164.424H233.706L208.485 246.924H213.396C221.543 246.924 228.726 241.6 231.09 233.82L245.088 188.038L276.412 246.969L295.115 246.924L320.312 164.424Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M201.831 164.424H168.9C162.451 164.424 156.462 167.775 153.111 173.282L108.11 246.969H120.571C127.019 246.969 133.009 243.619 136.359 238.111L166.605 188.566C168.716 185.124 172.457 183.013 176.496 183.013H182.852L182.829 228.358H166.146C157.999 228.358 150.816 233.682 148.453 241.462L146.778 246.969H201.808L201.831 164.424Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M395.606 164.424H362.675C356.226 164.424 350.237 167.775 346.886 173.282L301.885 246.969H311.982C319.876 246.969 327.22 242.862 331.351 236.115L360.38 188.589C362.491 185.147 366.232 183.035 370.271 183.035H376.627L376.605 228.381H359.921C351.774 228.381 344.592 233.705 342.228 241.485L340.553 246.992H395.583L395.606 164.424Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M596.128 164.424H563.197C556.748 164.424 550.759 167.775 547.408 173.282L502.407 246.969H512.504C520.398 246.969 527.742 242.862 531.872 236.115L560.902 188.589C563.013 185.147 566.754 183.035 570.793 183.035H577.149L577.126 228.381H560.443C552.296 228.381 545.113 233.705 542.75 241.485L541.075 246.992H596.105L596.128 164.424Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M32.7244 228.358L46.5851 183.035H103.749C111.896 183.035 119.079 177.711 121.442 169.932L123.118 164.424H47.3654C39.2187 164.424 32.0359 169.748 29.6722 177.528L14.6641 226.614C11.566 236.734 19.139 246.946 29.7181 246.946H90.99C99.1367 246.946 106.319 241.622 108.683 233.843L110.358 228.335H32.7244V228.358Z",
      className: "cls-1"
    }
  )
] }), _u = ({ ...e }) => {
  const o = Ht("SgiCanadaLogo");
  return /* @__PURE__ */ t(ge.span, { __css: o, role: "img", "aria-label": "SGI Canada logo", ...e, children: /* @__PURE__ */ t(Du, {}) });
}, Au = {
  neutral: "gray",
  error: "red",
  success: "green",
  warning: "orange",
  info: "blue",
  recommendation: "teal"
}, Vt = ({ children: e, status: o = "neutral", ...r }) => /* @__PURE__ */ t(Do, { colorScheme: Au[`${o}`], ...r, children: e }), Qm = ({
  children: e,
  bodyClassName: o,
  bodyStyleProps: r,
  "data-testid": a,
  id: n,
  title: i,
  titleClassName: l,
  titleStyleProps: s,
  ...d
}) => /* @__PURE__ */ h(Fr, { id: n, "data-testid": a, ...d, children: [
  i && /* @__PURE__ */ t(
    jr,
    {
      className: l,
      id: n && `${n}-title`,
      "data-testid": a && `${a}-title`,
      ...s,
      children: i
    }
  ),
  /* @__PURE__ */ t(
    Or,
    {
      className: o,
      id: n && `${n}-body`,
      "data-testid": a && `${a}-body`,
      ...r,
      children: e
    }
  )
] }), ee = A((e, o) => {
  const { children: r, isDestructive: a = !1, isFullWidth: n, ...i } = e;
  return /* @__PURE__ */ t(Wr, { ref: o, colorScheme: a ? "red" : void 0, w: n ? "100%" : void 0, ...i, children: r });
});
ee.displayName = "Button";
const K = A((e, o) => {
  const { isFullWidth: r, ...a } = e;
  return /* @__PURE__ */ t(Gr, { ref: o, w: r ? "100%" : void 0, ...a });
});
K.displayName = "IconButton";
const Lu = A((e, o) => {
  const { children: r, spacing: a = 3, ...n } = e;
  return /* @__PURE__ */ t(Ur, { ref: o, spacing: a, ...n, children: r });
});
Lu.displayName = "ButtonGroup";
const P = ({
  __css: e,
  icon: o,
  size: r,
  viewBox: a = `0 0 ${o.icon[0]} ${o.icon[1]}`,
  ...n
}) => {
  const i = E(() => ge(at), []);
  return /* @__PURE__ */ t(
    i,
    {
      __css: { fontSize: "inherit", ...e },
      icon: o,
      ...r && { ..._e[r] },
      width: "1em",
      viewBox: a,
      ...n
    }
  );
}, R = {
  arrowDown: { solid: Un, light: Ni },
  arrowLeft: { solid: Vn, light: zi },
  arrowLeftLongToLine: { solid: Yn, light: Di },
  arrowRight: { solid: Zn, light: _i },
  arrowRightFromBracket: { solid: Qn, light: Ai },
  arrowRightLongToLine: { solid: Kn, light: Li },
  arrowUp: { solid: Xn, light: Ti },
  arrowUpFromBracket: { solid: qn, light: Bi },
  arrowUpRightFromSquare: {
    solid: Jn,
    light: Pi
  },
  atom: { solid: ei, light: Ri },
  bars: { solid: ti, light: Hi },
  bell: { solid: oi, light: Ei },
  calendar: { solid: ri, light: Fi },
  cartShopping: { solid: ai, light: ji },
  check: { solid: Po, light: Oi },
  chevronDown: { solid: ni, light: Wi },
  chevronLeft: { solid: ii, light: Gi },
  chevronRight: { solid: li, light: Ui },
  chevronUp: { solid: si, light: Vi },
  circle: { solid: ci, light: Yi },
  circleCheck: { solid: di, light: Zi },
  circleDot: { solid: ui, light: Qi },
  circleExclamation: { solid: gi, light: Ki },
  circleInfo: { solid: pi, light: Xi },
  circleXmark: { solid: mi, light: qi },
  cloudArrowUp: { solid: bi, light: Ji },
  comment: { solid: hi, light: el },
  creditCard: { solid: fi, light: tl },
  creditCardFront: { solid: yi, light: ol },
  dollarSign: { solid: xi, light: rl },
  eye: { solid: vi, light: al },
  eyeSlash: { solid: Ci, light: nl },
  filter: { solid: Si, light: il },
  magnifyingGlass: { solid: wi, light: ll },
  minus: { solid: Ro, light: sl },
  plus: { solid: ki, light: cl },
  solarSystem: { solid: Ii, light: dl },
  triangleExclamation: { solid: $i, light: ul },
  xmark: { solid: Mi, light: Ho }
}, Tu = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.arrowDown[`${e}`], ...o }), Go = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.arrowRightFromBracket[`${e}`], ...o }), bo = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.arrowUp[`${e}`], ...o }), Bu = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.arrowUpFromBracket[`${e}`], ...o }), Pu = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.arrowUpRightFromSquare[`${e}`], ...o }), Ru = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.bars[`${e}`], ...o }), Uo = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.bell[`${e}`], ...o }), Hu = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.calendar[`${e}`], ...o }), Vo = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.cartShopping[`${e}`], ...o }), Ie = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.chevronDown[`${e}`], ...o }), Yo = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.chevronLeft[`${e}`], ...o }), Zo = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.chevronRight[`${e}`], ...o }), Yt = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.chevronUp[`${e}`], ...o }), Eu = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.circle[`${e}`], ...o }), Zt = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.circleCheck[`${e}`], ...o }), Fu = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.circleDot[`${e}`], ...o }), Qo = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.circleExclamation[`${e}`], ...o }), ju = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.circleInfo[`${e}`], ...o }), Ko = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.circleXmark[`${e}`], ...o }), Ou = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.cloudArrowUp[`${e}`], ...o }), Wu = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.comment[`${e}`], ...o }), Gu = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.creditCard[`${e}`], ...o }), Uu = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.creditCardFront[`${e}`], ...o }), Vu = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.dollarSign[`${e}`], ...o }), Yu = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.eye[`${e}`], ...o }), Zu = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.eyeSlash[`${e}`], ...o }), Qu = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.filter[`${e}`], ...o }), Qt = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.magnifyingGlass[`${e}`], ...o }), Ku = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.solarSystem[`${e}`], ...o }), Xo = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.triangleExclamation[`${e}`], ...o }), qo = ({ variant: e = "solid", ...o }) => /* @__PURE__ */ t(P, { icon: R.xmark[`${e}`], ...o }), Xu = (e) => {
  switch (e) {
    case "lg":
      return "md";
    case "sm":
      return "xs";
    default:
      return "sm";
  }
}, qu = (e) => {
  switch (e) {
    case "lg":
      return "xl";
    case "sm":
      return "xs";
    default:
      return "md";
  }
}, Km = ({ size: e = "md", ...o }) => {
  const r = D("CloseButtonCustom");
  return /* @__PURE__ */ t(
    K,
    {
      sx: r,
      icon: /* @__PURE__ */ t(qo, { variant: "light", size: qu(e), viewBox: "0 100 320 320" }),
      size: Xu(e),
      ...o
    }
  );
}, Jo = ({ children: e, ...o }) => {
  const r = D("FormError");
  return /* @__PURE__ */ h(ge.div, { __css: r.text, ...o, children: [
    /* @__PURE__ */ t(Qo, { variant: "solid", size: "xl", sx: r.icon }),
    /* @__PURE__ */ t(I, { children: e })
  ] });
}, X = ({
  children: e,
  name: o,
  "data-testid": r,
  error: a,
  formHelperText: n,
  hideOptionalLabel: i = !1,
  id: l = o,
  isRequired: s,
  label: d,
  ...g
}) => /* @__PURE__ */ h(
  Vr,
  {
    isInvalid: !!a,
    id: l,
    isRequired: s,
    "data-testid": r,
    ...g,
    children: [
      d && /* @__PURE__ */ h(Yr, { requiredIndicator: /* @__PURE__ */ t(Q, {}), "data-testid": r && `${r}-label`, children: [
        d,
        " ",
        !s && !i && /* @__PURE__ */ t("span", { className: "label-optional", children: "(optional)" })
      ] }),
      e,
      n && /* @__PURE__ */ t(Zr, { "data-testid": r && `${r}-helptext`, children: n }),
      a && /* @__PURE__ */ t(Qr, { "data-testid": r && `${r}-error`, mt: { base: 1, md: 2 }, children: /* @__PURE__ */ t(Jo, { children: a }) })
    ]
  }
), er = A((e, o) => {
  const { size: r = "md", children: a, ...n } = e;
  return /* @__PURE__ */ t(Kr, { ref: o, size: r, ...n, children: a });
});
er.displayName = "SwitchBase";
const Kt = A((e, o) => {
  const {
    name: r,
    error: a,
    hideOptionalLabel: n = !1,
    label: i,
    formHelperText: l,
    isReadOnly: s,
    isRequired: d,
    id: g = r,
    controlStyleProps: p,
    controlClassName: u,
    "data-testid": b,
    ...f
  } = e;
  return /* @__PURE__ */ t(
    X,
    {
      name: r,
      id: g,
      error: a,
      hideOptionalLabel: n,
      label: i,
      formHelperText: l,
      isReadOnly: s,
      isRequired: d,
      "data-testid": b && `${b}-control`,
      className: u,
      ...p,
      children: /* @__PURE__ */ t(er, { ref: o, name: r, "data-testid": b, ...f })
    }
  );
});
Kt.displayName = "Switch";
const Ju = ({ children: e, isLoaded: o = !1, ...r }) => /* @__PURE__ */ t(Xr, { isLoaded: o, ...r, children: e }), z = ({
  children: e,
  as: o,
  variant: r = "body",
  type: a = "primary",
  ...n
}) => {
  const i = !o && (r === "h1" || r === "h2" || r === "h3" || r === "h4") ? r : o, l = D("Typography", { variant: r }), s = qr();
  let d;
  switch (a) {
    case "secondary":
      d = s.colors.gray[600];
      break;
    case "error":
      d = s.colors.red[500];
      break;
    case "link":
      d = s.colors.teal[500];
      break;
    case "primary":
    default:
      d = s.color;
      break;
  }
  return /* @__PURE__ */ t(ge.p, { __css: l, color: d, as: i, ...n, children: e });
}, eg = ({
  allColumns: e,
  id: o
}) => /* @__PURE__ */ h(ve, { children: [
  /* @__PURE__ */ t(Be, { children: /* @__PURE__ */ t(
    ee,
    {
      variant: "tertiary",
      size: "sm",
      rightIcon: /* @__PURE__ */ t(Ie, { size: "sm", variant: "light" }),
      children: "Columns"
    }
  ) }),
  /* @__PURE__ */ t(Ce, { children: /* @__PURE__ */ t(Se, { children: /* @__PURE__ */ t(Et, { children: e.filter((r) => {
    var a;
    return ((a = r.columnDef.meta) == null ? void 0 : a.isToggleable) ?? !0;
  }).map((r, a) => {
    var n;
    return /* @__PURE__ */ h(T, { gap: 2, children: [
      /* @__PURE__ */ t(I, { children: /* @__PURE__ */ t(
        Kt,
        {
          size: "sm",
          isChecked: r.getIsVisible(),
          onChange: r.getToggleVisibilityHandler(),
          name: `${o}--column-toggle-${a}`,
          "aria-labelledby": `${o}--column-label-${a}`
        }
      ) }),
      /* @__PURE__ */ t(z, { variant: "bodySmall", id: `${o}--column-label-${a}`, children: ((n = r.columnDef.meta) == null ? void 0 : n.columnName) ?? r.id })
    ] }, r.id);
  }) }) }) })
] }), tt = ({ children: e, isNumeric: o, colSpan: r, ...a }) => /* @__PURE__ */ t(Jr, { colSpan: r, isNumeric: o, ...a, children: e }), je = ({ children: e, ...o }) => /* @__PURE__ */ t(ea, { ...o, children: e }), kt = ({ addOn: e, content: o, heading: r, icon: a }) => /* @__PURE__ */ h(O, { spacing: 4, children: [
  a,
  /* @__PURE__ */ h(O, { spacing: 1, children: [
    /* @__PURE__ */ t(z, { variant: "subheading2", children: r }),
    /* @__PURE__ */ t(z, { children: o })
  ] }),
  e
] }), tg = ({
  colSpan: e = 1,
  addOn: o,
  error: r,
  searchTerm: a
}) => /* @__PURE__ */ t(je, { children: /* @__PURE__ */ t(tt, { colSpan: e, p: "0", children: /* @__PURE__ */ t(Ze, { bg: "gray.100", py: "46px", px: 6, children: r ? /* @__PURE__ */ t(
  kt,
  {
    addOn: o,
    icon: /* @__PURE__ */ t(Xo, { size: "4xl", color: "red.500", variant: "light" }),
    heading: "Something went wrong!",
    content: "Please try again later."
  }
) : a ? /* @__PURE__ */ t(
  kt,
  {
    addOn: o,
    icon: /* @__PURE__ */ t(Qu, { size: "4xl", variant: "light" }),
    heading: `No results for "${a}" found!`,
    content: "Broaden your filter settings or try searching for something else."
  }
) : /* @__PURE__ */ t(
  kt,
  {
    addOn: o,
    icon: /* @__PURE__ */ t(Qt, { size: "4xl", variant: "light" }),
    heading: "No data yet!",
    content: "Try searching or adding new content."
  }
) }) }) }), tr = A(
  ({ children: e, isNumeric: o, colSpan: r, title: a, ...n }, i) => /* @__PURE__ */ t(ta, { ref: i, colSpan: r, title: a, isNumeric: o, ...n, children: e })
);
tr.displayName = "Th";
const og = (e, o, r) => (r.splice(
  r.indexOf(o),
  0,
  r.splice(r.indexOf(e), 1)[0]
), [...r]), rg = ({
  header: e,
  table: o,
  canReorderColumns: r,
  canSortColumns: a,
  enableMultiRowSelection: n
}) => {
  var c;
  const { getState: i, setColumnOrder: l } = o, { columnOrder: s } = i(), { column: d } = e, [, g] = xl({
    accept: "column",
    drop: (m) => {
      const x = og(m.id, d.id, s);
      l(x);
    }
  }), [{ isDragging: p }, u, b] = vl({
    collect: (m) => ({
      isDragging: m.isDragging()
    }),
    item: () => d,
    type: "column",
    canDrag: () => {
      var m;
      return r && (((m = e.column.columnDef.meta) == null ? void 0 : m.isReorderable) ?? !0);
    }
  }), { isNumeric: f } = e.column.columnDef.meta ?? {};
  return /* @__PURE__ */ t(
    tr,
    {
      ref: (m) => {
        g(m), u(m), b(m);
      },
      colSpan: e.colSpan,
      isNumeric: f,
      width: e.getSize() !== 0 ? `${e.getSize()}px` : void 0,
      opacity: p ? 0.5 : 1,
      children: e.isPlaceholder ? null : /* @__PURE__ */ h(
        T,
        {
          _hover: e.column.getIsSorted() ? {} : { svg: { opacity: 0.4 } },
          gap: 1,
          alignItems: "center",
          justifyContent: f ? "flex-end" : "flex-start",
          ...a && e.column.getCanSort() ? {
            cursor: "pointer",
            userSelect: "none",
            onClick: () => {
              const x = i().sorting.find((y) => y.id === d.id);
              x ? x.desc ? e.column.clearSorting() : e.column.toggleSorting(!0, e.column.getCanMultiSort()) : e.column.toggleSorting(!1, e.column.getCanMultiSort());
            }
          } : r && (((c = e.column.columnDef.meta) == null ? void 0 : c.isReorderable) ?? !0) ? { cursor: "grab", userSelect: "none" } : {},
          children: [
            !(!n && d.id === "select") && Je(e.column.columnDef.header, e.getContext()),
            (a && e.column.getCanSort() && {
              asc: /* @__PURE__ */ t(bo, { size: "md", variant: "solid" }),
              desc: /* @__PURE__ */ t(Tu, { size: "md", variant: "solid" })
            }[e.column.getIsSorted()]) ?? /* @__PURE__ */ t(bo, { size: "md", opacity: 0 })
          ]
        }
      )
    },
    e.id
  );
}, ag = ({ children: e }) => /* @__PURE__ */ h(ve, { children: [
  /* @__PURE__ */ t(Be, { children: /* @__PURE__ */ t(
    ee,
    {
      width: { base: "100%", md: "auto" },
      variant: "tertiary",
      size: "sm",
      rightIcon: /* @__PURE__ */ t(Ie, { size: "sm", variant: "light" }),
      children: "Filter"
    }
  ) }),
  /* @__PURE__ */ t(Ce, { children: /* @__PURE__ */ t(Se, { children: e }) })
] }), ng = ({ children: e, ...o }) => /* @__PURE__ */ t(oa, { ...o, children: e }), ig = ra`
    from {
        opacity: 0%;
        transform: translate(0, -5px)
    }

    to {
        opacity: unset;
        transform: none;
    }
`, lg = ({ children: e }) => {
  const o = aa();
  return /* @__PURE__ */ t(I, { overflow: "hidden", children: /* @__PURE__ */ t(I, { animation: o ? void 0 : `${ig} 0.2s ease-in`, children: e }) });
}, sg = ({ onClick: e }) => /* @__PURE__ */ t(
  K,
  {
    onClick: e,
    borderLeftRadius: "none",
    "aria-label": "Search",
    className: "search-input-button",
    icon: /* @__PURE__ */ t(Qt, { variant: "light" })
  }
), Ye = A((e, o) => {
  const {
    inputLeftAddon: r,
    inputRightAddon: a,
    inputLeftElement: n,
    inputLeftElementOverride: i,
    inputRightElement: l,
    inputRightElementOverride: s,
    maxW: d,
    maxWidth: g,
    minW: p,
    minWidth: u,
    onSearchClick: b,
    size: f = "md",
    showSearchButton: c = !1,
    type: m,
    variant: x = "outline",
    w: y,
    width: v,
    ...S
  } = e;
  return /* @__PURE__ */ h(
    na,
    {
      size: f,
      variant: x,
      w: y,
      width: v,
      maxW: d,
      maxWidth: g,
      minW: p,
      minWidth: u,
      children: [
        n && !i && /* @__PURE__ */ t(_o, { pointerEvents: "none", children: n }),
        i,
        r && /* @__PURE__ */ t(ia, { children: r }),
        r && x === "filled" && /* @__PURE__ */ t(De, { orientation: "vertical", marginLeft: "-1px" }),
        /* @__PURE__ */ t(la, { ref: o, type: m, ...S }),
        l && !s && /* @__PURE__ */ t(Ft, { pointerEvents: "none", children: l }),
        s,
        a && x === "filled" && /* @__PURE__ */ t(De, { orientation: "vertical", marginRight: "1px" }),
        a && /* @__PURE__ */ t(sa, { children: a }),
        m === "search" && c && /* @__PURE__ */ t(sg, { onClick: b })
      ]
    }
  );
});
Ye.displayName = "InputBase";
const dt = A((e, o) => {
  const {
    name: r,
    controlStyleProps: a,
    controlClassName: n,
    "data-testid": i,
    error: l,
    formHelperText: s,
    hideOptionalLabel: d = !1,
    id: g = r,
    isDisabled: p,
    isReadOnly: u,
    isRequired: b,
    label: f,
    variant: c,
    ...m
  } = e;
  return /* @__PURE__ */ t(
    X,
    {
      name: r,
      hideOptionalLabel: d,
      id: g,
      error: l,
      label: f,
      isDisabled: p,
      isReadOnly: u,
      isRequired: b,
      formHelperText: s,
      "data-testid": i && `${i}-control`,
      className: n,
      ...a,
      children: /* @__PURE__ */ t(
        Ye,
        {
          ref: o,
          name: r,
          "data-testid": i,
          variant: u ? "filled" : c,
          ...m
        }
      )
    }
  );
});
dt.displayName = "Input";
const cg = ({
  isSearchBtnDisplayed: e,
  onClick: o
}) => /* @__PURE__ */ t(
  Ft,
  {
    className: e ? "input-clear-element search-button-repos" : "input-clear-element",
    children: /* @__PURE__ */ t(
      K,
      {
        variant: "ghost",
        "aria-label": "Clear field",
        onClick: o,
        icon: /* @__PURE__ */ t(Ko, { variant: "solid" })
      }
    )
  }
), ie = (e) => co.Children.toArray(e).filter(
  (o) => co.isValidElement(o)
), xe = (...e) => e.filter(Boolean).join(" "), dg = (e) => /\.$/.test(e) ? e : e + ".", or = A((e, o) => {
  const {
    onSearch: r,
    className: a,
    hasButton: n,
    onChange: i,
    onClear: l,
    placeholder: s = "Search...",
    size: d = "md",
    wait: g = 300,
    ...p
  } = e, u = le(null), b = o || u, [f, c] = V(!1), m = Fo(r, g), x = xe(
    n ? "search-input-with-button" : "search-input-no-button",
    a
  ), y = (C) => {
    c(C !== "");
  }, v = (C) => {
    l == null || l(), C != null && C.current && (C.current.value = "", C.current.focus()), c(!1);
  }, S = (C) => {
    var M;
    C.current && r((M = C.current) == null ? void 0 : M.value);
  };
  return /* @__PURE__ */ t(
    dt,
    {
      ref: b,
      type: "search",
      className: x,
      placeholder: s,
      size: d,
      variant: "outline",
      inputLeftElementOverride: n ? void 0 : /* @__PURE__ */ t(_o, { pointerEvents: "none", className: "search-input-left-element-icon", children: /* @__PURE__ */ t(Qt, { variant: "light" }) }),
      inputRightElementOverride: f ? /* @__PURE__ */ t(
        cg,
        {
          isSearchBtnDisplayed: n,
          onClick: () => {
            v(b), !n && m("");
          }
        }
      ) : void 0,
      showSearchButton: !!n,
      onChange: (C) => {
        i == null || i(C), y(C.target.value), !n && m(C.target.value);
      },
      onSearchClick: n ? () => S(b) : void 0,
      ...p
    }
  );
});
or.displayName = "SearchInput";
const ug = ({ children: e, onSearch: o }) => /* @__PURE__ */ h(
  T,
  {
    gap: { base: 2, md: 4 },
    alignItems: { base: "flex-start", md: "center" },
    flexDirection: { base: "column", md: "row" },
    justifyContent: "space-between",
    pt: { base: 4, md: 0 },
    px: { base: 4, md: 0 },
    children: [
      o ? /* @__PURE__ */ t(
        or,
        {
          size: "sm",
          width: { base: "100%", md: "300px" },
          name: "search",
          onSearch: o,
          "aria-label": "Table search"
        }
      ) : /* @__PURE__ */ t("div", {}),
      /* @__PURE__ */ t(T, { justifyContent: "flex-end", mb: { base: 4, md: 0 }, width: "100%", gap: { base: 2, md: 3 }, children: e })
    ]
  }
), Te = A((e, o) => {
  const { children: r, options: a, size: n = "md", variant: i = "outline", ...l } = e;
  return /* @__PURE__ */ t(
    ca,
    {
      ref: o,
      size: n,
      variant: i,
      icon: /* @__PURE__ */ t(Ie, { variant: "light" }),
      ...l,
      children: a ? a.map(({ disabled: s, key: d, label: g, value: p }) => /* @__PURE__ */ t("option", { disabled: s, value: p, children: g }, d ?? p)) : r
    }
  );
});
Te.displayName = "SelectBase";
const gg = () => /* @__PURE__ */ t(
  K,
  {
    as: "div",
    variant: "ghost",
    size: "sm",
    "aria-label": "",
    icon: /* @__PURE__ */ t(Zo, { fontSize: { base: k.sm, md: k.md }, variant: "light" })
  }
), pg = () => /* @__PURE__ */ t(
  K,
  {
    as: "div",
    variant: "ghost",
    size: "sm",
    "aria-label": "",
    icon: /* @__PURE__ */ t(Yo, { fontSize: { base: k.sm, md: k.md }, variant: "light" })
  }
), mg = xt.default ? xt.default : xt, bg = ({ className: e, testId: o, ...r }) => /* @__PURE__ */ t(I, { "data-testid": o, children: /* @__PURE__ */ t(mg, { containerClassName: e, ...r }) }), hg = ge(bg, {
  shouldForwardProp: () => !0
}), fg = ({
  itemsCount: e,
  itemsPerPage: o = 10,
  marginPagesDisplayed: r = 1,
  onPageClick: a,
  pageCount: n,
  pageRangeDisplayed: i = 3,
  testId: l,
  ...s
}) => {
  const d = D("Pagination"), [g, p] = V(0);
  oe(() => {
    e && p(Math.ceil(e / o));
  }, [e, o]);
  const u = (b) => {
    const f = b.selected * o % e;
    a == null || a({ ...b, offset: f });
  };
  return /* @__PURE__ */ t(
    hg,
    {
      sx: d.container,
      breakLabel: "...",
      nextLabel: /* @__PURE__ */ t(gg, {}),
      previousLabel: /* @__PURE__ */ t(pg, {}),
      onPageChange: u,
      pageRangeDisplayed: i,
      pageCount: n ?? g,
      marginPagesDisplayed: r,
      testId: l,
      ...s
    }
  );
}, yg = ({
  id: e,
  pageSize: o,
  onPageSizeChange: r,
  pageSizeOptions: a = [10, 25, 50, 100],
  totalCount: n,
  currentPage: i,
  isManual: l,
  pageCount: s,
  onPageClick: d
}) => {
  const g = E(
    () => l ? Math.ceil(n / o) : s,
    [l, o, n, s]
  ), p = E(
    () => i && o && i * o,
    [i, o]
  ), u = E(
    () => i * o + o,
    [i, o]
  );
  return /* @__PURE__ */ h(
    T,
    {
      gap: 2,
      flexDirection: { base: "column", md: "row" },
      justifyContent: "space-between",
      py: 3,
      px: 6,
      children: [
        /* @__PURE__ */ h(
          T,
          {
            alignItems: "center",
            justifyContent: { base: "space-between", md: "flex-start" },
            gap: 2,
            children: [
              /* @__PURE__ */ t(z, { id: `${e}--pageSize-label`, variant: "bodySmall", children: "Show rows per page:" }),
              /* @__PURE__ */ t(I, { maxW: "100px", children: /* @__PURE__ */ t(
                Te,
                {
                  size: "sm",
                  value: o.toString(),
                  onChange: ({ currentTarget: b }) => {
                    r == null || r(Number(b.value));
                  },
                  options: a.map((b) => ({
                    label: b.toString(),
                    value: b.toString()
                  })),
                  "aria-labelledby": `${e}--pageSize-label`,
                  name: `${e}--pageSize`
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ h(
          T,
          {
            gap: 6,
            justifyContent: { base: "space-between", md: "flex-start" },
            alignItems: "center",
            children: [
              /* @__PURE__ */ h(z, { variant: "bodySmall", role: "status", "aria-live": "polite", children: [
                `${p + 1}-${u > n ? n : u}`,
                " ",
                /* @__PURE__ */ h(I, { as: "span", color: "gray.600", children: [
                  "of ",
                  n
                ] })
              ] }),
              g > 1 && /* @__PURE__ */ t(
                fg,
                {
                  itemsCount: n,
                  itemsPerPage: o,
                  pageCount: g,
                  onPageClick: ({ selected: b }) => d == null ? void 0 : d(b),
                  renderOnZeroPageCount: () => null,
                  forcePage: i,
                  nextAriaLabel: `Next ${o} rows`,
                  previousAriaLabel: `Previous ${o} rows`
                }
              )
            ]
          }
        )
      ]
    }
  );
}, xg = ({ children: e }) => /* @__PURE__ */ t(da, { children: e }), vg = (e) => /* @__PURE__ */ t(ua, { ...e }), ho = ({
  onClick: e,
  "aria-label": o,
  isExpanded: r = !1
}) => /* @__PURE__ */ t(
  K,
  {
    onClick: e,
    "aria-label": o,
    variant: "ghost",
    size: "sm",
    icon: /* @__PURE__ */ t(
      Ie,
      {
        variant: "light",
        size: "md",
        rotation: r ? 180 : void 0,
        style: { transition: "transform .2s ease" }
      }
    ),
    role: "switch",
    "aria-checked": r
  }
), Cg = "gravity-table", Xm = ({
  actions: e,
  caption: o,
  columns: r,
  columnsControl: a = !1,
  columnOrder: n,
  columnVisibility: i,
  data: l,
  debugAll: s,
  debugColumns: d,
  debugHeaders: g,
  debugRows: p,
  debugTable: u,
  dndContext: b,
  emptyStateAddon: f,
  enableMultiRowSelection: c = !0,
  enableMultiSort: m = !1,
  error: x,
  expanded: y,
  getRowAccessibilityName: v,
  getRowCanExpand: S,
  getSubRows: C,
  id: M,
  isLoading: _ = !1,
  onColumnOrderChange: G,
  onColumnVisibilityChange: j,
  onExpandedChange: L,
  onPageChange: w,
  onPageSizeChange: F,
  onRowSelectionChange: W,
  onSearch: U,
  onSortingChange: me,
  pageCount: $r,
  pageIndex: bt = 0,
  pageSize: Pe = 10,
  renderEmptyState: oo,
  renderFilterComponent: ht,
  renderSubComponent: ce,
  rowSelection: J,
  searchTerm: Mr,
  selectedActions: Me,
  selectedLabel: ft = (be) => `Selected items: ${be.length}`,
  sorting: Nr,
  totalCount: ro,
  ...zr
}) => {
  const be = `${Cg}-${M || Wt()}`, Dr = D("Table"), [ao, no] = V({}), _r = E(
    () => y || ao,
    [y, ao]
  ), Ar = E(
    () => L || no,
    [L, no]
  ), [Re, Lr] = V(!1), q = ae({ base: !0, md: !1 }, { fallback: "md" }), Tr = E(() => q ? r.reduce((H, $, Ne) => (Ne > 0 && $.id && (H[$.id] = !1), H), {}) : i, [i, q, r]), Br = E(
    () => ({
      pageIndex: bt,
      pageSize: Pe
    }),
    [bt, Pe]
  ), io = E(() => {
    let H = r;
    return q && r.map(($, Ne) => (Ne > 0 && ($.meta = $.meta || {}), $)), (ce && !q || q && !Re && (H.length > 1 || ce)) && (H = [
      ...H,
      {
        id: "expand",
        size: 16,
        enableSorting: !1,
        meta: {
          isReorderable: !1,
          isToggleable: !1
        },
        header: ({ table: $ }) => /* @__PURE__ */ t(
          ho,
          {
            onClick: $.getToggleAllRowsExpandedHandler(),
            "aria-label": "Expand all rows",
            isExpanded: $.getIsAllRowsExpanded()
          }
        ),
        cell: ({ row: $ }) => /* @__PURE__ */ t(Q, { children: $.getCanExpand() || q ? /* @__PURE__ */ t(
          ho,
          {
            onClick: $.getToggleExpandedHandler(),
            "aria-label": `Expand ${v ? `${v($)} row` : `row ${$.id}`}`,
            isExpanded: $.getIsExpanded()
          }
        ) : ce ? null : "" })
      }
    ]), W && (!q || Re) && (H = [
      {
        id: "select",
        size: 16,
        enableSorting: !1,
        meta: {
          isReorderable: !1,
          isToggleable: !1
        },
        header: ({ table: $ }) => /* @__PURE__ */ t(T, { alignItems: "center", children: /* @__PURE__ */ t(
          ot,
          {
            "aria-label": "Select all rows",
            size: "sm",
            isChecked: $.getIsAllRowsSelected(),
            isIndeterminate: $.getIsSomeRowsSelected(),
            onChange: $.getToggleAllRowsSelectedHandler(),
            name: `${be}--select-all`
          }
        ) }),
        cell: ({ row: $ }) => /* @__PURE__ */ t(T, { alignItems: "center", children: /* @__PURE__ */ t(
          ot,
          {
            "aria-label": `Select ${v ? `${v($)} row` : `row ${$.id}`}`,
            size: "sm",
            isChecked: $.getIsSelected(),
            isIndeterminate: $.getIsSomeSelected(),
            onChange: $.getToggleSelectedHandler(),
            name: `${be}--select-row-${$.id}`
          }
        ) })
      },
      ...H
    ]), _ && (H = H.map(($) => ({
      ...$,
      cell: () => /* @__PURE__ */ t(I, { py: 2, children: /* @__PURE__ */ t(Ju, { width: "100%", height: 3.5 }) })
    }))), H;
  }, [
    r,
    W,
    _,
    v,
    q,
    Re
  ]);
  oe(() => {
    if (G) {
      let H = n ?? [];
      (L || ce || q) && (H = [...H, "expand"]), W && (H = ["select", ...H]), G(H);
    }
  }, []);
  const Pr = E(
    () => _ ? new Array(Pe).fill({}) : l ?? [],
    [_, l, Pe]
  ), he = gl({
    data: Pr,
    columns: io,
    defaultColumn: {
      minSize: 0,
      size: 0
    },
    state: {
      rowSelection: J,
      pagination: Br,
      expanded: _r,
      sorting: Nr,
      columnVisibility: Tr,
      columnOrder: n
    },
    onColumnOrderChange: G,
    onSortingChange: me,
    onExpandedChange: Ar,
    getSubRows: C,
    manualPagination: !!w,
    onRowSelectionChange: W,
    getCoreRowModel: pl(),
    getExpandedRowModel: ml(),
    getSortedRowModel: bl(),
    debugAll: s,
    debugColumns: d,
    debugHeaders: g,
    debugRows: p,
    debugTable: u,
    manualSorting: !!me,
    enableMultiSort: m,
    enableMultiRowSelection: c,
    getRowCanExpand: q ? () => !0 : S,
    manualExpanding: !!ce,
    onColumnVisibilityChange: j
  }), lo = !!w && (ro ?? 0) > 0, He = J || a || ht || U || e, Rr = !!G, Hr = !!me;
  return oe(() => {
    W == null || W({});
  }, [Re]), /* @__PURE__ */ t(Cl, { backend: Sl, context: b ?? window, children: /* @__PURE__ */ h(I, { position: "relative", border: "1px solid", borderColor: "gray.200", borderRadius: "lg", children: [
    He && /* @__PURE__ */ t(I, { px: { base: 0, md: 6 }, py: { base: 0, md: 5 }, children: /* @__PURE__ */ t(hl, { children: /* @__PURE__ */ h(fl, { features: yl, children: [
      J && !!Object.keys(J).length && /* @__PURE__ */ h(Q, { children: [
        /* @__PURE__ */ h(
          T,
          {
            display: { base: "none", md: "flex" },
            zIndex: "banner",
            borderRadius: "lg",
            backgroundColor: "gray.100",
            width: { base: "100%", md: "calc(100% - 48px)" },
            position: "absolute",
            as: yt.div,
            direction: { base: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { md: "center" },
            px: 3,
            py: 2,
            gap: 2,
            initial: { y: "-24px", opacity: 0 },
            animate: {
              y: -8,
              opacity: 1,
              transition: {
                type: "spring",
                stiffness: 700,
                damping: 30
              }
            },
            exit: { y: "-16px", opacity: 0 },
            children: [
              /* @__PURE__ */ t(z, { as: "span", variant: "bodyBoldSmall", children: ft(Object.keys(J)) }),
              Me == null ? void 0 : Me(Object.keys(J))
            ]
          }
        ),
        /* @__PURE__ */ h(
          T,
          {
            display: { base: "flex", md: "none" },
            zIndex: "banner",
            borderRadius: "lg",
            backgroundColor: "gray.100",
            width: { base: "100%", md: "calc(100% - 48px)" },
            position: "absolute",
            as: yt.div,
            direction: { base: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { md: "center" },
            px: 3,
            py: 2,
            gap: 2,
            initial: { y: "-24px", opacity: 0 },
            animate: {
              y: 0,
              opacity: 1,
              transition: {
                type: "spring",
                stiffness: 700,
                damping: 30
              }
            },
            exit: { y: "-16px", opacity: 0 },
            children: [
              /* @__PURE__ */ t(z, { as: "span", variant: "bodyBoldSmall", children: ft(Object.keys(J)) }),
              Me == null ? void 0 : Me(Object.keys(J))
            ]
          }
        )
      ] }),
      He && /* @__PURE__ */ h(Q, { children: [
        /* @__PURE__ */ t(
          yt.div,
          {
            animate: {
              y: Object.keys(J ?? {}).length ? 20 : 0,
              opacity: Object.keys(J ?? {}).length ? 0 : 1,
              transition: {
                type: "spring",
                stiffness: 700,
                damping: 30
              }
            },
            children: /* @__PURE__ */ h(ug, { onSearch: U, children: [
              ht && /* @__PURE__ */ t(ag, { children: ht }),
              a && !q && /* @__PURE__ */ t(eg, { allColumns: he.getAllLeafColumns(), id: be }),
              e
            ] })
          }
        ),
        q && W && /* @__PURE__ */ t(
          Kt,
          {
            mb: 4,
            px: { base: 4, md: 0 },
            name: "select-rows",
            onChange: (H) => Lr(H.target.checked),
            isChecked: Re,
            children: "Select Row(s)"
          }
        )
      ] })
    ] }) }) }),
    /* @__PURE__ */ t(ng, { children: /* @__PURE__ */ h(ga, { width: "100%", minWidth: `${he.getTotalSize()}px`, id: be, ...zr, children: [
      o && /* @__PURE__ */ t(pa, { children: o }),
      /* @__PURE__ */ t(vg, { children: he.getHeaderGroups().map((H) => /* @__PURE__ */ t(
        je,
        {
          sx: {
            "> th:first-of-type": {
              ...He ? {} : { borderTopLeftRadius: "8px" }
            },
            "> th:last-child": {
              ...He ? {} : { borderTopRightRadius: "8px" }
            },
            "> th": {
              ...He ? {} : { borderTop: "none" }
            }
          },
          children: H.headers.map(($) => /* @__PURE__ */ t(
            rg,
            {
              canReorderColumns: Rr,
              header: $,
              table: he,
              canSortColumns: Hr,
              enableMultiRowSelection: c
            },
            $.id
          ))
        },
        H.id
      )) }),
      /* @__PURE__ */ t(xg, { children: he.getRowModel().rows.length === 0 ? oo ? /* @__PURE__ */ t(je, { children: /* @__PURE__ */ t(tt, { colSpan: he.getHeaderGroups()[0].headers.length, children: oo }) }) : /* @__PURE__ */ t(
        tg,
        {
          colSpan: io.length,
          searchTerm: Mr,
          error: x,
          addOn: f
        }
      ) : he.getRowModel().rows.map((H) => /* @__PURE__ */ h(Gn, { children: [
        /* @__PURE__ */ t(je, { _last: lo ? {} : { "> td": { borderBottom: "none" } }, children: H.getVisibleCells().map(($) => {
          var Ne;
          return /* @__PURE__ */ t(
            tt,
            {
              width: $.column.getSize() !== 0 ? `${$.column.getSize()}px` : void 0,
              isNumeric: (Ne = $.column.columnDef.meta) == null ? void 0 : Ne.isNumeric,
              children: Je($.column.columnDef.cell, $.getContext())
            },
            $.id
          );
        }) }),
        H.getIsExpanded() && (q || ce) && /* @__PURE__ */ t(je, { "data-table-row-expander": !0, children: /* @__PURE__ */ h(tt, { p: 0, colSpan: H.getVisibleCells().length, children: [
          q && /* @__PURE__ */ t(Et, { spacing: "0", children: H.getAllCells().filter(($) => !$.column.getIsVisible()).map(($) => /* @__PURE__ */ h(
            ue,
            {
              justifyContent: "space-between",
              px: 4,
              py: 3,
              spacing: 4,
              children: [
                /* @__PURE__ */ t(z, { variant: "bodyBoldSmall", children: Je(
                  $.column.columnDef.header,
                  // Should get header context, but this still seems to work
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  $.getContext()
                ) }),
                /* @__PURE__ */ t(z, { variant: "bodySmall", children: Je($.column.columnDef.cell, $.getContext()) })
              ]
            },
            `${H.id}-${$.id}`
          )) }),
          ce && /* @__PURE__ */ t(lg, { children: ce({ row: H }) })
        ] }) })
      ] }, H.id)) })
    ] }) }),
    lo && /* @__PURE__ */ t(
      yg,
      {
        id: be,
        pageSize: Pe,
        totalCount: ro ?? 0,
        onPageSizeChange: F,
        pageCount: $r ?? 0,
        currentPage: bt,
        onPageClick: w
      }
    ),
    /* @__PURE__ */ t(I, { role: "status", "aria-live": "polite", sx: Dr.status, children: J && Object.keys(J).length ? `${ft(Object.keys(J))}` : "No rows selected" })
  ] }) });
}, qm = ({
  children: e,
  leftIcon: o,
  onCloseClick: r,
  showCloseButton: a = !1,
  ...n
}) => {
  const i = D("Tag");
  return /* @__PURE__ */ h(ma, { colorScheme: a ? "gray" : "teal", ...n, children: [
    o && re(o, {
      size: "sm"
    }),
    /* @__PURE__ */ t(ba, { children: e }),
    a && /* @__PURE__ */ t(
      K,
      {
        "aria-label": `Remove ${typeof e == "string" || typeof e == "number" ? `${e} ` : ""}tag`,
        sx: i.closeButton,
        variant: "ghost",
        icon: /* @__PURE__ */ t(at, { icon: Ho, size: "xs", viewBox: "0 100 320 320" }),
        onClick: r
      }
    )
  ] });
}, Jm = ({
  data: e,
  allowMultiple: o = !0,
  defaultIndex: r = [0],
  ...a
}) => (typeof r == "number" && (r = [r]), e.length > 0 ? /* @__PURE__ */ t(ha, { allowMultiple: o, defaultIndex: r, ...a, children: e.map((n) => /* @__PURE__ */ t(fa, { children: ({ isExpanded: i }) => /* @__PURE__ */ h(Q, { children: [
  /* @__PURE__ */ t("h4", { children: /* @__PURE__ */ h(ya, { children: [
    /* @__PURE__ */ t(I, { flex: "1", textAlign: "left", children: n.title }),
    i ? /* @__PURE__ */ t(Yt, { size: "md", variant: "light" }) : /* @__PURE__ */ t(Ie, { size: "md", variant: "light" })
  ] }) }),
  /* @__PURE__ */ t(xa, { children: n.content })
] }) }, n.title)) }) : null), qe = (e, o) => {
  var r;
  if (e && e.current) {
    const n = e.current.children[0].children, i = n[o].clientWidth;
    let l = 0;
    for (let s = 0; s < o; s++)
      l += n[s].clientWidth;
    (r = e.current) == null || r.scrollTo(
      0 - e.current.offsetWidth / 2 + l + i * 0.5,
      0
    );
  }
}, eb = ({
  data: e,
  defaultIndex: o,
  index: r,
  listStyleProps: a,
  onChange: n,
  panelStyleProps: i,
  tabStyleProps: l,
  ...s
}) => {
  const d = le(null), g = ae({ base: !0, md: !1 }, { fallback: "md" });
  oe(() => {
    g && (r ? qe(d, r) : o ? qe(d, o) : qe(d, 0));
  }, []);
  const p = (u) => {
    g && qe(d, u), n && n(u);
  };
  return e.length > 0 ? /* @__PURE__ */ h(va, { onChange: p, defaultIndex: o, index: r, ...s, children: [
    /* @__PURE__ */ t(ge.div, { className: "tabs-scrollable", ref: d, children: /* @__PURE__ */ t(Ca, { ...a, children: e.map((u) => /* @__PURE__ */ t(
      Sa,
      {
        isDisabled: u.isDisabled,
        "data-testid": u.testId,
        ...l,
        children: u.tab
      },
      `${u.tab}`
    )) }) }),
    /* @__PURE__ */ t(wa, { children: e.map((u) => /* @__PURE__ */ t(
      ka,
      {
        "data-testid": u.testId && `${u.testId}-panel`,
        ...i,
        children: u.content
      },
      `${u.tab}-panel`
    )) })
  ] }) : null;
}, Sg = ({ status: e, ...o }) => {
  const r = Ia(), a = "solid";
  switch (e) {
    case "error":
      return /* @__PURE__ */ t(Qo, { variant: a, sx: r.icon, color: "red.500", ...o });
    case "success":
      return /* @__PURE__ */ t(Zt, { variant: a, sx: r.icon, color: "green.500", ...o });
    case "warning":
      return /* @__PURE__ */ t(Xo, { variant: a, sx: r.icon, color: "orange.500", ...o });
    case "info":
      return /* @__PURE__ */ t(ju, { variant: a, sx: r.icon, color: "blue.500", ...o });
    default:
      return null;
  }
}, wg = (e, o) => e === "toast" ? o ? "40px" : { base: 4, md: 6 } : o ? { base: "48px", md: "60px" } : { base: 4, md: 6 }, Qe = ({
  alertStyleProps: e,
  children: o,
  descriptionStyleProps: r,
  iconStyleProps: a,
  id: n,
  onClose: i,
  showCloseButton: l = !0,
  status: s = "info",
  title: d,
  titleStyleProps: g,
  "data-testid": p,
  variant: u = "left-accent",
  ...b
}) => {
  const f = D("Alert", { variant: u });
  return /* @__PURE__ */ h(
    $a,
    {
      id: n,
      status: s,
      "data-testid": p,
      variant: u,
      addRole: u !== "toast",
      paddingRight: wg(u, l),
      ...e,
      ...b,
      children: [
        /* @__PURE__ */ t(Sg, { status: s, ...a }),
        /* @__PURE__ */ h(
          I,
          {
            width: "100%",
            lineHeight: 0,
            ...(u === "global" || u === "left-accent") && l && {
              borderRightWidth: "1px",
              borderRightColor: "gray.200",
              borderRightStyle: "solid",
              paddingRight: { base: 2, md: 3 }
            },
            children: [
              d && /* @__PURE__ */ t(
                Ma,
                {
                  id: n && `${n}-title`,
                  "data-testid": p && `${p}-title`,
                  ...g,
                  children: d
                }
              ),
              /* @__PURE__ */ t(
                Na,
                {
                  id: n && `${n}-desc`,
                  "data-testid": p && `${p}-desc`,
                  ...r,
                  children: o
                }
              )
            ]
          }
        ),
        l && /* @__PURE__ */ t(za, { sx: f.close, size: "sm", onClick: i })
      ]
    }
  );
}, tb = (e) => /* @__PURE__ */ t(Qe, { status: "info", ...e }), ob = (e) => /* @__PURE__ */ t(Qe, { status: "warning", ...e }), rb = (e) => /* @__PURE__ */ t(Qe, { status: "success", ...e }), ab = (e) => /* @__PURE__ */ t(Qe, { status: "error", ...e }), nb = ({ size: e = "md", ...o }) => /* @__PURE__ */ t(Da, { size: e, ...o }), rr = ({
  className: e,
  size: o = "md",
  value: r = 0,
  variant: a = "normal",
  ...n
}) => (a === "error" && r === 0 && (e = xe("gravity-progress__appear-full", e)), /* @__PURE__ */ t(_a, { size: o, value: r, variant: a, className: e, ...n })), ut = ({
  children: e,
  errorCode: o,
  errorDescription: r,
  actions: a,
  title: n,
  ...i
}) => {
  const l = D("ResponseError");
  return /* @__PURE__ */ h(I, { __css: l.container, ...i, children: [
    n && /* @__PURE__ */ t(z, { as: "h2", variant: "h2", pb: { base: 3, md: 6 }, children: n }),
    e,
    /* @__PURE__ */ t(z, { variant: "bodyBoldSmall", pt: { base: 3, md: 6 }, children: r }),
    /* @__PURE__ */ h(z, { variant: "bodySmall", children: [
      "Error code: ",
      o
    ] }),
    a && /* @__PURE__ */ t(I, { pt: { base: 3, md: 6 }, children: a })
  ] });
}, ib = (e) => /* @__PURE__ */ t(
  ut,
  {
    title: "Something went wrong!",
    errorCode: 500,
    errorDescription: "Internal Server Error",
    ...e,
    children: /* @__PURE__ */ h(O, { align: "stretch", spacing: { base: 3, md: 6 }, children: [
      /* @__PURE__ */ t(z, { variant: "body", children: "An error has occurred and we're working to fix the problem!" }),
      /* @__PURE__ */ t(z, { variant: "body", children: "Please try to refresh the page or try again at a later time. Thanks for your patience!" })
    ] })
  }
), lb = (e) => /* @__PURE__ */ t(
  ut,
  {
    title: "Something went wrong!",
    errorCode: 502,
    errorDescription: "Bad Gateway",
    ...e,
    children: /* @__PURE__ */ h(O, { align: "stretch", spacing: { base: 3, md: 6 }, children: [
      /* @__PURE__ */ t(z, { variant: "body", children: "An error has occurred and we're working to fix the problem!" }),
      /* @__PURE__ */ t(z, { variant: "body", children: "Please try to refresh the page or try again at a later time. Thanks for your patience!" })
    ] })
  }
), sb = (e) => /* @__PURE__ */ t(
  ut,
  {
    title: "We couldn't find this page!",
    errorCode: 404,
    errorDescription: "Not Found",
    ...e,
    children: /* @__PURE__ */ h(O, { align: "stretch", spacing: { base: 3, md: 6 }, children: [
      /* @__PURE__ */ t(z, { variant: "body", children: "It looks like the page may not exist." }),
      /* @__PURE__ */ t(z, { variant: "body", children: "Please check the URL and try again." })
    ] })
  }
), cb = (e) => /* @__PURE__ */ t(
  ut,
  {
    title: "No authorization found!",
    errorCode: 401,
    errorDescription: "Unauthorized",
    ...e,
    children: /* @__PURE__ */ h(O, { align: "stretch", spacing: { base: 3, md: 6 }, children: [
      /* @__PURE__ */ t(z, { variant: "body", children: "This page is not publicly available." }),
      /* @__PURE__ */ t(z, { variant: "body", children: "To access it, you may need to login first." })
    ] })
  }
), db = () => {
  const e = Aa(), o = ({
    description: l,
    duration: s = 5e3,
    position: d = "top-right",
    showCloseButton: g = !0,
    status: p = "info",
    ...u
  }) => {
    e({
      duration: s,
      position: d,
      render: ({ id: b, onClose: f }) => /* @__PURE__ */ t(
        Qe,
        {
          status: p,
          id: b ? `toast-${b}` : void 0,
          onClose: f,
          showCloseButton: g,
          variant: "toast",
          ...u,
          children: l
        }
      )
    });
  };
  return { showToast: o, showInfoToast: (l) => {
    o({ status: "info", ...l });
  }, showWarningToast: (l) => {
    o({ status: "warning", ...l });
  }, showSuccessToast: (l) => {
    o({ status: "success", ...l });
  }, showErrorToast: (l) => {
    o({ status: "error", ...l });
  } };
}, ar = ke(null), Xt = () => {
  const e = pe(ar);
  if (!e)
    throw new Error("useAutoSuggestionContext must be used within an AutoSuggestion component.");
  return e;
}, Bt = (e, o) => o || e, nr = A((e, o) => {
  const { suggestionIndex: r, ...a } = e, { dataTestId: n, handleSelection: i, id: l, keyedSuggestion: s, renderOption: d, suggestions: g } = Xt(), p = D("AutoSuggestion"), { value: u, suggestion: b } = g[r], f = E(
    () => Bt(u, b),
    [u, b]
  ), c = E(
    () => s === r,
    [s, r]
  ), m = E(
    () => d ? d(g[r]) : /* @__PURE__ */ t(z, { children: f }),
    [d, g[r], f]
  );
  return /* @__PURE__ */ t(
    I,
    {
      ref: o,
      role: "option",
      id: `${l}-suggestion-${r}`,
      "data-testid": n && `${n}-suggestion-${r}`,
      "aria-selected": c,
      "aria-label": `Suggestion - ${f}.`,
      onMouseDown: (x) => {
        x.preventDefault(), i(x);
      },
      sx: p.suggestion,
      ...c && { className: "suggestion-focused" },
      ...a,
      children: m
    }
  );
});
nr.displayName = "Suggestion";
const kg = ({ ...e }) => {
  const { id: o, suggestions: r } = Xt();
  return /* @__PURE__ */ t(
    O,
    {
      align: "stretch",
      spacing: 0,
      ...e,
      role: "listbox",
      "aria-label": "Suggestions",
      id: `${o}-suggestions`,
      children: r == null ? void 0 : r.map((a, n) => /* @__PURE__ */ t(nr, { suggestionIndex: n }, a.value))
    }
  );
}, Ig = ({ ...e }) => {
  const { suggestions: o } = Xt(), r = D("AutoSuggestion");
  return /* @__PURE__ */ t(I, { role: "status", "aria-live": "polite", ...e, children: o && o.length > 0 && /* @__PURE__ */ t(I, { sx: r.status, children: "Suggestions available. Press up/down arrow keys to access them." }) });
}, $g = A(
  (e, o) => {
    const {
      name: r,
      "data-testid": a,
      id: n = r,
      formInput: i,
      onSelectOption: l,
      options: s,
      renderOption: d,
      ...g
    } = e, [p, u] = V(!1), [b, f] = V([]), c = Fo(() => f([]), 100), [m, x] = V(-1), y = i || dt, v = D("AutoSuggestion");
    oe(() => {
      s && s.length > 0 ? (f(s), u(!0)) : (u(!1), c());
    }, [s]);
    const S = () => {
      x(-1);
    }, C = () => {
      u(!1), S();
    }, M = () => {
      b.length > 0 && u(!0);
    }, _ = Z(
      (j) => {
        if (b.length > 1) {
          if (j.type === "mousedown") {
            const L = j.currentTarget.id.match(/.*-(\d+)/);
            if (L && L.length > 1) {
              const w = parseInt(L[1]), F = Bt(
                b[w].value,
                b[w].suggestion
              );
              l == null || l(b[w].value, F), S();
            }
          } else if (j.type === "keydown") {
            const L = Bt(
              b[m].value,
              b[m].suggestion
            );
            l == null || l(b[m].value, L), S();
          }
        }
      },
      [m, l, b]
    ), G = (j) => {
      if (p)
        if (j.key === "ArrowUp")
          if (m > 0) {
            const L = m - 1;
            x(L);
          } else
            m === 0 && x(b.length - 1);
        else if (j.key === "ArrowDown")
          if (m < b.length - 1) {
            const L = m + 1;
            x(L);
          } else
            m === b.length - 1 && x(0);
        else
          j.key === "Home" ? x(0) : j.key === "End" ? x(b.length - 1) : j.key === "Enter" && m !== -1 && _(j);
    };
    return /* @__PURE__ */ t(
      ar.Provider,
      {
        value: { dataTestId: a, handleSelection: _, id: n, keyedSuggestion: m, renderOption: d, suggestions: b },
        children: /* @__PURE__ */ h(ve, { isOpen: p, matchWidth: !0, gutter: 4, autoFocus: !1, children: [
          /* @__PURE__ */ t(La, { children: /* @__PURE__ */ t(
            y,
            {
              name: r,
              id: n,
              "data-testid": a,
              ...g,
              autoComplete: "off",
              onBlur: C,
              onFocus: M,
              onKeyDown: G,
              ...b && m > -1 && {
                "aria-activedescendant": `${n}-suggestion-${m}`
              },
              spellCheck: "false",
              autoCorrect: "off",
              "aria-autocomplete": "list",
              "aria-owns": `${n}-suggestions`
            }
          ) }),
          /* @__PURE__ */ t(Ig, {}),
          /* @__PURE__ */ t(Ce, { sx: v.content, children: /* @__PURE__ */ t(Se, { sx: v.body, children: /* @__PURE__ */ t(kg, {}) }) })
        ] })
      }
    );
  }
);
$g.displayName = "AutoSuggestion";
const Mg = ({ minDate: e, maxDate: o, currentYear: r }) => {
  const a = [], n = e ? e.getFullYear() : r - 100, i = o ? o.getFullYear() : r + 25;
  for (let l = n; l <= i; l++)
    a.push(l);
  return a;
}, Pt = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], Ng = Pt.map((e) => ({
  label: e,
  value: e
})), zg = ({
  date: e,
  decreaseMonth: o,
  increaseMonth: r,
  nextMonthButtonDisabled: a,
  prevMonthButtonDisabled: n,
  changeYear: i,
  changeMonth: l,
  minDate: s,
  maxDate: d,
  dataTestId: g
}) => {
  const p = E(() => Mg({
    minDate: s,
    maxDate: d,
    currentYear: (/* @__PURE__ */ new Date()).getFullYear()
  }).map((u) => ({
    label: u.toString(),
    value: u.toString()
  })), [s, d]);
  return /* @__PURE__ */ h(T, { alignItems: "center", gap: 1, justifyContent: "space-between", children: [
    /* @__PURE__ */ t(
      K,
      {
        size: "sm",
        "aria-label": "Previous month",
        icon: /* @__PURE__ */ t(Yo, { variant: "light", size: "md" }),
        "data-testid": g ? `${g}-prev` : void 0,
        isDisabled: n,
        onClick: o,
        variant: "ghost"
      }
    ),
    /* @__PURE__ */ t(
      Te,
      {
        textStyle: "bodyBold",
        minWidth: "125px",
        variant: "filled",
        "data-testid": g ? `${g}-month` : void 0,
        size: "sm",
        name: "month",
        value: e ? Pt[e.getMonth()] : "",
        onChange: ({ target: { value: u } }) => l(Pt.indexOf(u)),
        options: Ng
      }
    ),
    /* @__PURE__ */ t(
      Te,
      {
        textStyle: "bodyBold",
        variant: "filled",
        size: "sm",
        name: "year",
        "data-testid": g ? `${g}-year` : void 0,
        value: e ? `${e.getFullYear()}` : "",
        onChange: ({ target: { value: u } }) => i(+u),
        options: p
      }
    ),
    /* @__PURE__ */ t(
      K,
      {
        size: "sm",
        "aria-label": "Next month",
        icon: /* @__PURE__ */ t(Zo, { variant: "light", size: "md" }),
        "data-testid": g ? `${g}-next` : void 0,
        isDisabled: a,
        onClick: r,
        variant: "ghost"
      }
    )
  ] });
};
function Dg(e) {
  return e.format !== void 0 && e.mask !== void 0;
}
function _g(e) {
  return e.allowLeadingZeros !== void 0 || e.decimalScale !== void 0;
}
const qt = A(
  (e, o) => {
    if (_g(e)) {
      const { decimalScale: r, onChange: a, allowLeadingZeros: n, ...i } = e;
      return /* @__PURE__ */ t(
        wl,
        {
          getInputRef: o,
          allowLeadingZeros: n,
          thousandSeparator: ",",
          decimalScale: r,
          onValueChange: a,
          customInput: Ye,
          ...i
        }
      );
    } else if (Dg(e)) {
      const { format: r, mask: a, onChange: n, ...i } = e;
      return /* @__PURE__ */ t(
        kl,
        {
          getInputRef: o,
          format: r ?? "",
          allowEmptyFormatting: !0,
          mask: a,
          onValueChange: n,
          customInput: Ye,
          ...i
        }
      );
    } else
      return null;
  }
);
qt.displayName = "MaskBase";
const $e = A((e, o) => {
  const {
    name: r,
    controlStyleProps: a,
    controlClassName: n,
    "data-testid": i,
    error: l,
    formHelperText: s,
    hideOptionalLabel: d = !1,
    id: g = r,
    isDisabled: p,
    isReadOnly: u,
    isRequired: b,
    label: f,
    variant: c,
    ...m
  } = e;
  return /* @__PURE__ */ t(
    X,
    {
      name: r,
      hideOptionalLabel: d,
      id: g,
      error: l,
      label: f,
      isDisabled: p,
      isReadOnly: u,
      isRequired: b,
      formHelperText: s,
      "data-testid": i && `${i}-control`,
      className: n,
      ...a,
      children: /* @__PURE__ */ t(
        qt,
        {
          ref: o,
          name: r,
          "data-testid": i,
          variant: u ? "filled" : c,
          ...m
        }
      )
    }
  );
});
$e.displayName = "MaskInput";
const ir = A((e, o) => /* @__PURE__ */ t(
  $e,
  {
    format: "####/##/##",
    mask: ["Y", "Y", "Y", "Y", "M", "M", "D", "D"],
    ...e,
    ref: o
  }
));
ir.displayName = "DateInput";
const lr = A(
  ({ onChange: e, onClick: o, onFocus: r, ...a }, n) => /* @__PURE__ */ t(
    ir,
    {
      ref: n,
      onChange: (i, l) => {
        if (l.event) {
          const { event: s } = l;
          s.currentTarget.value = i.formattedValue, e(l.event);
        }
      },
      onFocus: r,
      onClick: o,
      width: "100%",
      inputRightElement: /* @__PURE__ */ t(Hu, { color: "teal.500", size: "md", variant: "light" }),
      ...a
    }
  )
);
lr.displayName = "CustomInput";
const Ag = vt.default ? vt.default : vt, sr = A(
  ({ className: e, ...o }, r) => /* @__PURE__ */ t(Ag, { calendarClassName: e, ref: r, ...o })
);
sr.displayName = "DatePickerAdapter";
const Lg = ge(sr, {
  baseStyle: {}
}), Tg = A((e, o) => {
  const {
    datePickerOptions: r,
    value: a,
    onChange: n,
    "data-testid": i,
    showTodayButton: l = !0,
    isReadOnly: s,
    isDisabled: d,
    ...g
  } = e, p = D("DatePicker", {}), u = le(), b = Z(
    (f) => {
      if (f.currentTarget.value) {
        const c = new Date(
          f.currentTarget.value.replaceAll("D", "").replaceAll("M", "").replaceAll("Y", "")
        );
        c instanceof Date && !isNaN(c) && n(c, f);
      }
    },
    [n]
  );
  return /* @__PURE__ */ t(I, { children: /* @__PURE__ */ t(
    Lg,
    {
      ref: u,
      dateFormat: "yyyy/MM/dd",
      showPopperArrow: !1,
      onChangeRaw: b,
      onChange: n,
      __css: p.container,
      selected: a,
      "data-testid": i,
      ...r,
      readOnly: s,
      disabled: d,
      todayButton: l ? "Today" : void 0,
      onKeyDown: (f) => {
        var c;
        f.code === "Tab" && f.shiftKey && f.target.nodeName == "INPUT" && ((c = u.current) == null || c.setOpen(!1));
      },
      renderCustomHeader: (f) => /* @__PURE__ */ t(
        zg,
        {
          ...f,
          dataTestId: i,
          minDate: r == null ? void 0 : r.minDate,
          maxDate: r == null ? void 0 : r.maxDate
        }
      ),
      customInput: /* @__PURE__ */ t(lr, { ...g, "data-testid": i, ref: o })
    }
  ) });
});
Tg.displayName = "DatePicker";
const cr = A((e, o) => {
  const { "data-testid": r, id: a, name: n, timeInfo: i, ...l } = e;
  return /* @__PURE__ */ t(
    qt,
    {
      ref: o,
      name: `${n}-input`,
      id: a,
      "data-testid": r ? `${r}-input` : void 0,
      format: "##:##",
      mask: ["H", "H", "M", "M"],
      value: i.timeField,
      ...l
    }
  );
});
cr.displayName = "TimeMask";
const fo = (e, o = !1) => {
  const r = new RegExp(/^(0*\d|1[0-2]):[0-5]\d$/), a = new RegExp(/^(0*\d|1\d|2[0-3]):[0-5]\d$/);
  return (o ? a : r).test(e);
}, Bg = (e, o, r, a = !1) => {
  a || (o === "pm" ? r >= 0 && r < 12 && (r += 12) : r >= 0 && r < 13 && (r = r === 12 && o === "am" ? 0 : r)), e.setHours(r);
}, Pg = (e, o) => {
  o >= 0 && o < 60 ? e.setMinutes(o) : e.setMinutes(0);
}, yo = (e, o, r = !1) => {
  const a = /* @__PURE__ */ new Date();
  a.setSeconds(0);
  const [n, i] = e.replaceAll("H", "").replaceAll("M", "").split(":"), l = parseInt(n, 10), s = parseInt(i, 10);
  return Bg(a, o, l, r), Pg(a, s), a;
}, Rg = (e, o) => `${o.toString().padStart(2, "0")}:${e.getMinutes().toString().padStart(2, "0")}`, Hg = (e, o = !1) => {
  const r = { timeField: "", meridiem: "am" };
  let a = e.getHours();
  return o || (r.meridiem = a >= 12 ? "pm" : "am", a >= 12 && (a -= 12), a === 0 && r.meridiem === "pm" && (a = 12)), r.timeField = Rg(e, a), r;
}, Eg = A((e, o) => {
  const {
    name: r,
    controlStyleProps: a,
    controlClassName: n,
    "data-testid": i,
    error: l,
    formHelperText: s,
    hideOptionalLabel: d = !1,
    id: g = r,
    is24Hour: p = !1,
    isDisabled: u,
    isReadOnly: b,
    isRequired: f,
    label: c,
    onChange: m,
    placeholder: x,
    size: y = "md",
    value: v,
    variant: S = "outline",
    ...C
  } = e, [M, _] = V(
    v ? Hg(v, p) : {
      timeField: "",
      meridiem: "am"
    }
  ), G = D("DualInput"), j = (w, F) => {
    if (F.event) {
      const { event: W } = F;
      W.currentTarget.value = w.formattedValue;
      const U = W.currentTarget.value;
      if (_({ ...M, timeField: U }), U && fo(U, p)) {
        const me = yo(U, M.meridiem, p);
        m(me, W);
      } else
        m(null, W);
    }
  }, L = (w) => {
    const F = w.target.value;
    if (_({ ...M, meridiem: F }), fo(M.timeField)) {
      const W = yo(M.timeField, F);
      m(W, w);
    } else
      m(null, w);
  };
  return /* @__PURE__ */ t(
    X,
    {
      name: r,
      hideOptionalLabel: d,
      id: g,
      error: l,
      label: c,
      isDisabled: u,
      isReadOnly: b,
      isRequired: f,
      formHelperText: s,
      "data-testid": i && `${i}-control`,
      className: n,
      ...a,
      children: /* @__PURE__ */ h(T, { direction: "row", wrap: "nowrap", children: [
        /* @__PURE__ */ t(I, { __css: { ...!p && G.leftElement }, flex: "1", children: /* @__PURE__ */ t(
          cr,
          {
            ref: o,
            name: r,
            id: g,
            className: "dual-input-left",
            "data-testid": i,
            placeholder: x,
            timeInfo: M,
            onChange: j,
            variant: b ? "filled" : S,
            size: y,
            ...C
          }
        ) }),
        !p && /* @__PURE__ */ h(Q, { children: [
          (b || S === "filled") && /* @__PURE__ */ t(
            De,
            {
              orientation: "vertical",
              color: "gray.200",
              height: "auto",
              border: "0px solid",
              borderWidth: "0 0 0 1px"
            }
          ),
          /* @__PURE__ */ t(I, { __css: G.rightElement, maxW: "50%", children: /* @__PURE__ */ h(
            Te,
            {
              name: `${r}-select`,
              id: `${g}-select`,
              className: "dual-input-right",
              "data-testid": i ? `${i}-select` : void 0,
              value: M.meridiem,
              onChange: L,
              variant: b ? "filled" : S,
              size: y,
              "aria-label": "Meridiem select",
              children: [
                /* @__PURE__ */ t("option", { value: "am", children: "AM" }),
                /* @__PURE__ */ t("option", { value: "pm", children: "PM" })
              ]
            }
          ) })
        ] })
      ] })
    }
  );
});
Eg.displayName = "TimeInput";
const Fg = A((e, o) => {
  const { ...r } = e;
  return /* @__PURE__ */ t(
    $e,
    {
      ref: o,
      format: "####",
      mask: "",
      ...r,
      inputRightElement: /* @__PURE__ */ t(Gu, { className: "ccinput-right-icon", variant: "light" })
    }
  );
});
Fg.displayName = "CCCvcInput";
const jg = A((e, o) => {
  const { ...r } = e;
  return /* @__PURE__ */ t($e, { ref: o, format: "##/##", mask: ["M", "M", "Y", "Y"], ...r });
});
jg.displayName = "CCExpiryInput";
var Og = /* @__PURE__ */ ((e) => (e.AE = "American Express", e.Visa = "Visa", e.MC = "Master Card", e.Discover = "Discover", e.UnknownCard = "Unknown Card", e))(Og || {});
const Wg = A((e, o) => {
  const { onChange: r, ...a } = e, n = Z(
    (i, l) => {
      let s;
      switch (i.value.charAt(0)) {
        case "3":
          s = "American Express";
          break;
        case "4":
          s = "Visa";
          break;
        case "5":
          s = "Master Card";
          break;
        case "6":
          s = "Discover";
          break;
        default:
          s = "Unknown Card";
          break;
      }
      r && r({ ...i, ccType: s }, l);
    },
    [r]
  );
  return /* @__PURE__ */ t(
    $e,
    {
      ref: o,
      format: "#### #### #### ####",
      mask: "",
      onChange: n,
      ...a,
      inputRightElement: /* @__PURE__ */ t(Uu, { variant: "light", className: "ccinput-right-icon" })
    }
  );
});
Wg.displayName = "CCNumberInput";
const Gg = A((e, o) => {
  const { name: r, ...a } = e;
  return /* @__PURE__ */ t(
    $e,
    {
      ref: o,
      name: r,
      decimalScale: 2,
      placeholder: "0.00",
      inputLeftAddon: /* @__PURE__ */ t(Vu, { className: "currencyinput-left-addon", variant: "light" }),
      ...a
    }
  );
});
Gg.displayName = "CurrencyInput";
const Ug = A((e, o) => {
  const { ...r } = e;
  return /* @__PURE__ */ t($e, { ref: o, format: "1-###-###-####", mask: "_", ...r });
});
Ug.displayName = "PhoneInput";
const dr = ke(null), Vg = A((e, o) => {
  const {
    children: r,
    name: a,
    formHelperText: n,
    hideOptionalLabel: i = !1,
    id: l = a,
    label: s,
    onChange: d,
    value: g,
    error: p,
    variant: u = "checkbox",
    controlStyleProps: b,
    controlClassName: f,
    "data-testid": c,
    ...m
  } = e, { getCheckboxProps: x } = Il({
    onChange: d,
    value: g
  });
  return /* @__PURE__ */ t(
    X,
    {
      formHelperText: n,
      error: p,
      label: s,
      name: a,
      id: l,
      "data-testid": c && `${c}-control`,
      className: f,
      hideOptionalLabel: i,
      ...b,
      ...m,
      children: /* @__PURE__ */ t(dr.Provider, { value: { getCheckboxProps: x, variant: u, id: l }, children: r })
    }
  );
});
Vg.displayName = "CheckboxGroup";
const Yg = () => {
  const e = pe(dr);
  if (!e)
    throw new Error("useCheckboxGroupContext must be used within a CheckboxGroup");
  return e;
}, ur = ({ isIndeterminate: e, isChecked: o }) => o ? e ? /* @__PURE__ */ t(rt, { as: at, icon: Ro }) : /* @__PURE__ */ t(rt, { as: at, icon: Po }) : null, Zg = A((e, o) => {
  const {
    children: r,
    isDisabled: a = !1,
    isIndeterminate: n = !1,
    size: i = "md",
    value: l,
    id: s,
    ...d
  } = e, { getCheckboxProps: g, variant: p, id: u } = Yg(), b = g({ value: l }), f = s ?? [u, l].join("-");
  return /* @__PURE__ */ t(
    ot,
    {
      ref: o,
      variant: p,
      size: i,
      id: f,
      isDisabled: a,
      isIndeterminate: n,
      icon: /* @__PURE__ */ t(ur, {}),
      ...p === "card" && { alignItems: "start" },
      ...b,
      ...d,
      children: p === "card" ? /* @__PURE__ */ h(O, { align: "stretch", spacing: { base: 2, md: 3 }, children: [
        /* @__PURE__ */ t(I, { className: "checkbox-card-badge-container", children: /* @__PURE__ */ t(Vt, { className: "checkbox-card-selected-badge", status: "recommendation", children: "Selected" }) }),
        /* @__PURE__ */ t(I, { className: "checkbox-card-child-container", children: r })
      ] }) : r
    }
  );
});
Zg.displayName = "Checkbox";
const Qg = A(
  (e, o) => {
    const {
      children: r,
      name: a,
      formHelperText: n,
      hideOptionalLabel: i = !1,
      id: l = a,
      isIndeterminate: s = !1,
      isRequired: d,
      label: g,
      size: p = "md",
      variant: u = "checkbox",
      value: b,
      error: f,
      onChange: c,
      controlStyleProps: m,
      controlClassName: x,
      "data-testid": y,
      ...v
    } = e;
    return /* @__PURE__ */ t(
      X,
      {
        error: f,
        formHelperText: n,
        isRequired: d,
        label: g,
        name: a,
        hideOptionalLabel: i,
        id: l,
        className: x,
        "data-testid": y && `${y}-control`,
        ...m,
        children: /* @__PURE__ */ t(
          ot,
          {
            onChange: (S) => {
              c(S.target.checked);
            },
            isChecked: !!b,
            size: p,
            ref: o,
            variant: u,
            name: a,
            "data-testid": y,
            isIndeterminate: s,
            icon: /* @__PURE__ */ t(ur, {}),
            ...u === "card" && { alignItems: "start" },
            ...v,
            children: u === "card" ? /* @__PURE__ */ h(O, { align: "stretch", spacing: 3, children: [
              /* @__PURE__ */ t(I, { className: "checkbox-card-badge-container", children: /* @__PURE__ */ t(Vt, { className: "checkbox-card-selected-badge", status: "recommendation", children: "Selected" }) }),
              /* @__PURE__ */ t(I, { className: "checkbox-card-child-container", children: r })
            ] }) : r
          }
        )
      }
    );
  }
);
Qg.displayName = "BooleanCheckbox";
const ub = ({
  controlClassName: e,
  controlStyleProps: o,
  error: r,
  input: a,
  isDisabled: n,
  isReadOnly: i,
  isRequired: l,
  leftInputWidth: s,
  select: d,
  selectPosition: g = "left",
  size: p = "md",
  ...u
}) => {
  const b = D("DualInput"), f = g === "left" ? d : a, c = g === "left" ? a : d;
  return /* @__PURE__ */ t(
    X,
    {
      className: e,
      error: r,
      isRequired: l,
      ...o,
      ...u,
      children: /* @__PURE__ */ h(T, { direction: "row", wrap: "nowrap", children: [
        /* @__PURE__ */ t(
          I,
          {
            __css: b.leftElement,
            width: s,
            flex: g === "left" ? void 0 : 1,
            maxW: g === "left" ? "50%" : void 0,
            children: re(f, {
              className: "dual-input-left",
              controlClassName: "dual-input-left-control",
              isInvalid: r,
              isDisabled: n,
              isReadOnly: i,
              isRequired: l,
              size: p
            })
          }
        ),
        (i || f.props.variant === "filled" && c.props.variant === "filled") && /* @__PURE__ */ t(De, { orientation: "vertical", sx: b.divider }),
        /* @__PURE__ */ t(
          I,
          {
            __css: b.rightElement,
            flex: g === "left" ? 1 : void 0,
            maxW: g === "left" ? void 0 : "50%",
            children: re(c, {
              className: "dual-input-right",
              controlClassName: "dual-input-right-control",
              isInvalid: r,
              isDisabled: n,
              isReadOnly: i,
              isRequired: l,
              size: p
            })
          }
        )
      ] })
    }
  );
}, de = (e) => e === "left", Kg = A(
  (e, o) => {
    const {
      children: r,
      name: a,
      className: n,
      controlStyleProps: i,
      controlClassName: l,
      "data-testid": s,
      error: d,
      formHelperText: g,
      formInput: p,
      hideOptionalLabel: u = !1,
      id: b = a,
      isDisabled: f,
      isReadOnly: c,
      isRequired: m,
      label: x,
      selectPosition: y = "left",
      size: v = "md",
      variant: S,
      ...C
    } = e, M = D("DualInput"), _ = p || dt, G = re(r, {
      isInvalid: d,
      isDisabled: f,
      isReadOnly: c,
      isRequired: m,
      size: v,
      variant: c ? "filled" : S,
      className: de(y) ? "dual-input-left" : "dual-input-right",
      controlClassName: de(y) ? "dual-input-left-control" : "dual-input-right-control"
    }), j = /* @__PURE__ */ t(
      _,
      {
        ref: o,
        name: a,
        id: b,
        "data-testid": s,
        className: xe(
          de(y) ? "dual-input-right" : "dual-input-left",
          n
        ),
        controlClassName: de(y) ? "dual-input-right-control" : "dual-input-left-control",
        isInvalid: d,
        isDisabled: f,
        isReadOnly: c,
        isRequired: m,
        size: v,
        variant: c ? "filled" : S,
        ...C
      }
    );
    return /* @__PURE__ */ t(
      X,
      {
        name: a,
        hideOptionalLabel: u,
        id: b,
        error: d,
        label: x,
        isDisabled: f,
        isReadOnly: c,
        isRequired: m,
        formHelperText: g,
        "data-testid": s && `${s}-control`,
        className: l,
        ...i,
        children: /* @__PURE__ */ h(T, { sx: M.container, direction: "row", wrap: "nowrap", children: [
          /* @__PURE__ */ t(I, { ...!de(y) && { flex: 1 }, children: de(y) ? G : j }),
          (c || S === "filled") && /* @__PURE__ */ t(De, { orientation: "vertical", sx: M.divider }),
          /* @__PURE__ */ t(I, { ...de(y) && { flex: 1 }, children: de(y) ? j : G })
        ] })
      }
    );
  }
);
Kg.displayName = "DualInputv2";
const gr = A((e, o) => {
  const {
    defaultValue: r,
    min: a,
    max: n,
    onChange: i,
    precision: l,
    size: s = "md",
    step: d,
    value: g,
    variant: p = "outline",
    ...u
  } = e;
  return /* @__PURE__ */ h(
    Ta,
    {
      defaultValue: r,
      min: a,
      max: n,
      onChange: i,
      precision: l,
      size: s,
      step: d,
      value: g,
      variant: p,
      children: [
        /* @__PURE__ */ t(Ba, { ref: o, ...u }),
        /* @__PURE__ */ h(Pa, { children: [
          /* @__PURE__ */ t(Ra, {}),
          /* @__PURE__ */ t(Ha, {})
        ] })
      ]
    }
  );
});
gr.displayName = "NumberInputBase";
const Xg = A((e, o) => {
  const {
    name: r,
    error: a,
    hideOptionalLabel: n = !1,
    label: i,
    formHelperText: l,
    controlStyleProps: s,
    controlClassName: d,
    id: g = r,
    isDisabled: p,
    isReadOnly: u,
    isRequired: b,
    "data-testid": f,
    variant: c,
    ...m
  } = e;
  return /* @__PURE__ */ t(
    X,
    {
      name: r,
      id: g,
      error: a,
      hideOptionalLabel: n,
      label: i,
      formHelperText: l,
      isDisabled: p,
      isRequired: b,
      isReadOnly: u,
      "data-testid": f && `${f}-control`,
      className: d,
      ...s,
      children: /* @__PURE__ */ t(
        gr,
        {
          ref: o,
          name: r,
          "data-testid": f,
          variant: u ? "filled" : c,
          ...m
        }
      )
    }
  );
});
Xg.displayName = "NumberInput";
const qg = ({
  status: e,
  ...o
}) => {
  const r = "password-requirement-status-icon";
  switch (e) {
    case "error":
      return /* @__PURE__ */ t(
        Ko,
        {
          variant: "solid",
          color: "red.500",
          className: r,
          "aria-label": "x mark",
          ...o
        }
      );
    case "success":
      return /* @__PURE__ */ t(
        Zt,
        {
          variant: "solid",
          color: "green.500",
          className: r,
          "aria-label": "check mark",
          ...o
        }
      );
    default:
      return /* @__PURE__ */ t(Eu, { variant: "light", color: "gray.500", className: r, ...o });
  }
}, Jg = (e) => e.status === "success" ? e.requirement + " - requirement met." : e.requirement, e0 = (e) => {
  let o = 0;
  return e.forEach((r) => {
    r.status === "success" && o++;
  }), o;
}, t0 = ({ id: e, requirements: o }) => /* @__PURE__ */ h(O, { spacing: 1, align: "stretch", color: "gray.800", role: "list", children: [
  /* @__PURE__ */ t(z, { textStyle: "bodySmall", children: "Password must:" }),
  o.map((r, a) => /* @__PURE__ */ h(
    ue,
    {
      spacing: 2,
      "aria-label": `${dg(Jg(r))}`,
      role: "listitem",
      children: [
        /* @__PURE__ */ t(
          qg,
          {
            status: r.status,
            "aria-describedby": `${e}-requirement-${a}`
          }
        ),
        /* @__PURE__ */ t(z, { textStyle: "bodySmall", id: `${e}-requirement-${a}`, children: r.requirement })
      ]
    },
    r.requirement
  ))
] }), o0 = ({
  isDisabled: e = !1,
  isPasswordShown: o = !1,
  ...r
}) => /* @__PURE__ */ t(Ft, { className: "password-view-toggle", children: /* @__PURE__ */ t(
  K,
  {
    "aria-label": "Show password",
    icon: o ? /* @__PURE__ */ t(Zu, { variant: "solid" }) : /* @__PURE__ */ t(Yu, { variant: "solid" }),
    isDisabled: e,
    role: "switch",
    "aria-checked": o,
    ...r,
    variant: "ghost"
  }
) }), r0 = ({ requirements: e, ...o }) => /* @__PURE__ */ h(
  I,
  {
    role: "status",
    "aria-live": "polite",
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    border: "0px",
    overflow: "hidden",
    ...o,
    children: [
      e0(e),
      " out of ",
      e == null ? void 0 : e.length,
      " requirements met."
    ]
  }
), a0 = A((e, o) => {
  const {
    name: r,
    className: a,
    controlStyleProps: n,
    controlClassName: i,
    "data-testid": l,
    error: s,
    passwordRequirements: d,
    hideOptionalLabel: g = !1,
    id: p = r,
    isDisabled: u,
    isReadOnly: b,
    isRequired: f,
    label: c,
    variant: m,
    ...x
  } = e, [y, v] = V(!1), S = () => v(!y), C = xe("password-input", a);
  return /* @__PURE__ */ h(Q, { children: [
    /* @__PURE__ */ t(
      X,
      {
        name: r,
        hideOptionalLabel: g,
        id: p,
        error: s,
        label: c,
        isDisabled: u,
        isReadOnly: b,
        isRequired: f,
        formHelperText: d && d.length > 0 && /* @__PURE__ */ t(t0, { id: p, requirements: d }),
        "data-testid": l && `${l}-control`,
        className: i,
        ...n,
        children: /* @__PURE__ */ t(
          Ye,
          {
            ref: o,
            name: r,
            className: C,
            "data-testid": l,
            type: y ? "text" : "password",
            inputRightElementOverride: /* @__PURE__ */ t(
              o0,
              {
                onClick: S,
                isDisabled: u,
                isPasswordShown: y
              }
            ),
            variant: b ? "filled" : m,
            ...x
          }
        )
      }
    ),
    d && d.length > 0 && /* @__PURE__ */ t(r0, { requirements: d })
  ] });
});
a0.displayName = "PasswordInput";
const pr = ke(null), n0 = A((e, o) => {
  const {
    children: r,
    error: a,
    formHelperText: n,
    hideOptionalLabel: i = !1,
    isAttached: l = !1,
    isRequired: s,
    label: d,
    name: g,
    id: p = g,
    onChange: u,
    value: b,
    variant: f = "radio",
    controlStyleProps: c,
    controlClassName: m,
    "data-testid": x,
    ...y
  } = e, v = Ht("RadioGroup"), S = (M) => {
    u(M === "true" ? !0 : M === "false" ? !1 : M);
  }, { getRadioProps: C } = $l({
    name: g,
    onChange: S,
    // Handle true / false boolean
    value: typeof b == "boolean" ? `${b}` : b
  });
  return /* @__PURE__ */ t(
    X,
    {
      error: a,
      hideOptionalLabel: i,
      isRequired: s,
      label: d,
      name: g,
      id: p,
      formHelperText: n,
      "data-testid": x && `${x}-control`,
      className: m,
      ...c,
      ...y,
      children: /* @__PURE__ */ t(pr.Provider, { value: { getRadioProps: C, variant: f, id: p }, children: l ? /* @__PURE__ */ t(
        ue,
        {
          spacing: 0,
          "data-attached": !0,
          "data-orientation": "horizontal",
          sx: v,
          ...a && { "data-invalid": "true" },
          children: r
        }
      ) : r })
    }
  );
});
n0.displayName = "RadioGroup";
const i0 = () => {
  const e = pe(pr);
  if (!e)
    throw new Error("useRadioGroupContext must be used within a RadioGroup");
  return e;
}, l0 = A((e, o) => {
  const { children: r, id: a, isDisabled: n, size: i = "md", value: l, ...s } = e, { getRadioProps: d, variant: g, id: p } = i0(), u = d({ value: l }), b = a ?? [p, l].join("-");
  return (
    // applying style props directly to ChakraRadio doesn't work properly.
    /* @__PURE__ */ t(I, { w: "fit-content", ...s, children: /* @__PURE__ */ t(
      Ea,
      {
        ref: o,
        ...u,
        id: b,
        isDisabled: n,
        size: i,
        variant: g,
        children: g === "card" ? /* @__PURE__ */ h(O, { align: "stretch", spacing: { base: 2, md: 3 }, children: [
          /* @__PURE__ */ t(I, { className: "radio-card-badge-container", children: /* @__PURE__ */ t(Vt, { className: "radio-card-selected-badge", status: "recommendation", children: "Selected" }) }),
          /* @__PURE__ */ t(I, { className: "radio-card-child-container", children: r })
        ] }) : r
      }
    ) })
  );
});
l0.displayName = "Radio";
const s0 = A((e, o) => {
  const {
    name: r,
    children: a,
    controlStyleProps: n,
    controlClassName: i,
    "data-testid": l,
    error: s,
    formHelperText: d,
    hideOptionalLabel: g = !1,
    id: p = r,
    isDisabled: u,
    isReadOnly: b,
    isRequired: f,
    label: c,
    options: m,
    variant: x = "outline",
    ...y
  } = e;
  return /* @__PURE__ */ t(
    X,
    {
      name: r,
      hideOptionalLabel: g,
      id: p,
      "data-testid": l && `${l}-control`,
      error: s,
      label: c,
      isDisabled: u,
      isReadOnly: b,
      isRequired: f,
      formHelperText: d,
      className: i,
      ...n,
      children: /* @__PURE__ */ t(
        Te,
        {
          ref: o,
          name: r,
          "data-testid": l,
          variant: b ? "filled" : x,
          options: m,
          ...y,
          children: a
        }
      )
    }
  );
});
s0.displayName = "Select";
const c0 = ({ orientation: e = "horizontal", ...o }) => /* @__PURE__ */ h(Fa, { orientation: e, ...o, children: [
  /* @__PURE__ */ t(ja, { children: /* @__PURE__ */ t(Oa, {}) }),
  /* @__PURE__ */ t(Wa, {})
] }), gb = ({
  name: e,
  error: o,
  hideOptionalLabel: r = !1,
  label: a,
  formHelperText: n,
  controlStyleProps: i,
  controlClassName: l,
  id: s = e,
  isReadOnly: d,
  isRequired: g,
  "data-testid": p,
  ...u
}) => /* @__PURE__ */ t(
  X,
  {
    name: e,
    id: `slider-thumb-${s}`,
    error: o,
    hideOptionalLabel: r,
    label: a,
    formHelperText: n,
    isRequired: g,
    isReadOnly: d,
    "data-testid": p && `${p}-control`,
    className: l,
    ...i,
    children: /* @__PURE__ */ t(c0, { name: e, id: s, isReadOnly: d, "data-testid": p, ...u })
  }
), d0 = A((e, o) => {
  const {
    name: r,
    controlClassName: a,
    controlStyleProps: n,
    "data-testid": i,
    error: l,
    formHelperText: s,
    hideOptionalLabel: d = !1,
    id: g = r,
    isDisabled: p,
    isReadOnly: u,
    isRequired: b,
    label: f,
    placeholder: c,
    size: m = "md",
    variant: x = "outline",
    ...y
  } = e;
  return /* @__PURE__ */ t(
    X,
    {
      name: r,
      hideOptionalLabel: d,
      id: g,
      error: l,
      label: f,
      isDisabled: p,
      isReadOnly: u,
      isRequired: b,
      formHelperText: s,
      "data-testid": i && `${i}-control`,
      className: a,
      ...n,
      children: /* @__PURE__ */ t(
        Ga,
        {
          size: m,
          placeholder: c,
          ref: o,
          name: r,
          "data-testid": i,
          focusBorderColor: "teal.500",
          variant: u ? "filled" : x,
          ...y
        }
      )
    }
  );
});
d0.displayName = "Input";
const Jt = ({ size: e = "md", src: o, ...r }) => {
  const [a, n] = V(!1);
  return /* @__PURE__ */ t(
    Ua,
    {
      size: e,
      src: o,
      onError: () => n(!0),
      ...o && !a && { background: "none" },
      ...r
    }
  );
}, mr = ({ children: e, as: o, to: r, ...a }) => /* @__PURE__ */ t(Va, { ...a, children: typeof e == "object" ? e : /* @__PURE__ */ t(Ao, { as: o, href: r, children: e }) }), br = ({ children: e, ...o }) => /* @__PURE__ */ t(Ya, { autoSelect: !1, ...o, children: e }), hr = ({ children: e, as: o, href: r, isDisabled: a, ...n }) => /* @__PURE__ */ t(
  Za,
  {
    isDisabled: a,
    as: a ? void 0 : o,
    href: a ? void 0 : r,
    to: !a && r ? r : void 0,
    ...n,
    children: e
  }
), pb = ({ children: e, ...o }) => /* @__PURE__ */ t(Qa, { ...o, children: e }), mb = ({ ...e }) => /* @__PURE__ */ t(Ka, { ...e }), fr = ({ children: e, ...o }) => /* @__PURE__ */ t(Xa, { ...o, children: e }), yr = ({ children: e, ...o }) => /* @__PURE__ */ t(qa, { ...o, children: e }), u0 = ({ items: e }) => {
  const o = [...e];
  return o.shift(), o.pop(), o.pop(), /* @__PURE__ */ h(br, { children: [
    /* @__PURE__ */ t(yr, { children: "..." }),
    /* @__PURE__ */ t(fr, { children: o.map((r, a) => /* @__PURE__ */ t(hr, { as: r.as || Ao, href: r.to, children: r.label }, a)) })
  ] });
}, g0 = (e) => {
  const o = [];
  return o.push(e[0]), o.push(e[e.length - 2]), o.push(e[e.length - 1]), o;
}, It = ({ item: e, ...o }) => /* @__PURE__ */ t(mr, { as: e.as, to: e.to, isCurrentPage: e.isCurrent, ...o, children: e.label }), bb = ({ options: e, as: o, ...r }) => {
  o && e.forEach((l) => l.as = o);
  let n = [];
  return e.length > 3 ? n = g0(e) : n = e, E(
    () => n.findIndex((l) => l.isCurrent === !0),
    [n]
  ) === -1 && (n[n.length - 1].isCurrent = !0), /* @__PURE__ */ h(Ja, { separator: "/", ...r, children: [
    n[0] && /* @__PURE__ */ t(It, { item: n[0] }),
    e.length > 3 && /* @__PURE__ */ t(mr, { children: /* @__PURE__ */ t(u0, { items: e }) }),
    n[1] && /* @__PURE__ */ t(It, { item: n[1] }),
    n[2] && /* @__PURE__ */ t(It, { item: n[2] })
  ] });
}, ye = ({ as: e, children: o, href: r, size: a = "md", ...n }) => /* @__PURE__ */ t(we, { as: e, href: r, to: e && r ? r : void 0, size: a, ...n, children: o }), xr = ({ brandAs: e, brand: o, brandUrl: r, logo: a }) => {
  const n = ae({ base: !0, md: !1 }, { fallback: "md" });
  return /* @__PURE__ */ t(ye, { href: r, as: e, lineHeight: 0, textDecoration: "none", children: /* @__PURE__ */ h(ue, { spacing: 3, children: [
    a || /* @__PURE__ */ h(ue, { spacing: { base: 2, md: 3 }, children: [
      /* @__PURE__ */ t(Wo, { width: { base: "82.1px", md: "100px" } }),
      /* @__PURE__ */ t(_u, { width: { base: "57.9px", md: "70px" } })
    ] }),
    o && !n && /* @__PURE__ */ t(
      z,
      {
        variant: "subheading1",
        textDecoration: "none",
        color: "gray.800",
        whiteSpace: "nowrap",
        children: o
      }
    )
  ] }) });
}, p0 = (e, o) => {
  let r = "";
  return r = e > o ? `${o}+` : `${e}`, r;
}, eo = ({ children: e, ...o }) => /* @__PURE__ */ t(en, { hasArrow: !0, ...o, children: e }), gt = ({
  "aria-label": e,
  icon: o = /* @__PURE__ */ t(zu, {}),
  maxNotificationDisplayLimit: r = 99,
  notificationCount: a = 0,
  tooltipLabel: n,
  size: i = "sm",
  ...l
}) => {
  const s = D("Notification"), d = /* @__PURE__ */ t(
    K,
    {
      "aria-label": e,
      icon: o,
      variant: "ghost",
      size: i,
      sx: s.iconButton,
      ...l
    }
  );
  return /* @__PURE__ */ h(I, { sx: s.container, display: "inline-block", children: [
    n ? /* @__PURE__ */ t(eo, { label: n, children: d }) : d,
    a > 0 && /* @__PURE__ */ t(I, { sx: s.badgeContainer, children: /* @__PURE__ */ t(Do, { sx: s.badge, children: p0(a, r) }) })
  ] });
}, m0 = ({ ...e }) => /* @__PURE__ */ t(gt, { icon: /* @__PURE__ */ t(Uo, { variant: "light", size: "md" }), ...e }), b0 = ({ ...e }) => /* @__PURE__ */ t(gt, { icon: /* @__PURE__ */ t(Vo, { variant: "light", size: "md" }), ...e }), hb = ({
  bellNotificationCount: e,
  cartNotificationCount: o,
  brand: r,
  brandAs: a,
  brandUrl: n,
  hideBellButton: i = !1,
  hideCartButton: l = !1,
  hideLogInButton: s = !1,
  hideSearchField: d,
  hideSignUpButton: g = !1,
  logo: p,
  isSignedIn: u = !1,
  onBellButtonClick: b,
  onCartButtonClick: f,
  onSearchChange: c,
  onSignInClick: m,
  onSignOutClick: x,
  onSignUpClick: y,
  userMenuItems: v,
  userName: S,
  ...C
}) => {
  const M = D("GlobalHeader");
  return ae({ base: !0, md: !1 }, { fallback: "md" }), /* @__PURE__ */ t(Q, { children: /* @__PURE__ */ h(T, { sx: M.container, as: "header", ...C, children: [
    /* @__PURE__ */ t(xr, { brandUrl: n, logo: p, brand: r, brandAs: a }),
    /* @__PURE__ */ t(T, { flex: 1 }),
    /* @__PURE__ */ h(T, { gap: 3, alignItems: "center", flex: 0, justifyContent: "flex-end", children: [
      u && !l && /* @__PURE__ */ t(
        b0,
        {
          "aria-label": o ? `Cart - contains ${o} transactions` : "Cart",
          notificationCount: o,
          onClick: f
        }
      ),
      u && !i && /* @__PURE__ */ t(
        m0,
        {
          "aria-label": e ? `Notifications - ${e} unread` : "Notifications",
          notificationCount: e,
          onClick: b
        }
      ),
      u && /* @__PURE__ */ h(br, { children: [
        /* @__PURE__ */ t(yr, { children: /* @__PURE__ */ t(Jt, { size: "sm", name: S }) }),
        /* @__PURE__ */ h(fr, { children: [
          v,
          /* @__PURE__ */ t(hr, { onClick: x, children: "Sign out" })
        ] })
      ] }),
      !u && !s && /* @__PURE__ */ t(ee, { size: "sm", variant: "secondary", onClick: m, children: "Log in" }),
      !u && !g && /* @__PURE__ */ t(ee, { size: "sm", variant: "primary", onClick: y, children: "Sign up" })
    ] })
  ] }) });
}, to = ke(null), vr = () => {
  const e = pe(to);
  if (!e)
    throw new Error("useGlobalHeaderv2DevContext must be used within a GlobalHeaderv2 component.");
  return e;
}, h0 = ({ onSignOutClick: e, userMenuBody: o, userName: r }) => {
  const { isUserMenuOpen: a, onUserMenuClose: n, onUserMenuToggle: i } = vr();
  return /* @__PURE__ */ h(ve, { placement: "bottom-end", gutter: 2, isOpen: a, onClose: n, children: [
    /* @__PURE__ */ t(eo, { label: "My Profile", children: /* @__PURE__ */ t(I, { display: "inline-block", children: /* @__PURE__ */ t(Be, { children: /* @__PURE__ */ t(
      K,
      {
        "aria-label": "My Profile",
        variant: "ghost",
        icon: /* @__PURE__ */ t(Jt, { size: "sm", name: r }),
        borderRadius: "full",
        onClick: i
      }
    ) }) }) }),
    /* @__PURE__ */ t(Ce, { children: /* @__PURE__ */ h(Se, { children: [
      o && /* @__PURE__ */ t(I, { paddingBottom: 4, children: o }),
      /* @__PURE__ */ t(I, { textAlign: "right", children: /* @__PURE__ */ t(
        ee,
        {
          variant: "ghost",
          leftIcon: /* @__PURE__ */ t(Go, {}),
          onClick: e,
          children: "Sign Out"
        }
      ) })
    ] }) })
  ] });
}, f0 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMTQiIGhlaWdodD0iMTI4IiB2aWV3Qm94PSIwIDAgMTE0IDEyOCIgZmlsbD0ibm9uZSI+CjxwYXRoIGQ9Ik0yODcuNjU0IC05LjA1MDNDMzE1LjUyOSAtOS4wNTAzIDM0Mi4zODkgNS42ODE0NiAzNTcuNzYzIDMxLjUxNzVDMzY5LjA5OCA1MC41NjU3IDM3NC41MDggNzguNDE5MSAzNzYgODcuOTQ5N0wxNTQuMzQ2IDg3Ljk0OTdDMTI2LjQ3MSA4Ny45NDk3IDk5LjYxMDYgNzMuMjE4IDg0LjIzNjUgNDcuMzgxOUM3Mi45MDE5IDI4LjMzMzcgNjcuNDg4OSAwLjQ4Mjk0OCA2NiAtOS4wNTAyOUwyODcuNjU0IC05LjA1MDNaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjA0Ii8+CjxwYXRoIGQ9Ik04MS4xOTM3IDQxNi45NUw5LjkwNzE3IDIxNS41NDdDLTguMzg2NjggMTYzLjg2NSAxLjQ4ODk0IDEwNC4zNzIgMzkuNjI2MSA1OC44NzU4QzY3Ljc0NTYgMjUuMzMyNyAxMTYuMTg1IC0zLjAxODg2IDEzMyAtMTIuMDUwMyIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLW9wYWNpdHk9IjAuMDYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTIxNyAzMDUuOTVMNzcuNjcxNyAxNTguNDE3QzQxLjkyMDIgMTIwLjU2IDI3LjY0MjEgNjUuMTY5NiA0My4zMDcyIDExLjEzNTJDNTQuODU1NyAtMjguNzA1NiA4Ni4wNTk5IC03MS43OTY2IDk3LjIwMzggLTg2LjA1MDMiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS1vcGFjaXR5PSIwLjA4IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+Cjwvc3ZnPg==", y0 = ({ userName: e }) => {
  const o = D("GlobalHeaderv2");
  return /* @__PURE__ */ t(Ze, { __css: o.mobileMenuHeader, backgroundImage: f0, children: /* @__PURE__ */ h(O, { spacing: 2, children: [
    /* @__PURE__ */ t(Jt, { size: "lg", name: e }),
    e && /* @__PURE__ */ t(z, { variant: "subheading2", children: e })
  ] }) });
}, x0 = ({
  dimensions: e,
  isPublic: o,
  isSignedIn: r,
  mobileMenuHeader: a,
  mobileMenuBody: n,
  onSignOutClick: i,
  userName: l
}) => {
  const s = D("GlobalHeaderv2"), { isMobileMenuOpen: d, onMobileMenuClose: g, onMobileMenuToggle: p } = vr();
  return /* @__PURE__ */ h(ve, { gutter: 14, isOpen: d, onClose: g, children: [
    /* @__PURE__ */ t(eo, { label: "Menu", children: /* @__PURE__ */ t(I, { display: "inline-block", children: /* @__PURE__ */ t(Be, { children: /* @__PURE__ */ t(
      K,
      {
        "aria-label": "Menu",
        variant: "ghost",
        size: "md",
        borderRadius: "full",
        icon: d ? /* @__PURE__ */ t(qo, { variant: "light", size: "lg" }) : /* @__PURE__ */ t(Ru, { variant: "light", size: "lg" }),
        onClick: p
      }
    ) }) }) }),
    /* @__PURE__ */ h(
      Ce,
      {
        sx: s.mobileMenuContent,
        minHeight: `calc(100vh - ${e == null ? void 0 : e.borderBox.bottom}px)`,
        children: [
          a ? /* @__PURE__ */ t(Mt, { padding: 0, children: a }) : r && /* @__PURE__ */ t(Mt, { padding: 0, children: /* @__PURE__ */ t(y0, { userName: l }) }),
          /* @__PURE__ */ h(Se, { sx: s.mobileMenuBody, children: [
            n,
            r && /* @__PURE__ */ t(I, { as: "nav", marginTop: 2, children: /* @__PURE__ */ t(
              we,
              {
                onClick: i,
                onKeyDown: (u) => {
                  u.key === "Enter" && (i == null || i(u));
                },
                role: "menuitem",
                tabIndex: 0,
                sx: s.signOutLink,
                children: /* @__PURE__ */ h(ue, { spacing: 4, children: [
                  /* @__PURE__ */ t(Go, { variant: "light", size: "xl" }),
                  /* @__PURE__ */ t(z, { as: "span", textStyle: "bodyBold", children: "Sign Out" })
                ] })
              }
            ) })
          ] })
        ]
      }
    )
  ] });
}, v0 = ({
  cartNotificationCount: e,
  isMobile: o = !1,
  onCartButtonClick: r
}) => /* @__PURE__ */ t(
  gt,
  {
    "aria-label": e ? `Shopping Cart - contains ${e} transactions` : "Shopping Cart",
    notificationCount: e,
    onClick: r,
    icon: /* @__PURE__ */ t(Vo, { variant: "light", size: o ? "lg" : "md" }),
    size: o ? "md" : "sm",
    tooltipLabel: "Shopping Cart"
  }
), C0 = ({
  bellNotificationCount: e,
  isMobile: o = !1,
  onBellButtonClick: r
}) => /* @__PURE__ */ t(
  gt,
  {
    "aria-label": e ? `Notifications - ${e} unread` : "Notifications",
    notificationCount: e,
    onClick: r,
    icon: /* @__PURE__ */ t(Uo, { variant: "light", size: o ? "lg" : "md" }),
    size: o ? "md" : "sm",
    tooltipLabel: "Notifications"
  }
), fb = ({
  bellNotificationCount: e,
  cartNotificationCount: o,
  brand: r,
  brandAs: a,
  brandUrl: n,
  hideBellButton: i = !1,
  hideCartButton: l = !1,
  isPublic: s = !1,
  logo: d,
  mobileMenuHeader: g,
  mobileMenuBody: p,
  isSignedIn: u = !1,
  onBellButtonClick: b,
  onCartButtonClick: f,
  onSignInClick: c,
  onSignOutClick: m,
  userMenuBody: x,
  userName: y,
  ...v
}) => {
  const S = D("GlobalHeaderv2"), C = ae({ base: !0, md: !1 }, { fallback: "md" }), M = le(null), _ = tn(M), {
    isOpen: G,
    onToggle: j,
    onClose: L
  } = We(), {
    isOpen: w,
    onToggle: F,
    onClose: W
  } = We(), U = (me) => {
    m == null || m(me);
  };
  return /* @__PURE__ */ t(
    to.Provider,
    {
      value: {
        isMobileMenuOpen: G,
        onMobileMenuToggle: j,
        onMobileMenuClose: L,
        isUserMenuOpen: w,
        onUserMenuToggle: F,
        onUserMenuClose: W
      },
      children: /* @__PURE__ */ h(T, { sx: S.container, as: "header", ...v, ref: M, children: [
        C && /* @__PURE__ */ t(T, { flex: 1, children: /* @__PURE__ */ t(
          x0,
          {
            isPublic: s,
            isSignedIn: u,
            dimensions: _,
            mobileMenuHeader: g,
            mobileMenuBody: p,
            userName: y,
            onSignOutClick: U
          }
        ) }),
        /* @__PURE__ */ t(xr, { brandUrl: n, logo: d, brand: r, brandAs: a }),
        !C && /* @__PURE__ */ t(T, { flex: 1 }),
        /* @__PURE__ */ h(T, { gap: 3, alignItems: "center", flex: C ? 1 : 0, justifyContent: "flex-end", children: [
          u && !l && /* @__PURE__ */ t(
            v0,
            {
              isMobile: C,
              cartNotificationCount: o,
              onCartButtonClick: f
            }
          ),
          u && !i && /* @__PURE__ */ t(
            C0,
            {
              isMobile: C,
              bellNotificationCount: e,
              onBellButtonClick: b
            }
          ),
          u && !C && /* @__PURE__ */ t(
            h0,
            {
              userName: y,
              onSignOutClick: U,
              userMenuBody: x
            }
          ),
          !u && !s && /* @__PURE__ */ t(ee, { size: C ? "md" : "sm", variant: "secondary", onClick: c, children: "Sign In" })
        ] })
      ] })
    }
  );
}, S0 = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAzNDQgMjg4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPGcgY2xpcFBhdGg9InVybCgjY2xpcDBfNDIzN18yODcwNikiPgogICAgICA8cmVjdCB3aWR0aD0iMzQ0IiBoZWlnaHQ9IjMwMCIgZmlsbD0id2hpdGUiIC8+CiAgICAgIDxlbGxpcHNlIGN4PSIzODguMTQ3IiBjeT0iLTU1LjM4NDYiIHJ4PSIxNjMuNCIgcnk9IjIzMC43NjkiIGZpbGw9IiNERkUzM0UiIC8+CiAgICAgIDxwYXRoCiAgICAgICAgZD0iTTEwMy4zNDIgNjgzLjg5OEM1Mi44OTk5IDU4OS44NTUgMjUuNjI0OCA0NTkuODY0IDQyLjc5MTcgMzQyLjI4N0M1Mi45NjUgMjcyLjYwOSA4My42NTU4IDIxNy4zNDggMTIwLjI0MiAxNzEuNDgxQzE1MS41NTUgMTMyLjIyNSAxODcuNjUxIDk4LjM5NTkgMjI5LjUwNSA4Ny4zNjAyQzI1OC4yMTQgNzkuNzkwNCAyOTEuMzE2IDgzLjQ5NjcgMzE0Ljk5OCAxMDkuOTI5QzM0MS4yOTEgMTM5LjI3NSAzNTMuMDQxIDE4OS4xNCAzNjIuNTM1IDIzMi41MkMzNzMuODk1IDI4NC40MjQgMzgxLjcyIDMzOC43ODYgMzg1LjAzOCAzOTIuOTM5QzM4Ny42NTQgNDM1LjYyNyAzODUuMzI0IDQ3Ny4zNjkgMzg0Ljc2NyA1MjAuMDE3IgogICAgICAgIHN0cm9rZT0iIzNBQzJDRSIKICAgICAgICBzdHJva2VXaWR0aD0iMiIKICAgICAgICBzdHJva2VMaW5lY2FwPSJyb3VuZCIKICAgICAgLz4KICAgICAgPHBhdGgKICAgICAgICBkPSJNMzM4LjI2NyAtNTIzLjcyOUMzMjEuNTgxIC01MDcuMTc4IDMxNC40OTEgLTQ3NC4yMTkgMzA3LjE3OSAtNDUyLjU0MkMyNjEuNDYgLTMxNy4wMDEgMjIwLjQwMyAtMTc2LjM2NyAxOTYuNTkgLTMzLjg5OEMxNjEuNDk2IDE3Ni4wNTggMTcwLjE0NyAzOTMuNzk5IDIzNy4zNiA1OTUuNDgxQzI3OC43MzggNzE5LjY0MyAzNDMuMTQgODE0LjExIDQyMC44MjcgOTEwLjE3IgogICAgICAgIHN0cm9rZT0iI0RGRTMzRSIKICAgICAgICBzdHJva2VXaWR0aD0iMiIKICAgICAgICBzdHJva2VMaW5lY2FwPSJyb3VuZCIKICAgICAgLz4KICAgIDwvZz4KICAgIDxkZWZzPgogICAgICA8Y2xpcFBhdGggaWQ9ImNsaXAwXzQyMzdfMjg3MDYiPgogICAgICAgIDxyZWN0IHdpZHRoPSIzNDQiIGhlaWdodD0iMzAwIiBmaWxsPSJ3aGl0ZSIgLz4KICAgICAgPC9jbGlwUGF0aD4KICAgIDwvZGVmcz4KPC9zdmc+", yb = ({ bottomElement: e, children: o, topElement: r, ...a }) => {
  const n = D("PageHeader"), i = ae({ base: !0, md: !1 }, { fallback: "md" });
  return /* @__PURE__ */ t(
    T,
    {
      sx: n.container,
      ...a,
      ...!i && {
        backgroundRepeat: "no-repeat",
        backgroundImage: S0,
        backgroundPosition: "right"
      },
      children: /* @__PURE__ */ h(O, { sx: n.content, spacing: 4, align: "stretch", children: [
        r,
        typeof o == "string" || typeof o == "number" ? /* @__PURE__ */ t(z, { variant: "h1", as: "h1", children: o }) : o,
        e
      ] })
    }
  );
}, Cr = ke(null), w0 = {
  activeStep: 1,
  totalSteps: 0
}, pt = () => {
  const e = pe(Cr);
  if (!e)
    throw new Error("useStepsContext must be used within a Steps component.");
  return e;
}, k0 = /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "none", children: /* @__PURE__ */ t("circle", { cx: "10", cy: "10", r: "9", strokeWidth: "2", stroke: "black", fill: "none" }) }), I0 = ({ step: e = 0, stepState: o, ...r }) => {
  const a = D("Steps"), { componentClassPrefix: n } = pt(), i = `${n}__step-icon`, l = {
    variant: "solid",
    size: "xl"
  };
  return o === "active" ? /* @__PURE__ */ t(Fu, { className: `${i}`, ...l, sx: a.icon, ...r }) : o === "complete" ? /* @__PURE__ */ t(Zt, { className: `${i}`, ...l, sx: a.icon, ...r }) : /* @__PURE__ */ h(I, { className: `${i}`, sx: a.icon, children: [
    k0,
    /* @__PURE__ */ t(I, { className: `${n}__step-number`, children: e })
  ] });
}, $0 = ({ children: e }) => {
  const { componentClassPrefix: o } = pt();
  return /* @__PURE__ */ t(z, { className: `${o}__step-label`, children: e });
}, M0 = (e, o) => e < o ? "complete" : o === e ? "active" : "default", N0 = (e) => e === "complete" ? "Completed" : e === "active" ? "Current step" : "", z0 = A((e, o) => {
  const { children: r, className: a, isDisabled: n = !1, stepNumber: i = 0, variant: l, ...s } = e, {
    stepsState: d,
    handleStepSelection: g,
    isStepSelectDisabled: p,
    internalId: u,
    dataTestId: b,
    componentClassPrefix: f
  } = pt(), c = E(
    () => l || M0(i, d.activeStep),
    [l, i, d.activeStep]
  ), m = D("Steps", { variant: c }), x = E(
    () => d.totalSteps === i,
    [d.totalSteps, i]
  ), y = xe(`${f}__step`, a);
  return /* @__PURE__ */ h(
    O,
    {
      ref: o,
      role: "option",
      id: `${u}-details-${i}`,
      "data-testid": b && `${b}-details-${i}`,
      className: y,
      sx: m.stepDetails,
      align: "stretch",
      spacing: 1,
      onMouseDown: (v) => v.preventDefault(),
      onClick: (v) => {
        v.preventDefault(), g(v, p || n, i);
      },
      onKeyDown: (v) => {
        v.key === "Enter" && (v.preventDefault(), g(v, p || n, i));
      },
      ...x && { "data-last": !0 },
      ...i === 1 && { "data-first": !0 },
      ...p && { "data-no-click": !0 },
      ...(n || p) && { "aria-disabled": !0 },
      "aria-selected": !n && d.activeStep === i,
      "aria-label": `Step ${i} - ${r}` + (c !== "default" ? ` - ${N0(c)}.` : "."),
      tabIndex: -1,
      ...s,
      children: [
        /* @__PURE__ */ h(
          ue,
          {
            spacing: 2,
            sx: m.stepDetailsLabel,
            className: `${f}__step-details`,
            children: [
              /* @__PURE__ */ t(I0, { step: i, stepState: c }),
              /* @__PURE__ */ t($0, { children: r })
            ]
          }
        ),
        !x && /* @__PURE__ */ t(De, { sx: m.verticalDivider, "aria-hidden": !0 })
      ]
    }
  );
});
z0.displayName = "StepDetails";
const D0 = ({ children: e, ...o }) => {
  const { childRefs: r } = pt();
  return /* @__PURE__ */ t(O, { align: "stretch", spacing: 1, ...o, role: "listbox", "aria-label": "List of steps.", children: e.length > 0 && e.map((a, n) => re(a, {
    stepNumber: n + 1,
    ref: (i) => r.current[n] = i
  })) });
}, _0 = ({ activeStep: e }) => {
  const o = D("Steps");
  return /* @__PURE__ */ h(I, { role: "status", "aria-live": "polite", sx: o.status, children: [
    "Step ",
    e,
    " selected."
  ] });
}, xb = ({
  children: e,
  activeStep: o = 1,
  "data-testid": r,
  isStepSelectDisabled: a = !1,
  id: n,
  onStepSelect: i,
  ...l
}) => {
  const s = ae({ base: !0, md: !1 }, { fallback: "md" }), d = D("Steps"), g = ie(e), p = "gravity-steps", u = n || Wt(), [b, f] = V(0), { isOpen: c, onToggle: m, onClose: x } = We(), y = le([]), v = {
    ...w0,
    totalSteps: g.length,
    activeStep: o
  }, [S, C] = V(v);
  oe(() => {
    o && C({ ...S, activeStep: o });
  }, [o]);
  const M = Z(
    (L, w, F) => {
      w ? L.preventDefault() : (C({ ...S, activeStep: F }), i == null || i(F), m(), _());
    },
    [i, m]
  ), _ = () => {
    f(0);
  }, G = () => {
    x(), _();
  }, j = (L) => {
    if (L.key === "ArrowUp" && b > 1) {
      const w = b - 1;
      f(w), y == null || y.current[w - 1].focus();
    } else if (L.key === "ArrowDown" && b < g.length) {
      const w = b + 1;
      f(w), y == null || y.current[w - 1].focus();
    } else
      L.key === "Home" ? (f(1), y == null || y.current[0].focus()) : L.key === "End" && (f(g.length), y == null || y.current[g.length - 1].focus());
  };
  return /* @__PURE__ */ t(
    Cr.Provider,
    {
      value: {
        stepsState: S,
        handleStepSelection: M,
        isStepSelectDisabled: a,
        internalId: u,
        dataTestId: r,
        componentClassPrefix: p,
        childRefs: y
      },
      children: /* @__PURE__ */ h(
        O,
        {
          align: "stretch",
          spacing: s ? 4 : 2,
          ...s && { textAlign: "center" },
          id: u,
          "data-testid": r,
          ...l,
          role: "application",
          "aria-label": `On step ${S.activeStep} of ${g.length}.`,
          children: [
            /* @__PURE__ */ h(O, { spacing: 0, align: "stretch", children: [
              s && /* @__PURE__ */ h(z, { fontSize: "16px", children: [
                "Step ",
                S.activeStep
              ] }),
              /* @__PURE__ */ t(
                rr,
                {
                  "aria-label": "Steps progress percentage",
                  value: S.activeStep / g.length * 95,
                  size: "sm",
                  id: `${u}-progress`,
                  "data-testid": r && `${r}-progress`
                }
              )
            ] }),
            /* @__PURE__ */ h(T, { alignItems: "center", children: [
              /* @__PURE__ */ h(
                ve,
                {
                  placement: "bottom-start",
                  gutter: 8,
                  ...s && { matchWidth: !0 },
                  id: u,
                  isOpen: c,
                  onClose: G,
                  children: [
                    /* @__PURE__ */ t(Be, { children: /* @__PURE__ */ t(
                      ee,
                      {
                        type: "button",
                        variant: "tertiary",
                        rightIcon: c ? /* @__PURE__ */ t(Yt, { variant: "light", size: "md" }) : /* @__PURE__ */ t(Ie, { variant: "light", size: "md" }),
                        size: s ? "lg" : "md",
                        ...s && { isFullWidth: !0 },
                        onClick: m,
                        "data-testid": r && `${r}-popover-trigger`,
                        "aria-label": `${a ? "Click to view steps." : "Click to navigate to another step."}`,
                        children: a ? "View steps" : "Change step"
                      }
                    ) }),
                    /* @__PURE__ */ t(
                      Ce,
                      {
                        onKeyDown: j,
                        "aria-label": "List of steps available. Press the up/down arrow keys to hightlight a step and the Enter key to select it. ",
                        children: /* @__PURE__ */ t(Se, { sx: d.container, children: /* @__PURE__ */ t(D0, { children: g }) })
                      }
                    )
                  ]
                }
              ),
              !s && /* @__PURE__ */ h(Q, { children: [
                /* @__PURE__ */ t(I, { flex: 1 }),
                /* @__PURE__ */ h(z, { children: [
                  "Step ",
                  S.activeStep
                ] })
              ] })
            ] }),
            /* @__PURE__ */ t(_0, { activeStep: S.activeStep })
          ]
        }
      )
    }
  );
}, vb = ({
  bodyStyleProps: e,
  isOpen: o,
  onClose: r,
  cancelRef: a,
  children: n,
  closeOnEsc: i,
  closeOnOverlayClick: l,
  dialogStyleProps: s,
  footer: d,
  headerStyleProps: g,
  id: p,
  isCentered: u,
  onEsc: b,
  onOverlayClick: f,
  title: c,
  showCloseButton: m = !0,
  footerStyleProps: x,
  "data-testid": y,
  ...v
}) => /* @__PURE__ */ t(
  on,
  {
    leastDestructiveRef: a,
    isOpen: o,
    onClose: r,
    closeOnEsc: i,
    closeOnOverlayClick: l,
    id: p,
    isCentered: u,
    onEsc: b,
    onOverlayClick: f,
    children: /* @__PURE__ */ t(rn, { children: /* @__PURE__ */ h(an, { "data-testid": y, ...s, ...v, children: [
      /* @__PURE__ */ t(
        nn,
        {
          "data-testid": y && `${y}-header`,
          ...g,
          children: c
        }
      ),
      m && /* @__PURE__ */ t(ln, {}),
      n && /* @__PURE__ */ t(sn, { "data-testid": y && `${y}-body`, ...e, children: n }),
      d && /* @__PURE__ */ t(
        cn,
        {
          "data-testid": y && `${y}-footer`,
          ...x,
          children: d
        }
      )
    ] }) })
  }
), A0 = ({ onCancelClick: e, onContinueClick: o }) => {
  const r = ae({ base: !0, md: !1 }, { fallback: "md" });
  return /* @__PURE__ */ h(T, { gap: 3, width: "100%", justifyContent: { base: "space-between", md: "flex-end" }, children: [
    /* @__PURE__ */ t(
      ee,
      {
        size: "sm",
        variant: "tertiary",
        isFullWidth: r,
        ...e && { onClick: e },
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ t(
      ee,
      {
        size: "sm",
        variant: "primary",
        isFullWidth: r,
        ...o && { onClick: o },
        children: "Continue"
      }
    )
  ] });
}, L0 = (e, o) => {
  let r = "xl";
  return e ? r = "full" : o && (r = "sm"), r;
}, Cb = ({
  isOpen: e,
  onClose: o,
  children: r,
  closeOnEsc: a,
  closeOnOverlayClick: n,
  footer: i,
  isCentered: l,
  id: s,
  isFullScreen: d = !1,
  modalContentProps: g,
  modalHeaderProps: p,
  onCancelClick: u,
  onContinueClick: b,
  onEsc: f,
  onOverlayClick: c,
  scrollBehavior: m,
  showCloseButton: x = !0,
  title: y,
  useInert: v,
  "data-testid": S,
  ...C
}) => {
  const M = ae({ base: !0, md: !1 }, { fallback: "md" });
  return /* @__PURE__ */ h(
    dn,
    {
      id: s,
      isOpen: e,
      onClose: o,
      closeOnEsc: a,
      closeOnOverlayClick: n,
      isCentered: l,
      onEsc: f,
      onOverlayClick: c,
      scrollBehavior: m,
      useInert: v,
      size: L0(d, M),
      children: [
        /* @__PURE__ */ t(un, {}),
        /* @__PURE__ */ h(gn, { "data-testid": S, ...g, ...C, children: [
          y && /* @__PURE__ */ t(pn, { "data-testid": S && `${S}-header`, ...p, children: y }),
          x && /* @__PURE__ */ t(mn, { size: M ? "sm" : "md" }),
          /* @__PURE__ */ t(bn, { "data-testid": S && `${S}-body`, children: r }),
          /* @__PURE__ */ t(hn, { "data-testid": S && `${S}-footer`, children: i || /* @__PURE__ */ t(A0, { onCancelClick: u, onContinueClick: b }) })
        ] })
      ]
    }
  );
}, Sb = ({
  children: e,
  popoverTrigger: o,
  bodyStyleProps: r,
  closeOnBlur: a = !0,
  closeOnEsc: n = !0,
  footer: i,
  footerStyleProps: l,
  header: s,
  headerStyleProps: d,
  id: g,
  onClose: p,
  onOpen: u,
  placement: b = "bottom",
  showCloseButton: f = !0,
  trigger: c = "click",
  "data-testid": m,
  ...x
}) => /* @__PURE__ */ h(
  ve,
  {
    id: g,
    closeOnBlur: a,
    closeOnEsc: n,
    onClose: p,
    onOpen: u,
    placement: b,
    trigger: c,
    children: [
      /* @__PURE__ */ t(Be, { children: o }),
      /* @__PURE__ */ h(Ce, { "data-testid": m, ...x, children: [
        /* @__PURE__ */ t(fn, {}),
        f && /* @__PURE__ */ t(yn, {}),
        s ? /* @__PURE__ */ t(Mt, { "data-testid": m && `${m}-header`, ...d, children: s }) : f && /* @__PURE__ */ t(I, { className: "headerspacer" }),
        /* @__PURE__ */ t(Se, { "data-testid": m && `${m}-body`, ...r, children: e }),
        i && /* @__PURE__ */ t(xn, { "data-testid": m && `${m}-footer`, ...l, children: i })
      ] })
    ]
  }
), Fe = () => /* @__PURE__ */ t(z, { display: { base: "none", md: "inline" }, color: "gray.700", children: "|" }), T0 = () => {
  const e = D("Footer");
  return /* @__PURE__ */ h(T, { sx: e.defaultContent, children: [
    /* @__PURE__ */ t(ye, { href: "https://www.sgi.sk.ca", isExternal: !0, children: "sgi.sk.ca" }),
    /* @__PURE__ */ t(Fe, {}),
    /* @__PURE__ */ t(ye, { href: "https://www.sgicanada.ca", isExternal: !0, children: "sgicanada.ca" }),
    /* @__PURE__ */ t(Fe, {}),
    /* @__PURE__ */ t(ye, { href: "https://www.sgi.sk.ca/salvage", isExternal: !0, children: "sgi salvage" }),
    /* @__PURE__ */ t(Fe, {}),
    /* @__PURE__ */ t(ye, { href: "https://www.sgi.sk.ca/terms", isExternal: !0, children: "Terms of use" }),
    /* @__PURE__ */ t(Fe, {}),
    /* @__PURE__ */ t(ye, { href: "https://www.sgi.sk.ca/privacy", isExternal: !0, children: "Privacy statement" }),
    /* @__PURE__ */ t(Fe, {}),
    /* @__PURE__ */ t(ye, { children: "Feedback" }),
    /* @__PURE__ */ h(z, { children: [
      "© SGI ",
      (/* @__PURE__ */ new Date()).getFullYear()
    ] })
  ] });
}, wb = ({
  children: e,
  hideCommentButton: o = !1,
  onCommentClick: r,
  stickToBottom: a = !1,
  ...n
}) => {
  const l = D("Footer", { variant: a ? "stickToBottom" : "basic" });
  return /* @__PURE__ */ h(Ze, { as: "footer", __css: l.container, ...n, children: [
    ie(e).length > 0 ? e : /* @__PURE__ */ t(T0, {}),
    !o && /* @__PURE__ */ t(
      K,
      {
        "aria-label": "Click to comment",
        icon: /* @__PURE__ */ t(Wu, { variant: "light", size: "2xl" }),
        onClick: r,
        size: "lg",
        sx: l.chatIcon
      }
    )
  ] });
}, Sr = ke(null), $t = {
  activeCategory: "",
  openCategory: "",
  activeItem: ""
}, kb = ({ children: e, id: o = "globalNav", linkAs: r, ...a }) => {
  const [n, i] = V(
    $t
  ), l = D("GlobalNav"), { isOpen: s, onClose: d, onOpen: g } = We(), p = le();
  Lo({
    ref: p,
    handler: () => s && d()
  });
  const u = E(() => ie(e), [e]), b = (m, x) => {
    x === 0 ? (i({
      ...n,
      activeCategory: m.currentTarget.id,
      activeItem: $t.activeItem
    }), d()) : n.openCategory !== m.currentTarget.id ? i({ ...n, openCategory: m.currentTarget.id }) : x !== 0 && g();
  }, f = (m) => {
    const x = { ...n, activeItem: m.currentTarget.id };
    x.activeCategory = x.openCategory, i(x), d();
  }, c = () => {
    i($t);
  };
  return /* @__PURE__ */ t(
    Sr.Provider,
    {
      value: {
        globalNavState: n,
        setGlobalNavState: i,
        resetState: c,
        isOpen: s,
        onOpen: g,
        onClose: d,
        handleCategoryOnClick: b,
        handleItemOnClick: f,
        linkAs: r
      },
      children: /* @__PURE__ */ t(T, { __css: l.globalNavTopContainer, flexDir: "column", ref: p, id: o, ...a, children: /* @__PURE__ */ t(T, { __css: l.globalNavNavContainer, as: "nav", flexDir: "column", id: "globalNav-nav", children: u.length > 0 && u.map((m, x) => {
        const y = `category${x}`;
        return re(m, {
          id: y
        });
      }) }) })
    }
  );
}, Ke = () => {
  const e = pe(Sr);
  if (!e)
    throw new Error("useGlobalNavContext must be used within a GlobalNav component.");
  return e;
}, B0 = ({ children: e }) => {
  const o = D("GlobalNav"), { isOpen: r } = Ke(), [a, n] = V(!r);
  return /* @__PURE__ */ t(Q, { children: /* @__PURE__ */ t(
    Eo.div,
    {
      hidden: a,
      initial: !1,
      onAnimationStart: () => n(!1),
      onAnimationComplete: () => n(!r),
      animate: { width: r ? cu - et : 0 },
      style: o.globalNavMenuSlider,
      children: e
    }
  ) });
}, Ib = ({
  as: e,
  children: o,
  href: r,
  icon: a,
  id: n,
  label: i,
  onClick: l,
  onKeyDown: s,
  ...d
}) => {
  const { globalNavState: g, isOpen: p, onOpen: u, onClose: b, handleCategoryOnClick: f, linkAs: c } = Ke(), m = g.activeCategory === n, x = g.openCategory === n, v = D("GlobalNav", { variant: x && p ? "open" : m ? "active" : "" }), S = E(() => ie(o).length, [o]);
  oe(() => {
    x && (S > 0 ? u() : b());
  }, [g.openCategory]);
  const C = (_) => {
    l && l(_), f(_, S);
  }, M = (_) => {
    s && s(_), (_.key === " " || _.key === "Enter") && f(_, S);
  };
  return /* @__PURE__ */ h(Q, { children: [
    /* @__PURE__ */ t(
      we,
      {
        as: r && c ? c : e,
        href: r,
        to: r || void 0,
        sx: v.globalNavCategory,
        onClick: C,
        onKeyDown: M,
        value: i,
        id: n,
        tabIndex: 0,
        ...d,
        children: /* @__PURE__ */ h(O, { spacing: "2", children: [
          a && /* @__PURE__ */ t(rt, { __css: v.globalNavCategoryIcon, children: a }),
          i && /* @__PURE__ */ t(z, { children: i })
        ] })
      }
    ),
    x && /* @__PURE__ */ t(B0, { children: o })
  ] });
}, $b = ({ children: e, ...o }) => {
  const r = D("GlobalNav"), { globalNavState: a } = Ke(), n = E(() => ie(e), [e]);
  return /* @__PURE__ */ t(
    O,
    {
      sx: r.globalNavMenu,
      role: "menu",
      align: "stretch",
      divider: /* @__PURE__ */ t(vn, { sx: r.globalNavMenuDivider }),
      spacing: "6",
      ...o,
      children: n.length > 0 && n.map((i, l) => {
        const s = `${a.openCategory}-item${l}`;
        return re(i, {
          id: s
        });
      })
    }
  );
}, Mb = ({
  as: e,
  children: o,
  href: r,
  id: a,
  isDisabled: n,
  label: i,
  ...l
}) => {
  const { globalNavState: s, handleItemOnClick: d, linkAs: g } = Ke(), p = n ? "disabled" : s.activeItem === a ? "active" : "", u = D("GlobalNav", { variant: p }), b = E(() => ie(o), [o]);
  return /* @__PURE__ */ h(Q, { children: [
    /* @__PURE__ */ t(
      we,
      {
        role: "menuitem",
        display: "block",
        sx: u.globalNavMenuLink,
        onClick: !n && r ? d : void 0,
        id: a,
        as: !n && r && g ? g : e,
        href: n ? void 0 : r,
        to: !n && r ? r : void 0,
        ...l,
        children: i
      }
    ),
    b.length > 0 && b.map((f) => {
      const c = `${a}-sub`;
      return re(f, { id: c });
    })
  ] });
}, Nb = ({ children: e, id: o, ...r }) => {
  const a = D("GlobalNav"), n = E(() => ie(e), [e]);
  return /* @__PURE__ */ t(O, { sx: a.globalNavSubMenu, role: "group", align: "stretch", spacing: "0.5", ...r, children: n.length > 0 && n.map((i, l) => {
    const s = `${o}item${l}`;
    return re(i, {
      id: s
    });
  }) });
}, zb = ({
  as: e,
  href: o,
  id: r,
  isDisabled: a,
  label: n,
  ...i
}) => {
  const { globalNavState: l, handleItemOnClick: s, linkAs: d } = Ke(), g = a ? "disabled" : l.activeItem === r ? "active" : "", p = D("GlobalNav", { variant: g });
  return /* @__PURE__ */ t(Q, { children: /* @__PURE__ */ t(
    we,
    {
      sx: p.globalNavSubMenuLink,
      display: "block",
      role: "menuitem",
      onClick: !a && o ? s : void 0,
      id: r,
      as: !a && o && d ? d : e,
      href: a ? void 0 : o,
      to: !a && o ? o : void 0,
      ...i,
      children: n
    }
  ) });
}, wr = ke(null), P0 = {
  activeCategory: "",
  openCategory: "",
  activeItem: "",
  focusCategory: 0,
  focusItem: -1,
  focusOnTab: !1
}, mt = () => {
  const e = pe(wr);
  if (!e)
    throw new Error("useGlobalNavContext must be used within a GlobalNavv2 component.");
  return e;
}, kr = ({ children: e, category: o }) => {
  const r = D("GlobalNavv2"), { isOpen: a, rootId: n, setMenuItems: i } = mt(), [l, s] = V(!a);
  return /* @__PURE__ */ t(
    Eo.div,
    {
      hidden: l,
      initial: !1,
      onAnimationStart: () => s(!1),
      onAnimationComplete: () => {
        s(!a), a || i([]);
      },
      animate: { width: a ? ud - Tt : 0 },
      style: r.slider,
      children: /* @__PURE__ */ t(I, { padding: 6, id: `${n}-panel`, role: "menu", "aria-labelledby": o, children: e })
    }
  );
};
kr.displayName = "GlobalNavMenuSlider";
const R0 = (e, o, r) => o ? xe("category-open", r) : e ? xe("category-active", r) : r, lt = (e, o, r) => {
  if (e.current) {
    const a = e.current;
    r ? a == null || a.set(o, r) : a == null || a.delete(o);
  }
}, fe = (e, o) => {
  [...e.current.values()][o].focus();
}, H0 = (e) => e.offsetX > e.target.clientWidth || e.offsetY > e.target.clientHeight, Db = ({
  children: e,
  id: o,
  linkAs: r,
  variant: a = "desktop",
  ...n
}) => {
  const i = `gravity-nav-${o || Wt()}`, s = ae({ base: !0, md: !1 }, { fallback: "md" }) ? "mobile" : a, { isOpen: d, onClose: g, onOpen: p } = We(), u = D("GlobalNavv2", { variant: s }), [b, f] = V([]), [c, m] = V(
    P0
  ), x = pe(to), y = le(), v = le(/* @__PURE__ */ new Map()), S = le(/* @__PURE__ */ new Map()), C = E(() => ie(e), [e]);
  oe(() => {
    m({ ...c, focusOnTab: !0 });
  }, []), oe(() => {
    c.openCategory !== "" && b.length > 0 && c.focusItem === -1 && m({ ...c, focusItem: 0 });
  }, [c.openCategory, b]), oe(() => {
    c.focusItem > -1 && fe(S, c.focusItem);
  }, [c.focusItem]), oe(() => {
    c.focusCategory > -1 && c.focusOnTab && fe(v, c.focusCategory);
  }, [c.focusCategory]);
  const M = Z(() => {
    x && x.onMobileMenuClose();
  }, [x]);
  Lo({
    ref: y,
    handler: (w) => {
      d && s !== "mobile" && !H0(w) && (g(), m({ ...c, openCategory: "", focusItem: -1 }));
    }
  });
  const _ = Z(
    (w, F) => {
      s === "desktop" && f(F), F.length > 0 ? s === "mobile" && c.openCategory === w.currentTarget.id ? (m({ ...c, openCategory: "" }), g()) : (m({ ...c, openCategory: w.currentTarget.id }), p()) : F.length === 0 && (w.currentTarget.target || (m({
        ...c,
        activeCategory: w.currentTarget.id,
        openCategory: "",
        activeItem: ""
      }), M()), d && (g(), M()));
    },
    [c]
  ), G = Z(
    (w) => {
      const F = new RegExp(`${i}__cat[0-9]+`), W = w.currentTarget.id.match(F), U = { ...c };
      U.openCategory = "", U.focusItem = -1, U.focusCategory = c.focusCategory, w.currentTarget.target || (U.activeCategory = W == null ? void 0 : W[0], U.activeItem = w.currentTarget.id), s === "mobile" ? setTimeout(() => {
        g(), M(), fe(v, c.focusCategory), m(U);
      }, 100) : (g(), M(), setTimeout(() => {
        fe(v, c.focusCategory);
      }, 100), m(U));
    },
    [c]
  ), j = Z(
    (w, F) => {
      if (w.key === "Enter")
        _(w, F);
      else if (w.key === "Tab")
        s !== "mobile" && (g(), m({ ...c, openCategory: "", focusItem: -1 }));
      else {
        if (w.preventDefault(), w.key === "ArrowDown" && (c.focusCategory < C.length - 1 ? s === "mobile" && c.openCategory === w.currentTarget.id ? m({
          ...c,
          focusItem: 0
        }) : m({
          ...c,
          focusCategory: c.focusCategory + 1
        }) : c.focusCategory >= C.length - 1 && (s === "mobile" && c.openCategory === w.currentTarget.id ? m({
          ...c,
          focusItem: 0
        }) : m({ ...c, focusCategory: 0 }))), w.key === "ArrowUp")
          if (c.focusCategory > 0) {
            const W = new RegExp(`${i}__cat([0-9]+)`), U = c.openCategory.match(W);
            s === "mobile" && U !== null && c.focusCategory === parseInt(U[1]) + 1 ? m({
              ...c,
              focusCategory: c.focusCategory - 1,
              focusItem: S.current.size - 1
            }) : m({
              ...c,
              focusCategory: c.focusCategory - 1
            });
          } else
            c.focusCategory <= 0 && m({ ...c, focusCategory: C.length - 1 });
        w.key === "ArrowRight" && s !== "mobile" && d && m({ ...c, focusItem: 0 }), w.key === "Escape" && s !== "mobile" && d && (g(), m({ ...c, focusItem: -1 }));
      }
    },
    [c]
  ), L = Z(
    (w) => {
      w.key === "Enter" ? G(w) : w.key === "Tab" ? s !== "mobile" && (w.shiftKey || g(), m({ ...c, focusItem: -1 })) : (w.preventDefault(), w.key === "ArrowDown" && (c.focusItem < S.current.size - 1 ? m({ ...c, focusItem: c.focusItem + 1 }) : c.focusItem === S.current.size - 1 && m(s === "mobile" ? {
        ...c,
        focusCategory: c.focusCategory + 1 < v.current.size ? c.focusCategory + 1 : 0,
        focusItem: -1
      } : { ...c, focusItem: 0 })), w.key === "ArrowUp" && (c.focusItem > 0 ? m({ ...c, focusItem: c.focusItem - 1 }) : c.focusItem === 0 && (s === "mobile" ? (fe(v, c.focusCategory), m({ ...c, focusItem: -1 })) : m({ ...c, focusItem: S.current.size - 1 }))), w.key === "ArrowLeft" && s !== "mobile" && (m({ ...c, focusItem: -1 }), fe(v, c.focusCategory)), w.key === "Escape" && s !== "mobile" && d && (g(), fe(v, c.focusCategory), m({ ...c, focusItem: -1 })));
    },
    [c]
  );
  return /* @__PURE__ */ t(
    wr.Provider,
    {
      value: {
        categoryRefs: v,
        globalNavState: c,
        handleCategoryKeyDown: j,
        handleCategorySelect: _,
        handleItemKeyDown: L,
        handleItemSelect: G,
        itemRefs: S,
        isOpen: d,
        linkAs: r,
        rootId: i,
        setMenuItems: f,
        variant: s
      },
      children: /* @__PURE__ */ h(T, { as: "nav", ref: y, id: i, __css: u.container, ...n, children: [
        /* @__PURE__ */ t(
          T,
          {
            id: `${i}__categories`,
            role: "menubar",
            "aria-label": "Site navigation",
            "aria-orientation": "vertical",
            __css: u.menubar,
            children: C.length > 0 && C.map((w, F) => re(w, {
              index: F
            }))
          }
        ),
        s === "desktop" && /* @__PURE__ */ t(kr, { category: c.openCategory, children: b })
      ] })
    }
  );
}, _b = ({
  icon: e,
  label: o,
  as: r,
  children: a,
  className: n,
  href: i,
  index: l,
  isExternal: s = !1,
  ...d
}) => {
  const {
    categoryRefs: g,
    globalNavState: p,
    handleCategoryKeyDown: u,
    handleCategorySelect: b,
    isOpen: f,
    linkAs: c,
    rootId: m,
    variant: x
  } = mt(), y = D("GlobalNavv2", { variant: x }), v = `${m}__cat${l}`, S = Z(
    (L) => {
      lt(g, v, L);
    },
    [lt, v]
  ), C = E(
    () => v === p.activeCategory,
    [v, p.activeCategory]
  ), M = E(
    () => !!(v === p.openCategory && f),
    [v, p.openCategory, f]
  ), _ = E(() => ie(a).map((w, F) => re(w, {
    index: F,
    id: v
  })), [a]), G = Z(
    (L) => {
      b(L, _);
    },
    [b, _]
  ), j = Z(
    (L) => {
      u(L, _);
    },
    [u, _]
  );
  return /* @__PURE__ */ h(Q, { children: [
    /* @__PURE__ */ h(
      we,
      {
        ref: S,
        id: v,
        role: "menuitem",
        as: c || r,
        href: i,
        to: i,
        sx: y.category,
        onClick: G,
        onKeyDown: j,
        tabIndex: p.focusCategory === l ? 0 : -1,
        className: R0(C, M, n),
        ..._.length > 0 && { "aria-expanded": !!M },
        ..._.length > 0 && { "aria-haspopup": !0 },
        isExternal: s,
        ...C && p.activeItem === "" && { "aria-current": "page" },
        ...C && p.activeItem !== "" && { title: "Contains current page" },
        ...d,
        children: [
          /* @__PURE__ */ t(rt, { children: e }),
          /* @__PURE__ */ t(z, { as: "span", children: o }),
          x === "mobile" && _.length > 0 && /* @__PURE__ */ t(T, { flex: 1, justifyContent: "right", children: M ? /* @__PURE__ */ t(Yt, { variant: "light" }) : /* @__PURE__ */ t(Ie, { variant: "light" }) })
        ]
      }
    ),
    x === "mobile" && M && /* @__PURE__ */ t(I, { paddingY: 2, id: `${v}-panel`, "aria-labelledby": v, role: "menu", children: _ })
  ] });
}, Ab = ({
  label: e,
  children: o,
  id: r,
  index: a,
  ...n
}) => {
  const { variant: i } = mt(), l = D("GlobalNavv2", { variant: i }), s = `${r}-gr${a}`, d = E(() => ie(o).map((p, u) => re(p, {
    index: u,
    id: s
  })), [o]);
  return /* @__PURE__ */ h(T, { sx: l.group, role: "group", id: s, "aria-labelledby": `${s}-label`, ...n, children: [
    /* @__PURE__ */ t(z, { id: `${s}-label`, children: e }),
    /* @__PURE__ */ t(I, { children: d })
  ] });
}, Lb = ({
  label: e,
  as: o,
  href: r,
  id: a,
  index: n,
  isDisabled: i = !1,
  isExternal: l = !1,
  ...s
}) => {
  const { globalNavState: d, handleItemKeyDown: g, handleItemSelect: p, itemRefs: u, linkAs: b, variant: f } = mt(), c = `${a}-i${n}`, m = D("GlobalNavv2", { variant: f }), x = E(
    () => c === d.activeItem,
    [c, d.activeItem]
  ), y = Z(
    (C) => {
      lt(u, c, C);
    },
    [lt, c, u]
  ), v = Z(
    (C) => {
      i ? C.preventDefault() : p(C);
    },
    [i, p]
  ), S = Z(
    (C) => {
      i && C.key === "Enter" ? C.preventDefault() : g(C);
    },
    [i, g]
  );
  return /* @__PURE__ */ h(
    we,
    {
      ref: y,
      role: "menuitem",
      sx: m.menuItem,
      id: c,
      isExternal: l,
      onKeyDown: S,
      onClick: v,
      href: r,
      to: r,
      as: b || o,
      ...i && { "aria-disabled": !0 },
      ...x && { "aria-current": "page" },
      tabIndex: -1,
      ...s,
      children: [
        /* @__PURE__ */ t(z, { as: "span", children: e }),
        l && /* @__PURE__ */ t(Pu, { variant: "light", size: "sm" })
      ]
    }
  );
};
function xo(e) {
  return e / 1024;
}
function E0(e) {
  return e / 1024 ** 2;
}
function Ir(e) {
  return !e || e < 0 ? "" : e < 10 ? `${e} bytes` : e < 900 ? `${xo(e).toFixed(2)} KB` : e < 1024 ** 2 ? `${xo(e).toFixed(0)} KB` : `${E0(e).toFixed(0)} MB`;
}
function F0(e, o) {
  return o ? "error" : e === 0 ? "pending" : e >= 100 ? "success" : "uploading";
}
function j0(e) {
  switch (e) {
    case "success":
      return "Upload complete.";
    case "pending":
      return "Pending...";
    default:
      return "Uploading...";
  }
}
const O0 = ({
  name: e,
  onAddFiles: o,
  // 1 for MIME Types and 1 for displaying, [filetypes].join(' / ')
  acceptedFileTypes: r,
  allowMultiple: a = !1,
  "data-testid": n,
  error: i,
  fileTypesList: l = [],
  id: s,
  isDisabled: d,
  isReadOnly: g,
  isRequired: p,
  maxFileSize: u,
  ...b
}) => {
  const { getInputProps: f, getRootProps: c, isDragActive: m } = Ml({
    accept: r,
    multiple: a,
    maxSize: u,
    onDropAccepted: (y) => {
      o(
        y.map((v) => ({
          file: v,
          progressPercentage: 0
        }))
      );
    },
    onDropRejected: (y) => {
      o(
        y.map((v) => ({
          file: v.file,
          progressPercentage: 0,
          error: v.errors.map((S) => S.message).join(". ")
        }))
      );
    },
    disabled: !!d
  }), x = D("FileUpload");
  return /* @__PURE__ */ h(
    Ze,
    {
      __css: x.dropzone,
      ...b,
      ...c(),
      ...m && { "data-dragActive": !0 },
      ...i && { "data-invalid": !0 },
      ...d && { disabled: !0 },
      children: [
        /* @__PURE__ */ t(
          "input",
          {
            id: s,
            name: e,
            "data-testid": n,
            ...d && { disabled: !0 },
            ...g && { readOnly: !0 },
            ...p && { required: !0, "aria-required": !0 },
            ...i && { "data-invalid": !0 },
            ...f()
          }
        ),
        /* @__PURE__ */ h(O, { spacing: 4, children: [
          /* @__PURE__ */ t(Ou, { variant: "light", size: "4xl" }),
          /* @__PURE__ */ t(z, { variant: "body", children: "Drag and drop files here" }),
          /* @__PURE__ */ t(z, { variant: "body", children: "OR" }),
          /* @__PURE__ */ t(
            ee,
            {
              id: `${s}-browse`,
              name: `${e}-browse`,
              "data-testid": n && `${n}-browse`,
              variant: "tertiary",
              isDisabled: d,
              children: "Browse"
            }
          ),
          (l.length > 0 || u) && /* @__PURE__ */ h(O, { spacing: 0, children: [
            l.length > 0 && /* @__PURE__ */ h(z, { variant: "bodySmall", type: "secondary", children: [
              "File type(s): ",
              l.join(" / ")
            ] }),
            u && /* @__PURE__ */ h(z, { variant: "bodySmall", type: "secondary", children: [
              "File size limit: ",
              Ir(u)
            ] })
          ] })
        ] })
      ]
    }
  );
}, W0 = ({
  fileName: e,
  progressPercentage: o,
  status: r,
  "data-testid": a,
  id: n
}) => /* @__PURE__ */ t(
  rr,
  {
    size: "sm",
    "aria-label": `Upload progress for ${e}`,
    value: o,
    id: n && `${n}-progress`,
    "data-testid": a && `${a}-progress`,
    variant: r === "error" ? "error" : "normal",
    mb: 2
  }
), G0 = ({ status: e, error: o }) => o ? /* @__PURE__ */ t(Jo, { children: o }) : /* @__PURE__ */ t(
  z,
  {
    variant: "bodySmall",
    ...e === "success" ? { color: "green.500" } : { type: "secondary" },
    children: j0(e)
  }
), U0 = ({
  file: e,
  progressPercentage: o,
  status: r,
  "data-testid": a,
  error: n,
  id: i
}) => /* @__PURE__ */ h(Q, { children: [
  /* @__PURE__ */ t(
    W0,
    {
      id: i,
      "data-testid": a,
      fileName: `${e.name}`,
      progressPercentage: o,
      status: r
    }
  ),
  /* @__PURE__ */ t(G0, { error: n, status: r })
] }), V0 = ({
  file: e,
  progressPercentage: o,
  abort: r,
  "data-testid": a,
  error: n,
  hideActionButton: i = !1,
  id: l,
  name: s,
  onRemoveFile: d
}) => {
  const g = D("FileUpload"), p = E(() => F0(o, n), [o, n]), [u, b] = V(!0);
  return oe(() => {
    let f;
    return p === "success" ? f = window.setTimeout(() => b(!1), 3e3) : b(!0), () => {
      f && clearTimeout(f);
    };
  }, [p]), /* @__PURE__ */ h(T, { sx: g.listitem, id: l, "data-testid": a, children: [
    /* @__PURE__ */ h(O, { flex: 1, align: "stretch", spacing: 2, children: [
      /* @__PURE__ */ h(ue, { spacing: 2, children: [
        /* @__PURE__ */ t(Ku, { variant: "light", size: "md" }),
        /* @__PURE__ */ t(z, { noOfLines: 1, variant: "bodySmall", as: "span", children: e.name }),
        /* @__PURE__ */ h(z, { color: "gray.600", variant: "bodySmall", as: "span", whiteSpace: "nowrap", children: [
          "(",
          Ir(e.size),
          ")"
        ] })
      ] }),
      /* @__PURE__ */ t(Cn, { in: u, animateOpacity: !0, children: /* @__PURE__ */ t(
        U0,
        {
          id: l,
          "data-testid": a,
          file: e,
          progressPercentage: o,
          status: p,
          error: n
        }
      ) })
    ] }),
    d && !i && /* @__PURE__ */ t(Ze, { children: /* @__PURE__ */ t(
      ee,
      {
        id: l && `${l}-action`,
        name: s && `${s}-action`,
        "data-testid": a && `${a}-action`,
        variant: "tertiary",
        onClick: () => {
          d(e), p === "uploading" && (r == null || r());
        },
        ...p === "success" && { isDestructive: !0 },
        children: p === "success" ? "Delete" : "Cancel"
      }
    ) })
  ] });
}, vo = ({ ...e }) => /* @__PURE__ */ t(
  ee,
  {
    size: "md",
    variant: "secondary",
    rightIcon: /* @__PURE__ */ t(Bu, { size: "md", variant: "light" }),
    ...e,
    children: "Upload All"
  }
), Y0 = ({
  "data-testid": e,
  files: o = [],
  hideFileActionButtons: r,
  hideUploadAllButton: a,
  id: n,
  name: i,
  onRemoveFile: l,
  onUploadAllClick: s
}) => {
  let d = { above: !0, below: !0 };
  return typeof a == "boolean" && a === !1 ? d = { ...d, below: !1 } : typeof a == "object" && (d = a), /* @__PURE__ */ h(O, { spacing: 4, alignItems: "start", children: [
    !d.above && /* @__PURE__ */ t(
      vo,
      {
        id: n && `${n}-uploadall-above`,
        name: i && `${i}-uploadall-above`,
        "data-testid": e && `${e}-uploadall-above`,
        onClick: s
      }
    ),
    /* @__PURE__ */ t(O, { spacing: 0, align: "stretch", width: "100%", children: o.map((g, p) => /* @__PURE__ */ t(
      V0,
      {
        onRemoveFile: l,
        ...g,
        id: n && `${n}-file${p}`,
        name: i && `${i}-file${p}`,
        "data-testid": e && `${e}-file${p}`,
        ...r && { hideActionButton: !0 }
      },
      g.key ?? g.file.name
    )) }),
    !d.below && /* @__PURE__ */ t(
      vo,
      {
        id: n && `${n}-uploadall-below`,
        name: i && `${i}-uploadall-below`,
        "data-testid": e && `${e}-uploadall-below`,
        onClick: s
      }
    )
  ] });
}, Tb = ({
  name: e,
  onRemoveFile: o,
  controlClassName: r,
  controlStyleProps: a,
  "data-testid": n,
  error: i,
  files: l = [],
  formHelperText: s,
  hideFileActionButtons: d = !1,
  hideOptionalLabel: g = !1,
  hideUploadAllButton: p = { above: !0, below: !0 },
  id: u = e,
  isDisabled: b,
  isReadOnly: f,
  isRequired: c,
  label: m,
  onUploadAllClick: x,
  ...y
}) => {
  const v = D("FileUpload");
  return /* @__PURE__ */ h(Et, { spacing: 4, __css: v.container, children: [
    /* @__PURE__ */ t(
      X,
      {
        name: e,
        hideOptionalLabel: g,
        id: u,
        error: i,
        label: m,
        isDisabled: b,
        isReadOnly: f,
        isRequired: c,
        formHelperText: s,
        "data-testid": n && `${n}-control`,
        className: r,
        ...a,
        children: /* @__PURE__ */ t(
          O0,
          {
            name: e,
            id: u,
            isDisabled: b,
            isReadOnly: f,
            isRequired: c,
            "data-testid": n,
            error: i,
            ...y
          }
        )
      }
    ),
    l.length > 0 && /* @__PURE__ */ t(
      Y0,
      {
        id: u,
        name: e,
        "data-testid": n,
        onRemoveFile: o,
        files: l,
        hideFileActionButtons: d,
        onUploadAllClick: x,
        hideUploadAllButton: p
      }
    )
  ] });
};
export {
  Jm as Accordion,
  Qe as Alert,
  vb as AlertDialog,
  $g as AutoSuggestion,
  Jt as Avatar,
  Vt as Badge,
  Qg as BooleanCheckbox,
  bb as Breadcrumb,
  ee as Button,
  Lu as ButtonGroup,
  Fg as CCCvcInput,
  jg as CCExpiryInput,
  Wg as CCNumberInput,
  Og as CCType,
  Qm as Card,
  Zg as Checkbox,
  Vg as CheckboxGroup,
  dr as CheckboxGroupContext,
  Km as CloseButton,
  eg as ColumnToggle,
  Gg as CurrencyInput,
  ir as DateInput,
  Tg as DatePicker,
  ub as DualInput,
  Kg as DualInputv2,
  ab as ErrorAlert,
  Jo as ErrorMessage,
  P as FAIcon,
  Tb as FileUpload,
  wb as Footer,
  X as FormControl,
  hb as GlobalHeader,
  fb as GlobalHeaderv2,
  to as GlobalHeaderv2DevContext,
  kb as GlobalNav,
  Ib as GlobalNavCategory,
  $b as GlobalNavMenu,
  Mb as GlobalNavMenuItem,
  Nb as GlobalNavSubMenu,
  zb as GlobalNavSubMenuItem,
  Db as GlobalNavv2,
  _b as GlobalNavv2Category,
  Ab as GlobalNavv2MenuGroup,
  Lb as GlobalNavv2MenuItem,
  K as IconButton,
  tb as InfoAlert,
  dt as Input,
  ye as Link,
  nb as LoadingIndicator,
  zu as Logo,
  br as Menu,
  yr as MenuButton,
  mb as MenuDivider,
  pb as MenuGroup,
  hr as MenuItem,
  fr as MenuList,
  Cb as Modal,
  Xg as NumberInput,
  yb as PageHeader,
  a0 as PasswordInput,
  Ug as PhoneInput,
  Sb as Popover,
  rr as Progress,
  l0 as Radio,
  n0 as RadioGroup,
  pr as RadioGroupContext,
  ut as ResponseError,
  lb as ResponseErrorBadGateway,
  ib as ResponseErrorInternalServer,
  sb as ResponseErrorNotFound,
  cb as ResponseErrorUnauthorized,
  or as SearchInput,
  s0 as Select,
  _u as SgiCanadaLogo,
  Wo as SgiLogo,
  Ju as Skeleton,
  gb as Slider,
  z0 as StepDetails,
  xb as Steps,
  rb as SuccessAlert,
  nr as Suggestion,
  Kt as Switch,
  Xm as Table,
  ng as TableContainer,
  tg as TableEmptyState,
  ug as TableHeader,
  yg as TablePagination,
  eb as Tabs,
  qm as Tag,
  xg as Tbody,
  tt as Td,
  d0 as TextArea,
  tr as Th,
  vg as Thead,
  Um as ThemeProvider,
  Eg as TimeInput,
  eo as Tooltip,
  je as Tr,
  z as Typography,
  ob as WarningAlert,
  Cg as tableIdPrefix,
  Zm as theme,
  vr as useGlobalHeaderv2DevContext,
  db as useToast
};
